{
  "settings": {
    "calendar": {
      "calendar_settings": "Kalendereinstellungen",
      "settings": "Einstellungen",
      "select_calendar_type": "Kalendertyp auswählen",
      "add_new_calendar_group": "Neue Kalendergruppe hinzufügen",
      "add_new_equipment": "Neue Geräte hinzufügen",
      "new_calendar": "Neuer Kalender",
      "calendar_group_description": "Verwende Kalendergruppen, um mehrere Kalender effektiv zu organisieren und zu gruppieren.",
      "group": "Gruppe",
      "manage_your_calendars_and_groups": "Verwalte deine Kalender und Gruppen",
      "groups": "Gruppen",
      "create_group": "Gruppe erstellen",
      "create_calendar": "Kalender erstellen",
      "calendar_name": "Kalendername",
      "group_duration": "Gruppendauer",
      "calendar_type": "eintippen",
      "action": "Aktion",
      "round_robin": "Wechselnde Zuweisung",
      "event": "Veranstaltung",
      "group_name": "Gruppenname",
      "room_name": "Raumname",
      "group_description": "Gruppenbeschreibung",
      "calendar_url": "Kalender-URL",
      "calendars": "Kalender",
      "date_updated": "Tag aktualisiert",
      "status": "Status",
      "action_dropdown": "Dropdown „Aktion“",
      "calendar_list": "Services im Zusammenhang mit",
      "edit": "Bearbeiten",
      "duplicate": "Duplikat",
      "copy_embed_code": "Einbettungscode kopieren",
      "copy_permanent_link": "Permanentlink kopieren",
      "copy_new_slug_link": "Link zur Terminplanung kopieren",
      "copy_scheduling_link": "Planungslink kopieren (veraltete Version)",
      "deactivate_calendar": "Kalender deaktivieren",
      "move_to_group": "In Gruppe verschieben",
      "delete_calendar": "Kalender löschen",
      "delete_group": "Löschen",
      "delete_this_group": "Diese Gruppe löschen",
      "activate_calendar": "Kalender aktivieren",
      "duration": "Dauer",
      "all": "Alle",
      "draft": "Entwurf",
      "inactive": "Inaktiv",
      "active": "Aktiv",
      "actions": "Aktivitäten",
      "rearrange_calendars": "Kalender neu anordnen",
      "deactivate_all_calendars_in_group": "Alle Kalender in der Gruppe deaktivieren",
      "activate_all_calendars_in_group": "Alle Kalender in der Gruppe aktivieren",
      "no_groups_found": "Deine Suche stimmt mit keiner Kalendergruppe überein.",
      "no_groups_in_location": "Gruppe Sortieren Sie Ihre Kalender wie Ordner. Kalender zu einer Gruppe hinzufügen und eine Einzelperson teilen Link zur Terminplanung, damit Booker Von mehreren Kalendern auswählt.",
      "no_calendars_found": "Beginne mit der Verwendung des Kalenders, indem du einen neuen Kalender erstellst.",
      "no_calendars_found_search": "Deine Suche hat mit keinem Kalender übereingestimmt.",
      "delete_calendar_message": "Sie sind dabei, den Kalender zu löschen. Wenn Sie auf „Löschen“ klicken, werden auch alle Termine gelöscht.",
      "delete_calendar_message_title": "Diesen Kalender löschen?",
      "duplicate_calendar_message": "Du bist dabei, den Kalender zu duplizieren. Dadurch wird ein neuer Kalender mit den gleichen Einstellungen wie der ausgewählte Kalender erstellt.",
      "duplicate_calendar_message_title": "Diesen Kalender duplizieren?",
      "no_calendars_found_title": "Kein Kalender gefunden",
      "no_groups_in_location_title": "Keine Gruppen gefunden",
      "delete_group_confirmation_title": "Möchten Sie diese Gruppe löschen?",
      "delete_group_confirmation": "Möchtest du die ausgewählte Gruppe wirklich löschen?",
      "delete_group_confirmation_checkbox_title": "Verknüpfte Kalender und Termine löschen",
      "delete_group_confirmation_checkbox_description": "Wenn du diese Option wählst, werden auch die Kalender in dieser Gruppe sowie alle Termine in diesen Kalendern gelöscht.",
      "group_status_message_title": "{status} Gruppe & alle zugehörigen Kalender?",
      "calendar_status_message_title": "{status} diesen Kalender?",
      "calendar_status_message": "Du bist kurz vor dem {status} -Kalender.",
      "group_status_active_message": "Sind Sie sicher, dass Sie diese Gruppe aktivieren möchten? Alle Kalender in der Gruppe werden ebenfalls aktiviert und sind zur Buchung verfügbar.",
      "group_status_inactive_message": "Möchten Sie diese Gruppe wirklich deaktivieren? Alle Kalender innerhalb der Gruppe werden ebenfalls deaktiviert und stehen zur Buchung zur Verfügung.",
      "coming_soon": "Demnächst verfügbar",
      "select": "Auswählen",
      "15mins": "15 Minuten",
      "cancel": "Absagen",
      "save": "Speichern",
      "create": "Erstellen",
      "select_calendar_group": "Kalendergruppe auswählen",
      "move_calendar_confirmation": "Der Legacy-Link wird nicht mehr funktionieren, sobald Sie diese Änderung vornehmen. Bestätigen Sie, indem Sie das Kontrollkästchen auswählen.",
      "previously_called_unassigned": " (Zuvor als nicht zugewiesen bezeichnet)",
      "scheduling_type": "Kalendertyp auswählen",
      "scheduling_type_description": "Auswählen einen Kalendertyp, um deinen Kalender zu konfigurieren und festzulegen, wie Termine Geplant sind.",
      "service_menu_name": "Name des Servicemenüs",
      "template": "Vorlage",
      "select_template": "Vorlage auswählen",
      "group_url": "Gruppen-URL",
      "template_description": "Du hast jetzt die Wahl zwischen den Vorlagen Klassisch oder Neo für die Gruppenansicht.",
      "rooms": "Räume",
      "rooms_name": "Name",
      "rooms_description": "Beschreibung",
      "rooms_modal_description": "Raum hinzufügen oder bearbeiten.",
      "rooms_capacity": "Gesamtkapazität",
      "no_rooms_in_location_title": "Keine Räume gefunden",
      "no_rooms_in_location": "An diesem Ort wurden keine Räume gefunden",
      "no_equipments_in_location": "An diesem Standort wurden keine Geräte gefunden",
      "equipments": "Geräte",
      "equipment_name": "Name",
      "equipment_name_search": "Gerätename",
      "equipment_description": "Beschreibung",
      "equipment_modal_description": "Ein Gerät hinzufügen oder bearbeiten.",
      "add_equipment": "Gerät hinzufügen/bearbeiten",
      "add_room": "Raum hinzufügen/bearbeiten",
      "equipment_quantity": "Gesamtzahl",
      "equipment_outOfService": "Außer Betrieb befindliche Anzahl",
      "no_equipments_in_location_title": "Keine Geräte gefunden",
      "delete_this_equipment": "Dieses Gerät löschen",
      "delete_this_rooms": "Diesen Raum löschen",
      "delete_equipment_confirmation": "Bist du sicher, dass du dieses Gerät löschen willst? Dies wird auch aus allen verknüpften Kalendern entfernt.",
      "delete_rooms_confirmation": "Bist du sicher, dass du diesen Raum löschen willst? Dieser wird auch aus allen verknüpften Kalendern entfernt.",
      "add_new_calendar_equipments": "Neues Gerät hinzufügen",
      "no_equipments_found": "Deine Suche hat mit keinem Gerät übereingestimmt.",
      "no_rooms_found": "Deine Suche hat mit keinem Raum übereingestimmt.",
      "add_new_calendar_rooms": "Neuen Raum hinzufügen",
      "rooms_disable": "Raum deaktivieren",
      "equipments_disable": "Ausrüstung deaktivieren",
      "equipments_activate": "Ausrüstung aktivieren",
      "rooms_activate": "Raum aktivieren",
      "create_equipments": "Ausrüstung erstellen",
      "create_rooms": "Raum erstellen",
      "select_calendar_rooms_title": "Kalender auswählen",
      "select_calendar_rooms_description": "Du kannst mehrere Kalender auswählen, um sie mit Räumen zu verknüpfen.",
      "select_calendar_equipments_title": "Kalender auswählen",
      "select_calendar_equipments_description": "Du kannst einen Kalender auswählen, der dem Gerät zugeordnet werden soll.",
      "disable_equipment_title": "Gerät {status}",
      "disable_room_title": "Raum {status}",
      "equipments_status_message": "Sind Sie sicher, dass Sie diese Ausrüstung {status} möchten?",
      "rooms_status_message": "Sind Sie sicher, dass Sie diesen Raum {status} möchten?",
      "calendar_resource_disclaimer": "Dies könnte die Verfügbarkeit in den zugehörigen Servicekalendern beeinflussen.",
      "equipment_disclaimer": "Hinweis: Wenn du das Gerät später aktivierst, wird es automatisch wieder mit den Kalendern verbunden, mit denen es verknüpft ist",
      "room_disclaimer": "Hinweis: Wenn du den Raum später aktivierst, wird er automatisch wieder mit den Kalendern verbunden, mit denen er verknüpft ist",
      "equipment_tab_name": "Geräte",
      "rooms_tab_name": "Räume",
      "manage_your_rooms": "Verwalte hier Räume für dein Unternehmen",
      "manage_your_equipments": "Verwalte hier Geräte für dein Unternehmen",
      "select_service_calendar_description_equipments": "Du kannst mehrere Servicekalender auswählen, die mit Geräten verknüpft werden sollen.",
      "select_service_calendar_description_rooms": "Du kannst mehrere Servicekalender auswählen, die mit Räumen verknüpft werden sollen.",
      "service_menus": "Servicemenü",
      "manage_your_calendars_groups_and_service_menus": "Verwalte deine Kalender, Gruppen und dein Servicemenü",
      "new_service_menu": "Servicemenü erstellen",
      "deactivate_service_menu": "Servicemenü deaktivieren",
      "delete_service_menu": "Dieses Servicemenü löschen",
      "delete_service_menu_confirmation": "Möchtest du dieses Servicemenü wirklich löschen?",
      "service_menu_status_message_title": "Dieses Servicemenü {status}?",
      "service_menu_status_message": "Sie sind im Begriff, das Servicemenü zu {status}.",
      "no_service_menus_in_location_title": "Erstellen Sie Ihr individuelles Servicemenü",
      "add_new_service_menu": "Neues Servicemenü hinzufügen",
      "no_service_menus_in_location": "Erstelle zunächst ein neues Servicemenü und füge Gruppen hinzu",
      "no_service_menu_found": "Kein Servicemenü gefunden",
      "no_service_menu_found_desc": "Deine Suche hat mit keinem Servicemenü übereingestimmt.",
      "apply": "Anwenden",
      "troubleshoot_calendar": "Problembehandlung für Kalender",
      "round_robin_booking": "Wechselnde Zuweisung",
      "round_robin_description": "Verteilt Termine in rotierender Reihenfolge auf die Teammitglieder.",
      "round_robin_example": "Z. B.: Verkaufsgespräche, Onboarding-Sitzungen.",
      "unassigned_booking": "Event-Kalender",
      "unassigned_description": "Für die Planung von physischen Veranstaltungen ohne Zuordnung zu einem Gastgeber.",
      "unassigned_example": "Z. B.: Konferenzen, öffentliche Seminare, Messen.",
      "event_booking_alert_title": "Wichtig",
      "event_booking_alert_message": "Dieser Kalendertyp hat wesentliche Unterschiede.",
      "event_booking_learn_more": "Mehr erfahren",
      "event_booking_tooltip_title": "Wissenswertes:",
      "event_booking_tooltip_content": "• Event-Kalender haben keine Benutzer, daher können Besprechungen keinem Benutzer zugewiesen werden.\n• Da kein Benutzer zugewiesen ist, werden dynamische Meeting-Link-Tools (Zoom, Google Meet, Microsoft Teams) nicht unterstützt. Um Online-Meetings zu nutzen, kopieren Sie einen statischen Konferenzlink aus einem beliebigen Tool und fügen Sie ihn in den Besprechungsort ein.\n• Da kein Benutzer zugewiesen ist, werden Besprechungen nicht mit dem Kalender eines Benutzers aus den Kalendereinstellungen → Verbindungen synchronisiert. Dort hinzugefügte Konfliktkalender werden nicht berücksichtigt.\n• Besprechungen werden nur mit dem Kalender synchronisiert, der unter „Externe Synchronisierung“ für diesen Kalender ausgewählt wurde.\n• Ereignisse werden nur aus dem ausgewählten externen Kalender abgerufen und dorthin übertragen.\n• Über die externe Synchronisierung kann nur ein Google-Kalender verbunden werden.",
      "class_booking": "Kursbuchung",
      "class_booking_description": "Ein Gastgeber trifft sich mit mehreren Teilnehmern.",
      "class_booking_example": "Z. B.: Webinare, Gruppenschulungen, Online-Kurse.",
      "collective_booking": "Sammelbuchung",
      "collective_booking_description": "Mehrere Gastgeber treffen sich mit einem Teilnehmer.",
      "collective_booking_example": "Z. B. Panelinterviews, Ausschussbewertungen.",
      "service_booking": "Servicebuchung",
      "service_booking_description": "Nahtlose Terminplanung für dienstleistungsorientierte Unternehmen.",
      "service_booking_example": "Z. B.: Spa-Termine, Reparaturdienste, Beratungen.",
      "personal_booking": "Persönliche Buchung",
      "personal_booking_description": "Plant Einzelgespräche mit einem bestimmten Teammitglied.",
      "personal_booking_example": "Z. B.: Kundentreffen, private Beratungen.",
      "personal": "Persönlich",
      "explore_more_types": "Mehr Arten erkunden",
      "no_calendars_added": "Noch keine Kalender – richten Sie einen ein!",
      "no_calendars_added_description": "Erstellen Sie Ihren ersten Kalender, um mühelos mit dem Zeitplan zu beginnen.",
      "no_groups_added": "Noch keine Gruppen – beginnen Sie mit der Organisation!",
      "no_calendars_yet": "Noch keine Kalender",
      "no_groups_yet": "Noch keine Gruppen vorhanden",
      "no_calendars_access": "Noch keine Kalender wurden erstellt. Sobald ein Kalender erstellt wurde, wird er hier angezeigt. Sie haben keinen Zugriff auf die Erstellung eines Kalenders – bitte kontaktieren Sie Ihren Admin Falls erforderlich.",
      "no_groups_access": "Keine Gruppe wurde noch konfiguriert. Sobald eine Gruppe erstellt wurde, wird sie hier angezeigt. Sie haben keinen Zugriff auf die Erstellung einer Gruppe – bitte kontaktieren Sie Ihre Admin Falls erforderlich.",
      "no_groups_added_description": "Verwende Gruppe, um deine Kalender organisiert zu halten. Kalender zu einer Gruppe hinzufügen und eine Einzelperson Gruppe teilen Link zur Terminplanung für Einfach Booking.",
      "group_success_message": "Gruppe wurde erfolgreich erstellt. Sie können jetzt Kalender in diese Gruppe einbeziehen.",
      "choose_calendars": "Kalender auswählen",
      "do_it_later": "Ich werde das später tun",
      "add_calendars_to_group": "Kalender zur Gruppe hinzufügen",
      "select_calendars_to_add": "Bitte Auswählen jeder der Kalender, die Sie in die Gruppe {name}einbeziehen möchten",
      "add_calendars": "Kalender hinzufügen",
      "continue": "Weiter",
      "conflicting_calendars": "Konfliktkalender",
      "conflicting_calendars_description": "Die Nachlauf-Kalender sind bereits Teil von Andere Gruppe. Möchten Sie sie in Ihre Neu Gruppe, <b>{name}</b> verschieben?",
      "group_associated_with": "Derzeit Gruppe",
      "move_calendar_consent": "Ich aktiviere diese Kalender an die Neu Gruppe verschieben.",
      "calendars_moved_successfully": "Jeder der ausgewählten Kalender wurden erfolgreich nach {name} verschoben.",
      "new_group": "Neue Gruppe",
      "back": "Zurück",
      "share_otl": "Teilen Sie Ihre Verfügbarkeit jeder Datum mit einem eindeutigen Link , der ab einem späteren Zeitpunkt eine Buchung läuft und den Zugriff gewährleistet.",
      "copied_to_clipboard": "In die Zwischenablage kopiert",
      "generate_link": "Neuen Link erstellen",
      "generate_link_error": "Es konnte kein einmaliger Link generiert werden. Bitte erneut versuchen",
      "share_schedule_link": " Der Link zur Terminplanung wird über den Slug bestimmt. Ändern Sie den Slug, und der Link zur Terminplanung passt sich automatisch an die Änderung an.",
      "share_permanent_link": "Ideal für Funnel, Website-Weiterleitungen oder Anzeigen: Der permanente Link bleibt konstant derselbe und wird von Slug-Änderungen nicht beeinflusst.",
      "copy": "Kopieren",
      "share_embed_code": "Standort diesen Code in deinem HTML an der Stelle, an der dein {embedType} Widget erscheinen soll.",
      "scheduling_link": "Link zur Terminplanung",
      "permanent_link": "Permanenter Link",
      "one_time_link": "Einmaliger Link",
      "embed_code": "Einbettungscode",
      "loading": "Wird Laden...",
      "share_group": "Gruppe teilen",
      "edit_group": "Gruppe bearbeiten",
      "more_options": "Mehr Optionen",
      "share_calendar": "Kalender teilen",
      "edit_calendar": "Kalender bearbeiten",
      "troubleshoot_calendar_link": "Problembehandlung beim Kalender",
      "calendar_config_success": "Sie haben Ihren persönlichen/Gruppenkalender erfolgreich konfiguriert",
      "close": " Schließen",
      "added_calendars": "Hinzugefügte(r) Kalender",
      "select_calendars": "Kalender auswählen",
      "settings_confirmation": "Um fortfahren zu können, bestätigen Sie bitte diese Dynamisch.",
      "consent_checkbox_title": "Ich verstehe und akzeptiere diese Änderungen.",
      "confirm": "Bestätigen",
      "create_group_access_disabled": "Sie haben keine Autorisierung, um eine Gruppe zu erstellen. Kontaktiere deinen Admin , um den Zugriff zu erfahren.",
      "create_calendar_access_disabled": "Sie haben keine Autorisierung, um einen Kalender zu erstellen. Kontaktiere deinen Admin , um den Zugriff zu erfahren.",
      "preview_booking_widget": "Buchungs-Widget in der Vorschau",
      "share_service_menu": "Servicemenü freigeben",
      "back_message": "Zurück zur Kalenderliste",
      "service_calendars": "Servicekalender",
      "owned_by": "Im Eigentum Via",
      "owned_by_anyone": "Jeder",
      "owned_by_me": "Ich",
      "all_groups": "Alle Gruppen",
      "all_calendars": "Alle Kalender",
      "not_grouped": "Nicht gruppiert",
      "delete_group_desc": "Möchten Sie diese Gruppe wirklich löschen? Dadurch werden auch alle Kalendermitglieder mit dieser Gruppe gelöscht.",
      "calendar_listing_title": "Kalenderübersicht",
      "calendar_group_name": "Kalender/Gruppenname",
      "success": "Erfolg",
      "my_calendar": "Mein Kalender",
      "service_calendar_description": "Nahtlose Terminplanung für Serviceunternehmen."
    },
    "preferences": {
      "preferences": "Einstellungen",
      "my_preferences": "Meine Präferenz",
      "account_preferences": "Kontopräferenz",
      "user_preferences": "Benutzerpräferenzen",
      "set_preferences": "Lege deine Einstellungen für dein Konto fest.",
      "scheduling_options": "Optionen für die Terminplanung",
      "meeting_location": "Besprechungsort",
      "zoom": "Zoom",
      "save_preferences": "Präferenzen speichern",
      "in_app_preferences": "In den App-Einstellungen",
      "set_start_day": "Lege Einstellungen wie den Starttag für die App fest",
      "view_options": "Optionen anzeigen",
      "services": "Dienste",
      "feature_toggle_aria": "Funktionsumschaltung",
      "week_starts_on": "Die Woche beginnt am",
      "sunday": "Sonntag",
      "widget_preferences": "Widget-Einstellungen",
      "set_widget_language": "Einstellungen wie Sprache für Widget festlegen",
      "language_and_region": "Sprache und Region",
      "language": "Sprache",
      "english": "Englisch",
      "time_format": "Zeitformat",
      "time_format_value": "13:30 UHR",
      "monday": "Montag",
      "custom_meeting_location": "Benutzerdefinierter Standort",
      "view_appointments_in_1": "Termine anzeigen in",
      "timezone_uses_details_1": "Wir werden diese Zeitzone verwenden, um die Terminzeiten in der gesamten App und in deinen terminbezogenen E-Mails anzuzeigen – nur für dich. Es hat keine Auswirkungen auf Ihre Verfügbarkeit oder darauf, wie andere bei Ihnen buchen.",
      "business_timezones_1": "Geschäftszeitzone",
      "business_timezones_tooltip_1": "Hinweis: Wenn Sie diese Option wählen, wird sichergestellt, dass Ihre Anzeigepräferenz mit der ausgewählten Unternehmenszeitzone übereinstimmt. Falls sich die Zeitzone des Unternehmens ändert, wird Ihre Zeitzone automatisch angepasst.",
      "recommended_timezones": "Empfohlenen Zeitzonen",
      "all_timezones": "Allen Zeitzonen"
    },
    "availability": {
      "availability": "Verfügbarkeit",
      "my_availability": "Meine Verfügbarkeit",
      "my_availability_and_booking_rules": "Verfügbarkeitszeitplan",
      "my_availability_and_booking_rules_description": "Legen Sie fest, wann Besprechungen entsprechend der Verfügbarkeit des Personals gebucht werden können.",
      "account_availability": "Kontoverfügbarkeit",
      "timezone": "Zeitzone",
      "working_hours": "Arbeitszeiten",
      "set_recurring_hours": "Lege deine wiederkehrenden Arbeitszeiten für Besprechungen fest",
      "select_one": "Eine Option auswählen",
      "sunday": "Sonntag",
      "monday": "Montag",
      "tuesday": "Dienstag",
      "wednesday": "Mittwoch",
      "thursday": "Donnerstag",
      "friday": "Freitag",
      "saturday": "Samstag",
      "widget_preferences": "Widget-Einstellungen",
      "set_widget_language": "Einstellungen wie Sprache für Widget festlegen",
      "language_and_region": "Sprache und Region",
      "language": "Sprache",
      "english": "Englisch",
      "copy_to_all": "Kopie an alle",
      "save_availability": "Verfügbarkeit speichern",
      "add_time": "Zeit hinzufügen",
      "to": "Zu",
      "select_time": "Zeit auswählen",
      "add_user": "Nutzer hinzufügen",
      "accessRestricted": {
        "header": "Eingeschränkter Zugriff",
        "message": "Sie gehören nicht zu diesem Konto. Um Zugriff zu erhalten, fügen Sie sich selbst über Agentureinstellungen > Teams > Teammitglied bearbeiten zu diesem Konto hinzu und ordnen Sie das Konto unter „Rollen & Berechtigungen“ zu.",
        "contact_admin": "Diese Seite ist nur Öffentlich für Administratoren. Bitte kontaktiere deinen Admin, um Hilfe zu erhalten.",
        "button_text": "Gehen Sie zu den Agentureinstellungen."
      },
      "schedule": {
        "edit_schedule": "Zeitplan bearbeiten",
        "schedule_name": "Name des Zeitplans",
        "schedule_name_required": "Der Name des Zeitplans ist erforderlich",
        "timezone": "Zeitzone",
        "timezone_placeholder": "Option auswählen",
        "start_time": "Startzeit",
        "end_time": "Endzeit",
        "add_availability_hour": "Verfügbare Stunde hinzufügen",
        "remove_availability_hour": "Verfügbare Stunde entfernen",
        "unavailable": "Nicht verfügbar",
        "schedule_created": "Zeitplan erfolgreich erstellt",
        "schedule_updated": "Zeitplan erfolgreich aktualisiert",
        "calendars_selected": "{count} Kalender",
        "calendars_selected_multiple": "{count} Kalender",
        "select_users_placeholder": "Nutzer suchen",
        "edit_default_schedule": "Diesen Zeitplan bearbeiten",
        "customize_event_type_schedule": "Zeitplan nur für diesen Kalender anpassen",
        "multi_user_description": "Verfügbarkeit für <b>{count} ausgewählte Benutzer</b> aktualisieren – {calendar}",
        "bulk_edit_warning_banner": "Massedatenbearbeitung aktiviert. Änderungen überschreiben die bestehenden Zeitpläne für alle ausgewählten Benutzer.",
        "bulk_edit_slot_applies_to_all": "Das ausgewählte Zeitfenster wird auf alle ausgewählten Benutzer angewendet.",
        "bulk_edit_slot_applies_to_selected": "Das ausgewählte Zeitfenster wird auf {count} ausgewählte(n) Benutzer angewendet.",
        "bulk_edit_applies_to_all": "Änderungen werden auf alle {count} ausgewählten Benutzer angewendet.",
        "bulk_edit_weekly_hours": "Bulk-Bearbeitung von Wochenstunden",
        "bulk_edit_weekly_hours_title": "Wochenstunden für Massedatenbearbeitung",
        "bulk_edit_weekly_hours_desc": "Dies ersetzt die Wochenstunden für alle unten aufgeführten Benutzer.",
        "edit_now": "Jetzt bearbeiten",
        "bulk_edit": "Massedatenbearbeitung",
        "choose_days_weekly_hours": "Wählen Sie den/die Tag(e) aus, um die Wochenstunden festzulegen",
        "assign_to": "Zuweisen an:",
        "configure_weekly_hours": "Wochenstunden konfigurieren",
        "selected_users": "Ausgewählte Benutzer:",
        "bulk_edit_select_users": "Benutzer für Anwendung auswählen",
        "bulk_edit_select_users_placeholder": "Teammitglieder auswählen …",
        "bulk_edit_select_at_least_one": "Bitte wählen Sie mindestens einen Benutzer aus.",
        "bulk_edit_editing_for": "Bearbeitung für:",
        "bulk_edit_applies_to": "Gilt für:",
        "bulk_edit_user_count": "{count} Benutzer",
        "bulk_edit_users_count": "{count} Benutzer",
        "show_less": "Weniger anzeigen",
        "more": "mehr",
        "confirm_delete": "Löschen bestätigen",
        "confirm": "Bestätigen",
        "delete_user_date_confirm": "Möchten Sie die datumsspezifischen Stunden für <b>{userName}</b> am <b>{date}</b> wirklich löschen?",
        "delete_date_confirm": "Möchten Sie die datumsspezifischen Stunden für alle Benutzer am <b>{date}</b> wirklich löschen?",
        "selected_calendar": "ausgewählter Kalender",
        "edit_schedule_alert": "Hier vorgenommene Aktualisierungen werden angewendet auf",
        "schedule": "Zeitplan",
        "no_availability": "Keine Verfügbarkeit",
        "date_specific_hours_show_more": "mehr",
        "date_specific_hours_show_less": "weniger",
        "date_specific_hours_recurring_meetings_enabled": "Datumsspezifische Stunden können nicht hinzugefügt werden, da dieser Zeitplan mit einem Kalender verknüpft ist, in dem wiederkehrende Meetings aktiviert sind. Um weiterzukommen, deaktivieren Sie bitte wiederkehrende Meetings.",
        "recurring_incompatible_with_date_hours": "Wiederkehrende Besprechungen können nicht aktiviert werden, da der Zeitplan des Benutzers datumsspezifische Stunden enthält, die nicht kompatibel sind.",
        "incompatible_schedule_with_recurring": "{user} Zeitplan enthält datumsspezifische Stunden, die mit wiederkehrenden Meetings nicht kompatibel sind.",
        "incompatible_schedule_with_recurring_calendar": "Der Zeitplan enthält stundenweise Angaben zu bestimmten Daten, die mit wiederkehrenden Besprechungen nicht vereinbar sind.",
        "recurring_meetings_enabled_multi_user": "Wiederkehrende Besprechungen werden nicht unterstützt für Kalender mit mehreren Teammitgliedern oder wenn ein Teammitglied datumsabhängige Stunden zu seinem Zeitplan hinzugefügt hat.",
        "weekdays": "Wochentage, {timeRange}",
        "weekdays_hours_vary": "Wochentage, Öffnungszeiten variieren",
        "weekend": "Wochenende, {timeRange}",
        "weekend_hours_vary": "Wochenende, Öffnungszeiten variieren",
        "days_hours_vary": "{days}, Stunden variieren",
        "date_specific_hours_tab_name": "Datumsspezifische Öffnungszeiten",
        "date_specific_hours": "{count} datumsspezifische Stunden",
        "date_specific_hours_1": "1 datumsspezifische Stunde",
        "weekly_hours": "Wöchentliche Stunden",
        "custom_schedule": "Benutzerdefinierter Zeitplan",
        "select_schedule": "Wählen Sie einen Zeitplan aus",
        "no_schedules_found": "Keine Zeitpläne gefunden",
        "untitled": "Unbenannt",
        "error_updating_schedules": "Fehler beim Aktualisieren von Zeitplänen",
        "daily": "Täglich",
        "weekly": "Wöchentlich",
        "monthly": "Monatlich",
        "custom": "Benutzerdefiniert",
        "this_is_required": "Dies ist erforderlich",
        "search": "Suchen",
        "edit_hours": "Öffnungszeiten bearbeiten",
        "schedule_name_duplicate": "Ein Zeitplan mit diesem Namen existiert bereits",
        "delete_schedule_title": "Zeitplan von '{scheduleName}' löschen?",
        "delete_schedule_description": "Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie fortfahren möchten?",
        "delete_schedule_negative_text": "Abbrechen",
        "delete_schedule_positive_text": "Ja, löschen.",
        "active_on": "Aktiv in",
        "weekly_working_hours": "Wöchentliche Arbeitsstunden",
        "weekly_working_hours_subtext": "Wählen Sie die Tage und Zeiten aus, zu denen Sie arbeiten",
        "copy_availability_hour": "Verfügbarkeit kopieren",
        "mins": "Minuten",
        "hours": "Stunden",
        "save_weekly_hours": "Wochenstunden sichern",
        "save_date_specific_hours": "Datumsspezifische Stunden speichern",
        "update_weekly_hours_for_users": "Wochenstunden für {count} Benutzer aktualisieren",
        "set_date_specific_hours_for_users": "Datumsspezifische Stunden für {count} Benutzer festlegen",
        "set_date_specific_hours_for_user": "Datumsspezifische Stunden festlegen"
      }
    },
    "connections": {
      "connections": "Verbindungen",
      "connect": "verbinden",
      "conferencing": "Konferenzen",
      "my_connections": "Meine Kontakte",
      "account_connections": "Kontoverbindungen",
      "connection_preferences": "Verbindungseinstellungen",
      "manage_calendars_conferencing_channels": "Kalender und Konferenzkanäle verwalten",
      "main_integration_calendar": "Hauptkalender für Integrationen",
      "event_integration_calendar": "Ereignisse, die in einem Systemkalender erstellt werden, an dem du beteiligt bist, werden auch in diesem integrierten Kalender erstellt",
      "2way_sync": "2-Wege-Synchronisierung: Systemereignisse aus Ereignissen erstellen, die im integrierten Hauptkalender gebucht wurden",
      "calendars": "Kalender",
      "google": "Google",
      "outlook": "Outlook",
      "check_for_conflicts": "Auf Konflikte prüfen",
      "choose_accounts_to_connect": "Auswählen, welche Konten du verbinden möchtest",
      "payments": "Zahlungen",
      "stripe": "Stripe",
      "ads": "Anzeigen",
      "local_service_ads": "Lokale Serviceanzeigen",
      "fire_workflow": "Arbeitsablauf-Trigger für Ereignisse auslösen, die per 2-Wege-Synchronisierung gebucht wurden",
      "connect_google_outlook": "Google/Outlook/iCloud-Konto verbinden, um den Hauptkalender auswählen zu können.",
      "execute_automation": "Automatisierung ausführen",
      "save": "Speichern",
      "lsa": "Lokale Serviceanzeigen",
      "no_write_access": "Du hast keinen Schreibzugriff auf diesen Kalender",
      "connection_remove_confirmation": "Du bist dabei, diese Integration zu entfernen",
      "active": "Aktiv",
      "icloud": {
        "title": "iCloud-Integration",
        "description": "Zum Verbinden deines Kontos sind eine Zwei-Faktor-Authentifizierung und ein app-spezifisches Passwort erforderlich.",
        "email": "iCloud E-Mail-Adresse",
        "password": "iCloud Kennwort",
        "connect": "Verbinden",
        "cancel": "Absagen"
      }
    }
  },
  "appointment_modal": {
    "select_a_contact": "Kontakt auswählen",
    "start_time": "Startzeit",
    "unassigned": "Nicht zugewiesen",
    "end_time": "Endzeit",
    "search_by_name_email_phone_or_company": "Suche nach Namen, E-Mail, Telefon oder Firma",
    "add_new": "Neu hinzufügen",
    "pick_from_available_contacts": "Oder aus den verfügbaren Kontakten wählen",
    "book_appointment": "Termin buchen",
    "add_blocked_off_time": "Blockiertes Zeitfenster hinzufügen",
    "recommended_timezones": "Empfohlenen Zeitzonen",
    "all_timezones": "Allen Zeitzonen",
    "calendar": "Kalender",
    "repeat": "Wiederholen",
    "date_and_time": "Datum und Uhrzeit",
    "close": "Schließen",
    "team_member": "Gruppenmitglied",
    "recurring_booking": "Wiederkehrende Buchung",
    "one_slot_booking": "Buchung für ein Zeitfenster",
    "event_type": "Event-Typ",
    "occurrences_booked": "Veranstaltungen werden gebucht",
    "repeats": "Wiederholungen",
    "booking_details": "Buchungsdetails",
    "showing_slots_in_this_timezone": "Zeitfenster in dieser Zeitzone werden angezeigt:",
    "update_contact_tz": "Aktualisieren Sie außerdem die Zeitzone des Kontakts auf",
    "date": "Datum",
    "slot": "Zeitfenster",
    "calendar_default": "Standardkalender",
    "custom": "Benutzerdefiniert",
    "meeting_notes": "(z. B.) Sitzungsnotizen für unseren bevorstehenden Termin",
    "out_of_office": "(z. B.) Für eine Woche nicht im Büro!",
    "standard": "Standard",
    "appointment_title": "Titel des Termins",
    "event_title": "Event-Titel",
    "appt_with_bob": "(z. B.) Termin mit Bernd",
    "vacation": "(z. B.) Urlaub",
    "show_notes": "Anmerkungen anzeigen",
    "hide_notes": "Anmerkungen ausblenden",
    "additional_preferences": "Zusätzliche Präferenzen",
    "meeting_location": "Ort des Meetings",
    "appointment_status": "Terminstatus",
    "appt_description": "Beschreibung des Termins",
    "recurring_details": "Wiederkehrende Details",
    "event_description": "Beschreibung des Ereignisses",
    "in_contact_timezone": "In der Zeitzone des Kontakts",
    "vacation_message": "Urlaub geplant? Auszeit geplant? Blockiere die Zeit in deinem Kalender, um Kunden daran zu hindern, Termine zu buchen (bestehende Termine bleiben weiterhin in deinem Kalender gespeichert).",
    "contact": "Kontakt",
    "delete": "Löschen",
    "cancel": "Absagen",
    "back": "Zurück",
    "pick_available_contacts": "Oder wähle aus den verfügbaren Kontakten",
    "no_contacts_found": "Keine Kontakte gefunden",
    "found": "gefunden",
    "select_one": "Eine Option auswählen",
    "tz_tooltip": "Dies ist nur von Bedeutung, wenn du benutzerdefinierte Werte, wie z. B. termin_start_zeit termin_end_zeit termin_zeitzone usw., in deiner ausgehenden Kommunikation mit deinen Kunden verwendest. Dabei werden die vorgenannten Angaben einfach in die jeweilige Ortszeit umgerechnet.",
    "meeting_location_tooltip": "Der Besprechungsort wird wie im Kalender konfiguriert festgelegt.",
    "appt_meeting_location_tooltip": "Der Benutzer kann den Besprechungsort terminspezifisch festlegen.",
    "gmeet_tooltip": "Bitte stelle sicher, dass das jeweilige Teammitglied einen Google-Kalender als primären Kalender festgelegt hat.",
    "zoom_tooltip": "Bitte stelle sicher, dass das jeweilige Teammitglied Zoom integriert hat.",
    "enter_meeting_location": "Treffpunkt eingeben",
    "save_appointment": "Termin speichern",
    "save_event": "Ereignis speichern",
    "search_contacts": "Suche nach Namen, E-Mail, Telefon oder Firma",
    "recurring_slots": "{recurringSlotsLength}/{count}",
    "custom_timezone": "Benutzerdefinierte Zeitzone",
    "system_timezone": "Systemzeitzone",
    "contact_timezone": "Kontaktzeitzone",
    "account_timezone": "Kontozeitzone",
    "an_error_occurred": "Es ist ein Fehler aufgetreten"
  },
  "popup": {
    "calendar": "Kalender",
    "appointment_owner": "Termin-Eigentümer",
    "source": "Quelle",
    "booked_by": "Gebucht von",
    "view_activity_log": "Aktivitätsprotokoll anzeigen",
    "status": "Status",
    "cancel_appointment": "Termin absagen",
    "cancel_all": "Alle absagen",
    "google_event": "Google-Veranstaltung",
    "outlook_event": "Outlook-Veranstaltung",
    "blocked_slot": "Blockiertes Zeitfenster",
    "appointment": "Termin",
    "confirmed": "Bestätigt",
    "unconfirmed": "Unbestätigt",
    "cancelled": "Abgesagt",
    "showed": "Erschienen",
    "no_show": "Nicht erschienen",
    "invalid": "Ungültig",
    "more": "Mehr",
    "less": "Weniger",
    "edit": "Bearbeiten",
    "reschedule_all": "Alle umbuchen",
    "guests": "Gast/Gäste",
    "guest_count": "Anzahl Gast/Gäste"
  },
  "create_calendar": {
    "calendar_name": "Kalendername",
    "calendar_logo": "Kalenderlogo",
    "select_team_member": "Teammitglieder auswählen",
    "select_single_team_member": "Teammitglied auswählen",
    "eg_outbound_reach": "(z. B.) Ausgehende Reichweite",
    "description": "Beschreibung",
    "amount": "Betrag",
    "description_placeholder": "Beschreibung eingeben",
    "meeting_duration": "Dauer der Besprechung",
    "meeting_location": "Besprechungsort",
    "seats_per_class": "Plätze pro Kurs",
    "group": "Gruppe",
    "custom_url": "Benutzerdefinierte URL",
    "meeting_invite_title": "Titel der Besprechungseinladung",
    "event_color": "Ereignisfarbe",
    "availability_type": "Verfügbarkeitstyp",
    "new_calendar": "Neuer Kalender",
    "add_description": "Beschreibung hinzufügen",
    "remove_description": "Beschreibung entfernen",
    "booking_availability": "Buchungsverfügbarkeit",
    "slug_tooltip": "Passe die URL des Buchungs-Widgets an.",
    "meeting_location_tooltip": "Besprechungs-Links werden in Kalenderereignissen als „Besprechungsort“ angezeigt. Darin können zum Beispiel Zoom-Links für das Ereignis hinzugefügt werden.",
    "advanced_settings": "Erweiterte Einstellungen",
    "show_more_schedule": "Mehr anzeigen",
    "show_more_helper_text": "Um Ihre Unternehmensstunden weiter anzupassen, gehen Sie bitte zu den erweiterten Einstellungen.",
    "reschedule_preference": "Bevorzugte Terminverschiebung",
    "reschedule_preference_subtext": "Falls ein {contactLabel} einen Termin verschiebt:",
    "reassign_through_round_robin": "Neuzuweisung durch Round Robin",
    "keep_same_assinged_user": "Den gleichen Termin-Owner beibehalten",
    "new_appointment_preference": "Neue Terminpräferenz",
    "new_appointment_preference_text": "Immer mit dem zugewiesenen Benutzer von {contactLabel} buchen.",
    "new_appointment_preference_subtext": "Buche neue Termine mit dem {contactLabel} zugewiesenen Benutzer, anstatt die Round-Robin-Planung zu verwenden.",
    "cancel": "Absagen",
    "confirm": "Bestätigen",
    "service_calendar_name": "Servicename",
    "service_logo": "Servicelogo",
    "service_select_team_member": "Mitarbeiter auswählen",
    "service_duration": "Servicedauer",
    "appointment_invite_title": "Titel der Termineinladung",
    "payment_placeholder": "Gib eine Beschreibung ein, die dem Benutzer angezeigt wird, um ihn über die Zahlung zu informieren",
    "deposit_amount": "Einzahlungsbetrag",
    "collect_deposit_amount": "Teilzahlung akzeptieren",
    "percentage": "Prozentsatz",
    "total_amount": "Gesamtbetrag",
    "enter_meeting_location": "Besprechungsort eingeben",
    "accept_payments": "Zahlungen akzeptieren",
    "aria": {
      "should_accept_payment": "Sollte Zahlung akzeptieren"
    },
    "calendar_name_tooltip": "Kalendername, der im Buchungs-Widget angezeigt werden soll.",
    "booking_availability_tooltip": "Legen Sie die Tage und Uhrzeiten fest, zu denen Buchungen möglich sind. Dies sind Ihre standardmäßigen wöchentlichen Geschäftszeiten, die den Benutzern angezeigt werden, wenn sie ein Zeitfenster auswählen.",
    "select_team_member_tooltip": "Wählen Sie die Teammitglieder aus, die an diesem Meeting teilnehmen werden.",
    "seats_per_class_tooltip": "Legen Sie die maximale Anzahl der Teilnehmer fest, die diesen Kurs buchen dürfen. Sobald alle Plätze besetzt sind, ist das Zeitfenster für die Buchung nicht mehr verfügbar.",
    "meeting_color": "Konferenzen Farbe",
    "meeting_duration_tooltip": "Dies legt die Dauer Ihres Meetings fest und bestimmt, wie lange es dauern wird."
  },
  "calendar_advanced": {
    "general": {
      "quick_tip": "Schneller Tipp",
      "timezone_change_tip": "Zeitzonen können jederzeit unter Zeitzoneneinstellungen geändert werden",
      "save": "Änderungen speichern",
      "close": "Schließen",
      "meeting_details": "Grundlegende Details",
      "availability": "Verfügbarkeit",
      "forms_and_payment": "Formulare und Bezahlung",
      "notifications_and_additional_options": "Benachrichtigungen und zusätzliche Optionen",
      "connections": "Verbindungen",
      "customizations": "Anpassungen",
      "create": "Erstellen",
      "edit": "Bearbeiten",
      "equipments": "Räume und Geräte",
      "service_details": "Servicedetails",
      "booking_rules": "Buchungsregeln",
      "advanced_settings": "Erweiterte Einstellungen",
      "form_and_confirmation": "Formular & Bestätigung",
      "payments": "Zahlungen",
      "notifications_and_policies": "Benachrichtigungen & Richtlinien",
      "widget_appearance": "Widget-Erscheinungsbild",
      "saving_changes": "Nur eine Minute – Speichern Sie das neueste Dynamisch...",
      "calendar_id": "Kalender-ID",
      "saveCalendarSuccess": "Kalender erfolgreich gespeichert",
      "external_sync": "Externe Synchronisierung",
      "external_sync_and_channel": "Externe Synchronisierung & Kanäle",
      "booking_channels": "Buchungskanäle",
      "meeting_location": "Standort des Meetings",
      "staff_location": "Mitarbeiter und Standort"
    },
    "meeting_details": {
      "meeting_location": "Besprechungsort",
      "meeting_location_label": "Standort des Meetings",
      "enter_meeting_location": "Besprechungsort eingeben",
      "click_to_upload": "Zum Hochladen klicken",
      "square": "Quadrat",
      "circle": "Kreis",
      "remove_logo": "Logo entfernen",
      "meeting_invite_title_tooltip": "Dies ist der Titel für das Kalendermeeting, das in Ihrer Termin-Listenansicht, Kalenderansicht und in Kalendern von Drittanbietern angezeigt wird.",
      "event_color_tooltip": "Wählen Sie eine Farbe für diese Buchungsveranstaltung. Farben werden mit Terminen in Google-Kalendern synchronisiert.",
      "enter_a_name": "Bitte geben Sie einen Namen ein.",
      "enter_an_event_title": "Bitte gib einen Veranstaltungstitel ein.",
      "high_priority": "Hohe Priorität",
      "medium_priority": "Mittlere Priorität",
      "low_priority": "Niedrige Priorität",
      "priority": "Priorität",
      "custom": "Benutzerdefiniert",
      "zoom_not_added": "Der Benutzer hat sein Zoom-Konto noch nicht verbunden.",
      "opt_avail": "Für Verfügbarkeit optimieren",
      "opt_equal": "Für eine gleichmäßige Verteilung optimieren",
      "team_members": "Teammitglieder auswählen",
      "team_members_location": "Personal auswählen und Sitzungsstandort zuweisen",
      "team_member": "Teammitglied auswählen",
      "team_member_location": "Personal auswählen und Sitzungsstandort zuweisen",
      "meeting_location_required": "Besprechungsort ist erforderlich.",
      "meeting_details": "Grundlegende Details",
      "meeting_details_description": "Grundlegende Informationen zur Identifizierung dieses Kalenders.",
      "or_drag_and_drop": "oder ziehen und ablegen",
      "service_details": "Servicedetails",
      "team_member_disabled_recurring_tooltip": "Bei wiederkehrenden Besprechungen ist nur ein Teammitglied zugelassen. Um mehrere Teammitglieder hinzuzufügen, deaktiviere wiederkehrende Meetings.",
      "team_member_disabled_class_booking_tooltip": "Es kann nur ein Teammitglied zu einem Kursbuchungskalender hinzugefügt werden.",
      "advanced_settings": "Erweiterte Einstellungen",
      "enable_contact_assigned_to_setting": "Um diese Einstellung zu aktivieren, muss das Formular an erster Stelle in der Widget-Reihenfolge stehen. Bitte ordne die Widget-Reihenfolge auf der Registerkarte „Formulare und Zahlung“ neu an.",
      "reschedule_preference_setting_tooltip": "Wähle aus, wem der Termin zugewiesen werden soll, wenn ein {contactLabel} über das Booking Widget einen neuen Termin bucht.",
      "appointment_preference_tooltip": "Entscheiden Sie, ob neue Termine immer mit dem zugewiesenen Nutzer des {contactLabel} gebucht werden sollen. Falls einem {contactLabel} ein Benutzer zugewiesen ist, wird dieser Benutzer vorrangig gewählt; andernfalls erfolgt die Zuweisung in wechselnder Zuweisung. Tipp: Deaktivieren Sie die Option „Mitarbeiterauswahl zulassen“, um zu verhindern, dass Buchende den Mitarbeiter im Buchungs-Widget ändern.",
      "add_location": "Standort hinzufügen",
      "multiple_locations_neo": "Bieten Sie dem Buchenden mehrere Standortoptionen zur Auswahl an. Mehrere Standorte werden nur vom Neo-Widget unterstützt.",
      "make_owner": "Zum Owner machen",
      "only_one_team_member": "Beim Hinzufügen mehrerer Orte ist nur ein Teammitglied erlaubt.",
      "ask_the_booker_error_message": "Ort mit „Den Buchenden fragen“ existiert bereits.",
      "enter_location": "Geben Sie einen Standort Wert ein",
      "enter_display_label": "Anzeigebeschriftung eingeben",
      "add_display_label": "Beschriftung hinzufügen",
      "multiple_location_support_message": "Bieten Sie dem Bucher mehrere Standortoptionen zur Auswahl an. Mehrere Standorte werden nur vom Neo-Widget unterstützt.",
      "only_one_team_member_personal_calendar": "Bei der persönlichen Buchung ist nur ein Teammitglied erlaubt. ",
      "ms_teams_not_added": "Der Benutzer hat sein Microsoft Teams-Konto noch nicht verbunden.",
      "enable_new_appt_preference": "Neue Terminpräferenz aktivieren",
      "enable_new_appt_preference_desc": "Das Aktivieren von „<b>Buche immer über den {contactLabel} zugewiesenen Benutzer</b>“ legt das <b>Formular</b> automatisch als ersten Schritt in der Reihenfolge der Widgets fest.",
      "location_exists_toast": "Konferenzen Standort bereits hinzugefügt",
      "not_supported_with_multiple_team_members": "Nicht unterstützt bei mehreren Teammitgliedern",
      "not_supported_personal_calendar": "Nicht unterstützt im persönlichen Kalender",
      "not_supported_class_booking": "Nicht im Kursbuchungskalender unterstützt",
      "not_supported_collective_booking": "Im Sammelkalender nicht unterstützt",
      "not_supported_service_booking": "Nicht im Servicekalender unterstützt",
      "not_supported_round_robin": "Nicht im Kalender mit wechselnder Zuweisung unterstützt",
      "not_supported_event": "Nicht im Event-Kalender unterstützt",
      "calendar_logo_tooltip": "Wählen Sie ein Logo aus, das im Buchungs-Widget angezeigt werden soll.",
      "calendar_name_tooltip": "Kalendername, der im Buchungs-Widget angezeigt werden soll.",
      "description_tooltip": "Beschreiben Sie, worum es im Kalender geht, der im Buchungs-Widget angezeigt wird.",
      "group_tooltip": "Sie können diesen Kalender einer Gruppe zuweisen (falls erstellt). Benutzer, die auf den Gruppenlink zugreifen, können alle Kalender in dieser Gruppe durchsuchen und buchen.",
      "custom_url_tooltip": "Passen Sie die URL des Booking Widgets an.",
      "meeting_color_tooltip": "Wähle eine Farbe für dieses Buchungsereignis. Farben werden mit Terminen in Google Kalender synchronisiert.",
      "add_display_label_tooltip": "Den tatsächlichen Standort verbergen und ein benutzerdefiniertes Label anzeigen, bis das Meeting gebucht ist (gilt, wenn mehrere Standorte hinzugefügt werden).",
      "meeting_location_tooltip": "Wählen Sie einen Standort aus oder wählen Sie 'Benutzerdefiniert', um eine beliebige Adresse oder einen Besprechungslink hinzuzufügen.",
      "team_members_location_tooltip": "Wählen Sie den Mitarbeiter aus, der an dieser Besprechung teilnehmen wird, und legen Sie seinen Besprechungsstandort fest.",
      "meeting_distribution": "Meetingverteilung",
      "meeting_distribution_tooltip": "Wählen Sie, wie Besprechungen den Mitarbeitern zugewiesen werden.",
      "opt_avail_tooltip": "Weisen Sie Besprechungen dem Mitarbeiter zu, der zur gewählten Zeit verfügbar ist, unabhängig von früheren Buchungen. Maximiert die Nutzung offener Zeitfenster und die Erfolgsquote bei Buchungen.",
      "opt_equal_tooltip": "Verteilen Sie Besprechungen gleichmäßig auf alle Mitarbeiter, indem Sie frühere Buchungen nachverfolgen. Priorisiert Fairness über Verfügbarkeit.",
      "priority_tooltip": "Legen Sie die Präferenzstufe für die Zuweisung von Besprechungen fest, wenn mehrere Mitarbeiter verfügbar sind. Mitarbeiter mit hoher Priorität werden bei Buchungen zuerst berücksichtigt, gefolgt von Mitarbeitern mit mittlerer und niedriger Priorität.",
      "contact_routing_preference": "Kontaktweiterleitungspräferenz",
      "contact_routing_preference_tooltip": "Definiere, wie neue und wiederkehrende {contactsLabel} den Teammitgliedern zugewiesen werden – entweder per Round Robin oder ihrem ursprünglichen Eigentümer.",
      "team_members_location_owner_tooltip": "Der Hauptnutzer, der das Meeting besitzt und den endgültigen Standort des Meetings bereitstellt.",
      "owner": "Eigentümer",
      "upload_from_system": "Aus System hochladen",
      "choose_from_media_storage": "Aus Medienspeicher auswählen",
      "only_one_team_member_allowed": "Nur ein Teammitglied ist erlaubt.",
      "at_least_two_team_members_required": "Mindestens zwei Teammitglieder sind erforderlich.",
      "at_least_one_team_member_required": "Mindestens ein Teammitglied ist erforderlich.",
      "widget_shape": "Form des Widgets:",
      "widget_bookings_path": "/widget/buchungen/",
      "contact_name_placeholder": "&#123;&#123; contact.name &#125;&#125;",
      "profile_photo_alt": "Profilfoto",
      "meeting_location_placeholder": "Standort des Meetings",
      "team_member_meeting_location": "Personal & Konferenzstandort",
      "meeting_location_desc": "Weisen Sie Mitarbeiter diesem Kalender zu und legen Sie fest, wo die Besprechungen stattfinden.",
      "event_calendar_meeting_location_desc": "Wählen Sie, wo das Meeting stattfinden wird."
    },
    "meeting_location": {
      "ask_the_booker": "Den Buchenden fragen (Buchender betritt den Standort)",
      "ask_the_booker_desc": "Der Buchende wird gebeten, bei der Buchung einen Standort seiner Wahl anzugeben",
      "zoom": "Zoom",
      "google_meet": "Google Meet",
      "microsoft_teams": "Microsoft Teams",
      "phone": "Rufnummer",
      "full_address": "Vollständige Anschrift",
      "custom": "Benutzerdefiniert",
      "meeting_location": "Standort des Meetings"
    },
    "availability": {
      "my_availability": "Meine Verfügbarkeit",
      "calendar_availability": "Verfügbarkeit des Kalenders",
      "calendar_availability_desc": "Legen Sie fest, wann Besprechungen in diesem Kalender gebucht werden können.",
      "set_availability": "Stelle hier deine Verfügbarkeit für den Kalender ein.",
      "standard": "Standard",
      "custom": "Benutzerdefiniert",
      "to": "An",
      "copy_to_all": "Kopie an alle",
      "add_time": "Zeit hinzufügen",
      "recurring_meeting": "Wiederkehrendes Treffen",
      "recurring_info": "Nur ein Benutzer pro Kalender für wiederkehrende Buchungen.",
      "repeat": "Wiederholen",
      "times_to_repeat": "Zeiten zum Wiederholen",
      "slots_unavailable": "Wenn Zeitfenster nicht verfügbar sind?",
      "overlap_status": "Terminstatus bei Terminüberschneidungen ",
      "meeting_interval": "Besprechungsintervall",
      "meeting_duration": "Dauer der Besprechung",
      "minimum_scheduling": "Mindestterminvorgabe",
      "date_range": "Datumsbereich",
      "maximum_bookings_per_day": "Maximale Buchungen pro Tag",
      "maximum_bookings_per_slot": "Maximale Buchungen pro Zeitfenster",
      "maximum_bookings_per_slot_per_user": "Maximale Buchungen pro Zeitfenster (pro Benutzer)",
      "seats_per_class": "Plätze pro Kurs",
      "pre_buffer_time": "Vorlaufzeit",
      "post_buffer_time": "Nachlaufzeit",
      "pre_buffer_tooltip": "Vorlaufzeit ist zusätzliche Zeit, die vor einem Termin hinzugefügt werden kann, um zusätzliche Zeit zum Vorbereiten zu haben.",
      "post_buffer_tooltip": "Nachlaufzeit ist zusätzliche Zeit, die nach einem Termin hinzugefügt werden kann, um zusätzliche Zeit zum Nachbereiten zu haben.",
      "buffer_time": "Pufferzeit",
      "daily": "Täglich",
      "weekly": "Wöchentlich",
      "monthly": "Monatlich",
      "skip_booking": "Buchung von nicht verfügbaren Zeitfenstern überspringen",
      "continue_booking": "Buchung fortsetzen",
      "book_next_available": "Nächstes verfügbares Zeitfenster buchen",
      "confirmed": "Bestätigt",
      "unconfirmed": "Unbestätigt",
      "enter_valid_hours": "Bitte gib gültige Öffnungszeiten ein",
      "enter_valid_avail": "Bitte gib eine gültige kundenspezifische Verfügbarkeit ein",
      "availability_type_tooltip": "Wähle „Standardverfügbarkeit“ für wöchentlich angebotene reguläre Buchungen. Wähle „Benutzerdefiniert“ für Buchungen, die nur an bestimmten Terminen verfügbar sind.",
      "meeting_interval_tooltip": "Steuert, wie oft Buchungszeitfenster angezeigt werden.\nFür ein 30-minütiges Meeting: \n• Wählen Sie 1 Stunde, um Zeitfenster zu Beginn jeder Stunde anzuzeigen. \n• Wählen Sie 30 Min., um alle 30 Min. Zeitfenster anzuzeigen.",
      "date_range_tooltip": "Veranstaltungen können in den nächsten n Tagen geplant werden.",
      "maximum_bookings_per_day_tooltip": "Maximale Anzahl der erlaubten Meetings pro Tag in diesem Kalender.",
      "maximum_bookings_per_slot_tooltip": "Begrenzen Sie, wie viele Meetings ein Benutzer im selben Zeitfenster erhalten kann. Wenn das Limit erreicht ist, wird die Buchung dem nächsten Benutzer in der Round-Robin-Warteschlange zugewiesen oder das Zeitfenster wird nicht mehr verfügbar.",
      "add_days": "Tage hinzufügen",
      "month_on_day": "Monatlich am Tag",
      "month_on_last_day": "Monatlich am letzten Tag",
      "day": "Tag",
      "week": "Woche",
      "month": "Monat",
      "mins": "Minuten",
      "hours": "Stunden",
      "days": "Tage",
      "weeks": "Wochen",
      "months": "Monate",
      "meeting_interval_error": "Das Besprechungsintervall muss zwischen 5 Minuten und 12 Stunden liegen.",
      "meeting_duration_error": "Die Besprechungsdauer muss zwischen 1 Minute und 12 Stunden liegen.",
      "buffer_time_error": "Die Pufferzeit muss weniger als 12 Stunden betragen.",
      "appointment_interval": "Terminintervall",
      "appointment_duration": "Dauer des Termins",
      "maximum_appointments_per_day": "Maximale Anzahl an Terminen pro Tag",
      "subTitle": "Wähle das Datum, um bestimmte Stunden festzulegen.",
      "heading_1": "Wöchentlich verfügbare Stunden",
      "scheduling_availability_heading": "Buchungsverfügbarkeit",
      "scheduling_availability_tooltip": "Verwenden Sie einen bestehenden Verfügbarkeitszeitplan oder erstellen Sie einen benutzerdefinierten für diesen Kalender.",
      "tooltip_1": "Lege deinen wöchentlichen Verfügbarkeitsplan fest. Dies sind deine Standardstunden, die wöchentlich einheitlich angewendet werden.",
      "heading_2": "Wann bist du verfügbar?",
      "unavailable_label": "Nicht verfügbar",
      "tooltip_2": "Passe deinen Zeitplan für bestimmte Termine an. Überschreibe deine regulären Wochenstunden, indem du die Verfügbarkeit oder Nichtverfügbarkeit für ausgewählte Daten markierst.",
      "date_specific_level": "Datumsspezifische Stunden hinzufügen",
      "specific_hours_button": "Datumsspezifische Uhrzeiten",
      "specific_hours_description": "Legen Sie eine benutzerdefinierte Verfügbarkeit für bestimmte Zeiten fest, die von Ihrem wöchentlichen Zeitplan abweichen.",
      "overlap_error": "Zeitfenster dürfen sich nicht überschneiden",
      "apply": "Anwenden",
      "copy_times_to": "Zeiten kopieren nach",
      "no_date_specific_heading": "Keine datumsspezifische Uhrzeit hinzugefügt.",
      "no_date_specific_description": "Du kannst bestimmte Daten und Uhrzeiten zu deiner Verfügbarkeit hinzufügen/entfernen.",
      "recurring_disabled_conditions_tooltip": "Wiederkehrend-Besprechungen werden deaktiviert. Um sie auslöser, stelle sicher, dass der Kalender nur eine Gruppe Mitglieder enthält und keine datumsspezifische Zahlung von Stunde oder Unvollständig hinzugefügt wurde.",
      "date_specific_hours_disabled_conditions_tooltip": "Wenn du eine datumsspezifische Uhrzeit angeben möchtest, stelle sicher, dass wiederkehrende Besprechungen deaktiviert sind.",
      "recurring_disable_event_calendar_conditions": "Wiederkehrend-Besprechungen werden deaktiviert. Um Auslöser zu stellen, stelle sicher, dass keine datumsspezifische Stunde oder Unvollständig Zahlung hinzugefügt wurde.",
      "service_duration": "Servicedauer",
      "service_interval": "Serviceintervall",
      "service_interval_tooltip": "Das Besprechungsintervall legt fest, wie oft Buchungszeiträume im Kalender erscheinen. Zum Beispiel bedeutet ein 1-Stunden-Intervall bei einem 30-minütigen Ereignis, dass die Zeitfenster jede Stunde erscheinen. Ein 30-Minuten-Intervall bedeutet, dass Zeitfenster alle 30 Minuten erscheinen.",
      "service_duration_tooltip": "Dies legt die Dauer deines Termins fest und bestimmt, wie lange er dauern wird.",
      "minimum_scheduling_tooltip": "Hiermit legen Sie die Mindestzeit fest, die bei der Terminbuchung über das Kalender-Widget vor einem Termin übrig bleiben muss. Wenn diese Mindestzeit beispielsweise auf 4 Stunden festgelegt ist, können Termine nicht innerhalb von 4 Stunden vor ihrer Startzeit gebucht werden; Buchungen müssen dann mindestens 4 Stunden im Voraus erfolgen.",
      "look_busy_title": "Als nicht verfügbar anzeigen",
      "look_busy_helper_text": "Blende einen Prozentsatz deiner verfügbaren Termin-Zeitfenster im Buchungs-Widget aus, um geschäftiger und gefragter zu erscheinen.",
      "look_busy_percentage_description": "Die Anzahl der verfügbaren Zeitfenster um x % ausblenden.",
      "maximum_bookings_per_slot_tooltip_personal": "Maximale Anzahl der zulässigen Meetings in einem einzelnen Zeitfenster.",
      "enable_recurring_title": "Wiederkehrende Besprechung aktivieren",
      "enable_recurring_desc": "Durch Aktivieren von <b>wiederkehrenden Meetings</b> werden die folgenden Einstellungen automatisch deaktiviert, da sie nicht gleichzeitig bestehen können:",
      "date_specific_hours": "Alle <b>datumsspezifischen Öffnungszeiten</b> werden gelöscht.",
      "multiple_team_members": "<b>Mehrere Teammitglieder</b> werden entfernt—nur ein Teammitglied kann in diesem Kalender verbleiben.",
      "partial_payments": "<b>Unvollständig Zahlungen</b> werden deaktiviert und der Voll-Betrag wird einziehen.",
      "select_team_member_to_keep": "Auswählen einer Gruppe Mitglieder zum Behalten in diesem Kalender:",
      "select_team_member": "Teammitglied auswählen",
      "partial_payments_disabled": "Wie möchten Sie den vollen Betrag für wiederkehrende Termine einziehen, da unvollständige Bezahlungen deaktiviert sind?",
      "enable_date_specific_hours": "Datumsspezifische Uhrzeiten aktivieren",
      "enable_date_specific_hours_desc": "Durch das Aktivieren der <b>datumsspezifischen Uhrzeiten</b> wird die folgende Einstellung automatisch deaktiviert, da sie nicht gleichzeitig bestehen können:",
      "recurring_meetings_disabled": "<b>Wiederkehrende Besprechungen werden deaktiviert</b>, {contactsLabel} kann nur einzelne Termine basierend auf den von Ihnen festgelegten verfügbaren Terminen buchen.",
      "payment_preference": "Zahlungseinstellungen:",
      "team_members_in_this_calendar": "Teammitglieder in diesem Kalender",
      "other_team_members": "Andere Teammitglieder (Nicht zu diesem Kalender hinzugefügt)",
      "select_team_member_tooltip": "Wählen Sie die Teammitglieder aus, die an diesem Meeting teilnehmen werden.",
      "meeting_duration_tooltip": "Dies legt die Dauer Ihres Meetings fest und bestimmt, wie lange es andauern wird.",
      "date_specific_hours_tooltip": "Passe deinen Zeitplan für bestimmte Termine an. Überschreibe deine regulären Wochenstunden, indem du die Verfügbarkeit oder Nichtverfügbarkeit für ausgewählte Daten markierst.",
      "recurring_meeting_tooltip": "Lass Meetings sich über einen Zeitraum mehrfach wiederholen.",
      "repeat_frequency_tooltip": "Wählen Sie die Häufigkeit dieses wiederkehrenden Events.",
      "time_to_repeat_tooltip": "Gesamtanzahl der Wiederholungen festlegen.",
      "slots_unavailable_tooltip": "Wählen Sie, was geschehen soll, wenn ein oder mehrere Zeitfenster in einer wiederkehrenden Buchung bereits belegt sind.",
      "skip_booking_tooltip": "Nur die verfügbaren Zeitfenster werden gebucht. Alle nicht verfügbaren Daten in der wiederkehrenden Serie werden übersprungen.",
      "force_book": "Buchung erzwingen",
      "force_booking_tooltip": "Alle Zeitfenster werden gebucht, selbst wenn es zu Konflikten kommt. Mit Vorsicht verwenden, um Doppelbuchungen zu vermeiden.",
      "book_next_available_tooltip": "Falls ein ausgewähltes Zeitfenster nicht verfügbar ist, wird das nächste verfügbare Zeitfenster im gleichen wiederkehrenden Zeitplan gebucht (z. B. nächsten Montag bei wöchentlicher Wiederholung).",
      "slot_interval_tooltip": "Legen Sie den Abstand zwischen den Startzeiten aufeinanderfolgender verfügbarer Zeitfenster fest. Wenn zum Beispiel die Dauer Ihres Meetings 30 Min. beträgt und Sie das Intervall auf 60 Min. einstellen, kann ein Benutzer um 9:00 Uhr, dann um 10:00 Uhr und so weiter buchen – obwohl jedes Meeting nur 30 Min. dauert.",
      "minimum_scheduling_notice_tooltip": "Benutzer müssen Meetings mindestens so lange im Voraus buchen.",
      "date_range_preferences_tooltip": "Legen Sie fest, wie weit in die Zukunft Buchungen ab dem heutigen Datum möglich sind.",
      "maximum_bookings_per_slot_preferences_tooltip": "Begrenzen Sie, wie viele Meetings für denselben Zeitfenster geplant werden können.",
      "maximum_bookings_per_slot_per_user_preferences_tooltip": "Begrenzen Sie, wie viele Meetings für denselben Zeitfenster (pro Nutzer) geplant werden können.",
      "pre_buffer_time_tooltip": "Zeit, die vor jedem Meeting blockiert werden muss, um zusätzliche Vorbereitungszeit zu ermöglichen.",
      "post_buffer_time_tooltip": "Zeit für eine Blockade nach jeder Sitzung, die zusätzliche Zeit für die Nachbereitung vorsieht.",
      "seats_per_class_tooltip": "Legen Sie die maximale Anzahl der Teilnehmer fest, die diesen Kurs buchen dürfen. Sobald alle Plätze belegt sind, ist das Zeitfenster nicht mehr zur Buchung verfügbar.",
      "maximum_bookings_per_slot_per_user_tooltip": "Begrenzen Sie, wie viele Meetings für denselben Zeitfenster (pro Nutzer) geplant werden können.",
      "repeat_frequency": "Wiederholungsfrequenz",
      "slot_interval": "Zeitfensterintervall",
      "skip_booking_helper_text": "Nur die verfügbaren Zeitfenster werden gebucht. Alle nicht verfügbaren Termine in der wiederkehrenden Serie werden übersprungen.",
      "force_book_helper_text": "Alle Zeitfenster werden gebucht, selbst wenn es zu Konflikten kommt. Mit Vorsicht verwenden, um Doppelbuchungen zu vermeiden.",
      "book_next_available_helper_text": "Wenn ein ausgewähltes Zeitfenster nicht verfügbar ist, buchen Sie das nächste verfügbare Zeitfenster und den gleichen Wiederkehrend-Plan (z. B. Nächste Montag Falls Wöchentlich).",
      "bulk_edit": "Massendaten bearbeiten",
      "select_users": "Nutzer auswählen",
      "select_all": "Alles auswählen",
      "times_to_repeat_tooltip": "Gesamtanzahl der Wiederholungen festlegen.",
      "custom_recurrence": "Benutzerdefinierte Wiederholung",
      "repeats_every": "Wiederholt sich alle",
      "availability_schedule": "Verfügbarkeitszeitplan",
      "availability_schedule_desc": "Legen Sie fest, wann Besprechungen entsprechend der Verfügbarkeit des Personals gebucht werden können.",
      "no_users_added": "Keine Mitarbeiter hinzugefügt!",
      "no_users_added_description": "Bitte fügen Sie Mitarbeiter hinzu, um deren Verfügbarkeit zu überprüfen",
      "add_users": "Mitarbeiter hinzufügen",
      "minimum_scheduling_notice_error": "Bitte geben Sie ≤ 1.440 Min. ein.",
      "please_select_date": "Bitte wählen Sie ein Datum, um fortzufahren"
    },
    "forms_payment": {
      "forms": "Formulare & Gäste",
      "forms_sub": "Konfigurieren Sie die Präferenzen für die letzte Seite, die nach einer erfolgreichen Buchung angezeigt wird.",
      "select_form": "Formular auswählen",
      "enable_same_user_assignment": "Weise bei jeder Terminbuchung Kontakte ihren jeweiligen Kalenderteammitgliedern zu.",
      "sticky_contacts_label": "Sticky-{contactsLabel}",
      "sticky_contacts": "Felder vorab ausfüllen",
      "confirmation_page": "Bestätigungsseite",
      "default": "Standard",
      "redirect_url": "Weiterleitungs-URL",
      "use_custom_form_rules": "Benutzerdefinierte Formularregeln verwenden",
      "default_message_tooltip": "Zeigt die konfigurierte Bestätigungsnachricht an, nachdem der Termin gebucht wurde.",
      "redirect_url_tooltip": "Leitet den Kunden nach der Buchung des Termins auf die konfigurierte Seite weiter.",
      "use_custom_form_rules_tooltip": "Verwendet die im benutzerdefinierten Formular definierte Weiterleitung oder benutzerdefinierte Nachricht. Wenn keine Regel zutrifft, wird die Bestätigungsnachricht des Kalenders angezeigt.",
      "thank_you": "Dankesnachricht",
      "enter_url": "URL eingeben",
      "enter_thank_you_message": "Geben Sie eine Dankesnachricht ein.",
      "amount_tab_hidden_label": "Platzhalter den Betrag",
      "percentage_tab_hidden_label": "Platzhalter für den Prozentsatz",
      "pixel_id": "Meta Pixel-Id (Optional)",
      "auto_confirm": "Neue Kalenderbesprechungen automatisch bestätigen",
      "configure_payment": "Zahlungsoptionen konfigurieren",
      "accept_payments": "Zahlungen akzeptieren",
      "test": "Test",
      "live": "Live",
      "enable_guests": "Gäste hinzufügen",
      "add_guest_tooltip": "„Gast hinzufügen“ ermöglicht es deinem Teilnehmer, mehrere Teilnehmer zum selben Termin hinzuzufügen.",
      "add_guest_custom_form_tooltip": "Bei Aktivierung dieser Option wird eine vom System generierte E-Mail mit einem Link zum benutzerdefinierten Formular an die Gäste gesendet, sobald ihr Termin bestätigt wurde. Um doppelte E-Mail-Versand zu vermeiden, stell bitte sicher, dass nicht bereits eine separate Bestätigungs-E-Mail für Gäste eingerichtet ist. (Überprüfen kannst du dies auf der Registerkarte „Benachrichtigungen“ > „Bestätigungsbenachrichtigung“.)",
      "add_guest_same_form_check": "Sende dasselbe Formular zur Informationserfassung per E-Mail an alle Gäste.",
      "payment_tooltip": "Die Zahlung wird nur für den Hauptteilnehmer und nicht für die Gäste berücksichtigt.",
      "default_form": "Standard (Vorname, Nachname, E-Mail, Telefon, Notizen)",
      "select_form_tooltip": "Wenn Sie von den Personen, die in diesem Kalender buchen, mehr Informationen als nur Vorname, Nachname, E-Mail-Adresse und Rufnummer erfassen möchten, erstellen Sie ein benutzerdefiniertes Formular unter Seiten > Formulare > Builder und wählen Sie das Formular dann über die Drop-down-Liste unten aus.",
      "confirmation_page_tooltip": "Sobald jemand eine Buchung getätigt hat, kannst du wählen, ob du ihm eine benutzerdefinierte Nachricht auf derselben Seite anzeigen möchtest (Standard) oder ihn auf eine Seite deiner Wahl umleiten möchtest (Weiterleitung).",
      "add_guest_collect_email": "Name und E-Mail",
      "add_guest_count_only": "Nur Anzahl",
      "custom_email_notification": "Benutzerdefiniertes Formular an Gäste senden.",
      "consent_label": "Kontrollkästchen „Einwilligung“",
      "consent_input_placeholder": "Einwilligungstext hinzufügen",
      "same_user_assignment_tooltip": "Um diese Einstellung zu aktivieren, muss sich das Formular an erster Stelle im Widget befinden. Ordne das Widget neu an, um das Formular zuerst zu positionieren, um diese Einstellung zu aktivieren.",
      "consent_tooltip": "Bitten Sie die Kontakte um ihre Einwilligung, wenn Sie ein Meeting buchen.",
      "stripe_error": "Bis zu zwei Dezimalstellen (Beispiel: 25,99)",
      "auto_confirm_service": "Neue Termine automatisch bestätigen",
      "service_form_message": "Wenn ein Kontakt mehrere Services bucht, wird er nur das Standardformular im Servicemenü sehen.",
      "deposit_amount_error": "Der Einzahlungsbetrag muss geringer sein als der Gesamtbetrag.",
      "deposit_percentage_error": "Der Einzahlungsprozentsatz muss unter 100 % liegen.",
      "partial_payment_tooltip": "Ermögliche Teilzahlungen, um während der Terminbuchung eine Anzahlung vom Kunden zu erhalten.",
      "partial_payment_enable_error": "Der eingegebene Gesamtbetrag muss größer als 0 sein, um Teilzahlungen zu ermöglichen.",
      "payment_disable_text_integration": "Integriere einen Zahlungsanbieter unter Zahlungen > Integrationen, um Zahlungen zu akzeptieren",
      "payment_disable_text_recurring": "Die Option „Zahlung akzeptieren“ ist für wiederkehrende Besprechungen nicht verfügbar. Schalte wiederkehrend aus, um Zahlungen zu aktivieren.",
      "date_and_time_selector": "Datums- und Uhrzeitauswahl",
      "form_selector": "Formular",
      "order_step": "Schritt",
      "widget_order_label": "Widget-Reihenfolge",
      "widget_order_tool_tip": "Ordne die Reihenfolge „Datums- und Uhrzeitauswahl“ und „Formular“ im Kalender-Widget neu an. Ordne sie per Drag & Drop nach deiner Präferenz neu an.",
      "widget_re_order_tooltip": "Die Neuanordnung ist nur mit dem Neo-Widget-Stil verfügbar. Wechsle zu Neo, um die Neuanordnung zu aktivieren.",
      "widget_re_order_disabled_tooltip": "Um die Reihenfolge der Widgets zu ändern, deaktivieren Sie bitte die Option „Neue Terminpräferenz (immer mit dem zugewiesenen Benutzer von {contactLabel} buchen)“ im Abschnitt Besprechungsdetails > Teammitglieder > Erweiterte Einstellungen.",
      "payment_description_error": "Maximale Zeichenanzahl von 1000 erreicht.",
      "widget_multiple_location_disabled_tooltip": "Das Widget Klassisch unterstützt nicht mehrere Besprechungsorte. Bitte entferne alle zusätzlichen Standorte, um das Klassisch-Widget zu verwenden.",
      "recurring_payment_label": "Zahlung für wiederkehrende Termine",
      "enable_payments_for_guests": "Bezahlungen für Gäste aktivieren",
      "guest_payment_description": "Da du die Option „Gäste hinzufügen“ aktiviert hast, kannst du bei der Buchung auch Gebühr je Gast auswählen.",
      "charge_per_attendee": "Gebühr pro Teilnehmer",
      "charge_per_attendee_description": "Multipliziere den Gesamtbetrag mit der Nummer von Teilnehmern (einschließlich Gäste), wenn du bei der Buchung die Zahlung einziehen möchtest.",
      "click_confirm_description": "Klicken Sie auf „Speichern“, um diese Änderungen zu speichern.",
      "multiply_amount_guests": "Zahlung für alle Teilnehmer einziehen",
      "multiply_amount_guests_description": "Wenn aktiviert, wird der Betrag, der bei der Buchung zu zahlen ist, mit der Gesamtzahl der Teilnehmer, einschließlich der Gäste, multipliziert.",
      "first_appointment_only": "Gebühr nur für den ersten Termin",
      "all_appointments": "Gebühr für jeden Termin im Voraus",
      "no_payment_provider_connected": "Kein Zahlungsanbieter verbunden.",
      "no_default_payment_provider": "Kein Provider verbunden",
      "provider_not_supported": "Der Standard Provider wird nicht unterstützt",
      "manage_payment_provider": "Zahlungsanbieter verwalten",
      "supported_providers": "Unterstützte Anbieter:",
      "paypal_razorpay_helper_text": "Zahlungen werden ausschließlich über Razorpay abgewickelt, da PayPal mit benutzerdefinierten Zahlungsanbietern nicht kompatibel ist.",
      "rearrange_widget_order": "Reihenfolge der Widgets neu anordnen",
      "change_form_order": "Dynamisch das Formular zum ersten Schritt in Widget Sortieren wird die Nachlauf-Einstellungen deaktivieren:",
      "change_form_order_desc": "<b>Neue Terminpräferenz (immer mit dem zugewiesenen Benutzer des {contactLabel} buchen)</b> wird deaktiviert. Das bedeutet, dass Termine mit jedem verfügbaren Gruppenmitglied gebucht werden können, anstatt auf den dem {contactLabel} zugewiesenen Benutzer beschränkt zu sein.",
      "enable_mandatory_guest": "Erstellen Sie mindestens einen Gast erforderlich. Gast Felder werden vorgeöffnet und müssen vor ihrer Buchung ausgefüllt werden.",
      "enable_mandatory_guest_count": "Erfassen Sie die obligatorische Gästeanzahl im Buchungs-Widget.",
      "require_guest_for_booking": "Gäste für die Buchung erforderlich",
      "sticky_contacts_tooltip": "Felder für bekannte {contactsLabel} automatisch ausfüllen.",
      "auto_confirm_tooltip": "Neue Meetings automatisch als bestätigt markieren, ohne dass eine manuelle Genehmigung erforderlich ist. Deaktivieren Sie dies, wenn Sie jede Buchung manuell überprüfen und bestätigen möchten, bevor sie geplant wird.",
      "confirm_tooltip": "Sobald jemand eine Buchung vornimmt, kannst du wählen, ob du ihm eine benutzerdefinierte Nachricht auf derselben Seite anzeigen möchtest (Standard) oder ihn auf eine Seite deiner Wahl weiterleiten möchtest (Weiterleitungs-URL).",
      "facebook_pixel_id_tooltip": "",
      "accept_payments_tooltip": "Aktivieren Sie die Bezahlungserfassung während der Buchungen.",
      "total_amount_tooltip": "Legen Sie die Gesamtgebühr für das Meeting fest.",
      "deposit_amount_tooltip": "Betrag, der bei der Buchung als Anzahlung zu zahlen ist.",
      "multiply_amount_guests_all_guests": "Ziehe die Zahlung für alle Teilnehmer, auch Gäste, ein",
      "multiply_amount_guests_all_guests_tooltip": "Wenn aktiviert, wird der Betrag, der während der Buchung eingezogen wird, mit der Gesamtzahl der Teilnehmer multipliziert, einschließlich der Gäste.",
      "payment_description": "Bezahlungsbeschreibung",
      "payment_description_desc": "Wird dem Buchenden während der Eingabe der Bezahlungsdetails angezeigt.",
      "payment_description_tooltip": "Optional können Sie hilfreiche Details zur Bezahlung hinzufügen.",
      "test_mode_warning": "Test-Modus Dynamisch – kein wirklicher Umsatz wird bearbeitet.",
      "pixel_id_tooltip": "Senden Sie Aktivitäten des Buchungs-Widgets wie Ansichten, Klicks und Einsendungen mit Ihrer Pixel-ID an Meta.",
      "forms_description": "Legen Sie Ihre Präferenzen und Einstellungen für die Erfassung von Kundendaten während des Buchungsprozesses fest.",
      "payment_mode": "Zahlungsmodus",
      "payment_mode_tooltip": "Schalte zwischen Test-Modus und Live Modus für Zahlungen um. in Test-Modus werden keine wirklichen Abrechnungen erstellt – verwenden Sie sie, um die Buchungs- und Zahlungs Pipeline zu testen. Wechsle in den Live Modus, um aktuelle Zahlungen von Kunde zu akzeptieren.",
      "enable_coupon": "Gutscheincodes aktivieren",
      "enable_coupon_tooltip": "Ermöglichen Sie Kunden, Gutscheincodes während der Buchung anzuwenden. Um sicherzustellen, dass sie funktionieren, erstellen Sie zuerst gültige Gutscheincodes unter Bezahlungen > Gutscheincodes.",
      "payment_collection": "Zahlungserhebung",
      "payment_collection_tooltip": "Wählen Sie, ob der Kunde bei der Buchung bezahlt oder ob er lediglich seine Karte hinterlegt, ohne dass diese belastet wird.",
      "charge_upfront": "Im Voraus belasten",
      "save_card_on_file": "Karte speichern",
      "save_card_on_file_desc": "Sie können die Karte des Kunden während der Buchung auf sichere Weise speichern. Während der Buchung wird die Karte nicht belastet.",
      "guests": "Gäste"
    },
    "notifications": {
      "third_party_cal": "Einstellungen für Kalender von Drittanbietern",
      "third_party_cal_desc": "Richten Sie Ihre Präferenzen für Kalender von Drittanbietern ein.",
      "additional_settings": "Zusätzliche Einstellungen",
      "additional_settings_desc": "Zusätzliche Einstellungen für Ihren Kalender konfigurieren.",
      "notifications": "Benachrichtigungen",
      "notifications_sub": "Konfigurieren Sie, wie Sie Buchungsbenachrichtigungen per E-Mail, SMS, WhatsApp und In-App-Benachrichtigungen versenden.",
      "edit": "Bearbeiten",
      "created_on": "Erstellt am",
      "updated_on": "Aktualisiert am",
      "delivered": "Zugestellt",
      "not_available": "K. A.",
      "select_notification_type": "Wähle die Art der Benachrichtigung.",
      "notification_person": "Wer soll diese Benachrichtigung erhalten?",
      "contact": "{contactLabel}",
      "guest": "Gast",
      "assigned_user": "Zugewiesener Benutzer",
      "emails": "E-Mails",
      "alert_email_address": "E-Mail-Adresse für Benachrichtigungen",
      "ack_email": "Bestätigungs-E-Mail",
      "send_google_invites": "Erlaube Google Kalender, Einladungs- oder Aktualisierungs-E-Mails an Teilnehmer zu senden.",
      "assign_user_to_contact_desc": "Wenn diese Option aktiviert ist, stimmt der dem {contactLabel} zugewiesene Benutzer mit dem Eigentümer des Termins überein, bei dem die letzte Änderung stattgefunden hat – unabhängig davon, ob der Termin gebucht, verschoben oder neu zugewiesen wurde.",
      "send_google_outlook_invites": "Erlauben Sie Google / Outlook / iCloud-Kalender, Einladungs- und Aktualisierungs-E-Mails an Teilnehmer zu senden.",
      "assign_user_to_contact": "Weise {contactsLabel} bei jeder Terminbuchung ihren jeweiligen Kalenderteammitgliedern zu.",
      "skip_assigning_user_to_contact": "Überspringe die Zuweisung von {contactLabel}, falls {contactLabel} bereits einem Benutzer zugewiesen ist.",
      "skip_assigning_user_to_contact_desc": "Wenn diese Option aktiviert ist, bleibt der dem {contactLabel} zugewiesene Benutzer der gleiche, auch wenn der Termineigentümer ein anderer ist.",
      "assigned_staff": "Zugewiesene Mitarbeiter",
      "additional_emails": "Zusätzliche E-Mails",
      "assign_user_to_staff": "Weisen Sie den Kontakt stets dem Termin-Eigentümer zu.",
      "allow_cancellation": " Absage der Besprechung zulassen",
      "allow_reschedule": "Verschiebung der Besprechung zulassen",
      "allow_cancellation_tooltip": "Wenn diese Option aktiviert ist, wird ein Link zur Absage in den Abschnitt für zusätzliche Notizen und in die Kalendereinladung aufgenommen. Dieser Link läuft wie konfiguriert vor der Startzeit des Meetings ab, sodass der Buchende die Besprechung nicht absagen kann.",
      "allow_reschedule_tooltip": " Wenn diese Option aktiviert ist, wird ein Link zur Terminverschiebung dem Abschnitt für zusätzliche Notizen hinzugefügt und in die Kalendereinladung aufgenommen. Dieser Link läuft wie konfiguriert vor der Startzeit des Meetings ab und verhindert, dass der Buchende die Besprechung verschiebt.",
      "cancellation_link_expiry": "Der Link zur Absage läuft ab",
      "reschedule_link_expiry": "Der Link zur Terminverschiebung läuft ab",
      "before_meeting": "vor der Besprechung",
      "cancellation_and_reschedule_policy": "Stornierungs- und Umbuchungsrichtlinie:",
      "meeting_invite_notes": "Notizen zur Besprechungseinladung",
      "meeting_invite_notes_tooltip": "Fügen Sie Anmerkungen hinzu, die in der an Kunden gesendeten Kalendereinladung erscheinen. Diese Anmerkungen werden in der Besprechungsbeschreibung mit Drittanbieter-Kalendern synchronisiert."
    },
    "connections": {
      "connections_heading": "Externe Kalendersynchronisierung",
      "booking_channels_heading": "Buchungskanäle",
      "booking_channels_description": "Konfigurieren Sie, wie dieser Kalender Buchungen von externen Plattformen erhält.",
      "connections_sub": "Synchronisierung von Meetings mit externen Kalendern und verwalten Sie, wie Ereignisse gehandhabt werden.",
      "link_to_calendar": "Link zum Kalender",
      "sync_option": "Option „Synchronisieren“",
      "execute_automation": "Automatisierung ausführen",
      "fire_workflow": "Lösen Sie Arbeitsablauf-Auslöser für Ereignisse aus, die über die bidirektionale Synchronisierung gebucht wurden.",
      "reserve_with_google": "Mit Google reservieren [Veraltet]",
      "reserve_with_google_setup": "Anweisungen zur Einrichtung anzeigen",
      "reserve_with_google_configure": "Konfiguration",
      "change": "Ändern",
      "rwg_deprecation_notice": "Google hat <b>Reserve with Google (Local Services Ads)</b> eingestellt. Neue Verbindungen oder Änderungen an bestehenden Verbindungen werden nicht mehr unterstützt. Um weiterhin Buchungen von Google zu erhalten, nutzen Sie stattdessen <b>Google Organic Booking</b>.",
      "rwg_category": "Kategorie",
      "rwg_service_type": "Service",
      "connect_lsa": "Mit Ihrem Local Services Ads-Konto verbinden.",
      "reserve_error": "Derzeit wird Reserve bei Google nur für „Home Services“, „Real Estate“, „Legal Services“ (lokale Dienstleister) in den Vereinigten Staaten unterstützt.",
      "one_way": "Einweg",
      "two_way": "Zweiwege",
      "smart": "Intelligent",
      "confirm_remove": "Möchtest du den Google-Kalender wirklich entfernen?",
      "read_only_access": "Du hast keinen Schreibzugriff auf diesen Kalender. Bitte wähle einen anderen Kalender aus.",
      "reserve_with_google_desc": "Dieser Kalenderservice wird erst nach erfolgreicher Integration bei Google als Reserve aufgeführt.",
      "check_integration": "Überprüfe deinen Integrationsstatus",
      "setup_external": "Externen Kalender einrichten",
      "reserve_price_decimal_error": "Dezimalpreis wird nicht unterstützt.",
      "reserve_price_max_error": "Unterstützter Preis unter 1000.",
      "link_to_calendar_tooltip": "Wählen Sie den externen Kalender aus, mit dem die Besprechungen synchronisiert werden sollen. In den Kalendereinstellungen → Verbindungen verbundene Google-Kalender stehen zur Auswahl.",
      "one_way_sync": "Ein-Weg",
      "default_one_way": "Standardsynchronisierung (Ein-Weg-Synchronisierung)",
      "one_way_sync_desc": "Veranstaltungen aus dem verknüpften Kalender werden als blockierte Slots synchronisiert und es werden keine Kontakte für die Gäste erstellt.",
      "two_way_sync": "Zwei-Wege-Synchronisierung",
      "two_way_sync_desc": "Kontakte werden für Gäste erstellt, die in verknüpften Kalenderereignissen gefunden werden, und diese Ereignisse werden in Systemtermine umgewandelt.",
      "smart_sync": "Intelligente Synchronisierung",
      "smart_sync_desc": "Veranstaltungen aus dem verknüpften Kalender werden als Termine für bestehende Kontakte synchronisiert. Falls kein Kontakt existiert, werden sie als blockierte Slots synchronisiert, ohne dass ein neuer Kontakt erstellt wird.",
      "sync_option_tooltip": "Wählen Sie, wie Ereignisse aus dem externen Kalender gehandhabt werden:\n• Einweg: Blockiert Zeit in diesem Kalender, ohne {contactsLabel} zu erstellen\n• Zweiweg: Erstellt Besprechungen und {contactsLabel} aus externen Kalenderereignissen\n• Smart: Erstellt Besprechungen nur für bestehende {contactsLabel} und blockiert Zeit für andere.",
      "default_sync": "Standard",
      "default_sync_desc": "Synchronisiert Ereignisse von Ihrem externen Kalender mit diesem Kalender.",
      "advanced_sync": "Erweitert",
      "advanced_sync_desc": "Synchronisiert Veranstaltungen aus Ihrem externen Kalender mit diesem Kalender und erstellt Kontakte und Termine im System.",
      "assign_contact_to": "Kontakt zuordnen zu",
      "select_calendar": "Kalender auswählen",
      "sync_preferences": "Synchronisierungseinstellungen",
      "sync_preferences_desc": "Wie möchten Sie Ihre verknüpften Kalender-Veranstaltungen synchronisieren?",
      "recommended": "Empfohlen",
      "execute_automation_desc": "Automatisierung ausführen, wenn ein Termin in diesem Kalender erstellt wird.",
      "save": "Änderungen speichern",
      "cancel": "Abbrechen",
      "reserve_with_google_title": "Mit Google reservieren",
      "current_connection": "Derzeit aktive Verbindung :",
      "category": "Kategorie",
      "service": "Dienstart",
      "price": "Geschätzter Preis",
      "currency": "Währung",
      "client_portal_booking": "Buchung im Kundenportal",
      "client_portal_booking_description": "Erlauben Sie, dass dieser Kalender in der Buchungsliste des Kundenportals erscheint."
    },
    "booking_rules": {
      "booking_rules": "Buchungsregeln",
      "booking_rules_description": "Steuern Sie, wie und wann Besprechungen gebucht werden können."
    },
    "payments": {
      "payments": "Zahlungen",
      "payments_description": " Aktivieren und verwalten Sie Zahlungen, Regeln und Gebührenmodelle."
    },
    "extras": {
      "extras": "Anpassungen",
      "extras_sub": "Lege den Stil des Widgets und andere Einstellungen fest.",
      "calendar_widget_style": "Kalender-Widget-Stil",
      "neo": "Neu",
      "classic": "Klassisch",
      "insert_custom_code": "Benutzerdefinierten Code einfügen",
      "show_seats_per_slot": "Plätze pro Zeitfenster anzeigen",
      "allow_reschedule_meeting": "Verschieben von Besprechungen zulassen",
      "allow_cancelling_meeting": "Absagen von Besprechungen erlauben",
      "additional_notes": "Zusätzliche Hinweise",
      "cancellation_and_reschedule": "Absage und Verschiebung:",
      "allow_staff": "Mitarbeiterauswahl bei der Buchung zulassen",
      "code_block_tooltip": "Drittanbieter-Skripte innerhalb des HTML-Blocks können zwar leistungsstarke Funktionen bieten, bringen aber auch Risiken für Datenschutz, Sicherheit, Leistung und Seitenverhalten mit sich. Daher empfehlen wir, den Inhalt dieses Skripts zu überprüfen, bevor du es im Kalender speicherst.",
      "calendar_image": "Kalender-Titelbild",
      "remove_image": "Bild entfernen",
      "calendar_image_info": "Das hochgeladene Bild ist in der Gruppenansicht für die Neo-Vorlage sichtbar und erscheint nicht im individuellen Kalenderlink.",
      "get_image_from_unsplash": "Verbessere dein Bildmaterial mit",
      "unsplash": "Unsplash",
      "service_additional_preferences": "Zusätzliche Präferenzen konfigurieren",
      "service_image": "Titelbild des Service",
      "service_image_description": "Wähle ein Bild aus, das im Servicemenü für diesen Service angezeigt werden soll.",
      "allow_reschedule_appointment": "Terminverschiebung zulassen",
      "allow_cancelling_appointment": "Terminabsage zulassen",
      "custom_code_placeholder": "Bitte gib hier den benutzerdefinierten Code ein",
      "calendar_widget_style_desc": "Wähle zwischen unserem klassischen oder dem eleganten Neo-Widget.",
      "seats_per_slot": "Plätze pro Zeitfenster",
      "show_staff_selection": "Mitarbeiterauswahl",
      "seats_per_slot_desc": " Ermögliche Buchenden, die Anzahl der verfügbaren Plätze für jedes Zeitfenster direkt im Kalender-Widget zu sehen.",
      "show_staff_selection_desc": "Ermögliche Buchenden, bei der Terminbuchung einen Mitarbeiter direkt aus dem Kalender-Widget auszuwählen. Funktioniert nur mit Neo Widget.",
      "widget_re_order_tooltip": "Der klassische Widget-Stil erlaubt keine Änderungen der Widget-Reihenfolge. Stelle sicher, dass die Datums- und Uhrzeitauswahl an erster Stelle und das Formular an zweiter Stelle steht, bevor du den klassischen Stil auswählst.",
      "show_staff_selection_desc_service": "Ermögliche Buchenden, bei der Terminbuchung einen Mitarbeiter direkt aus dem Kalender-Widget auszuwählen.",
      "switch_to_classic_widget": "Zum klassischen Widget wechseln",
      "switch_to_classic_widget_desc": "Der Wechsel zum <b>klassischen Widget</b> wird automatisch die folgenden Einstellungen deaktivieren, da sie nicht gleichzeitig bestehen können:",
      "form_first_disabled": "<b>Das Formular wird in den ersten Schritt</b> in Widget Sortieren verschoben.",
      "appointment_preference_disabled": "<b>Neue Terminpräferenz (immer mit dem zugewiesenen Benutzer des {contactLabel} buchen)</b> wird deaktiviert. Das bedeutet, dass Termine mit jedem verfügbaren Gruppenmitglied gebucht werden können, anstatt auf den dem {contactLabel} zugewiesenen Benutzer beschränkt zu sein.",
      "multiple_location_disabled": "<b>Mehrere Konferenzen-Adresse</b> werden gelöscht, und nur der <b>zuerst hinzugefügte Standort</b> wird beibehalten.",
      "insert_custom_code_tooltip": "Passen Sie das Widget-Styling mit Ihrem eigenen CSS-Code an.",
      "classic_tooltip_disabled": "Das klassische Widget wird für Klassen-Buchungskalender nicht unterstützt.",
      "show_staff_selection_disabled_tooltip": "Die Mitarbeiterauswahl wird nur für das Neo-Widget unterstützt."
    },
    "roomsAndEquipments": {
      "title": "Wählen Sie Räume und Ausstattung",
      "description": "Wähle aus einer Liste von Räumen und Geräten aus, was zusammen mit diesem Kalender gebucht werden soll.",
      "rooms": "Räume auswählen",
      "equipments": "Geräte auswählen"
    }
  },
  "activity_log": {
    "activity_log": "Aktivitätsprotokoll",
    "date": "Datum",
    "filter_by": "Filtern nach",
    "calendar_update": "Kalenderaktualisierung",
    "start_time_update": "Aktualisierung der Startzeit",
    "end_time_update": "Aktualisierung der Endzeit",
    "title_update": "Aktualisierung des Titels",
    "notes_update": "Aktualisierung der Anmerkungen",
    "appointment_status_update": "Aktualisierung des Terminstatus",
    "meeting_location_update": "Aktualisierung des Treffpunkts",
    "google_sync_update": "Aktualisierung der Google-Synchronisierung",
    "outlook_sync_update": "Aktualisierung der Outlook-Synchronisierung",
    "assigned_user_update": "Aktualisierung des zugewiesenen Benutzers",
    "appointment_status": "Terminstatus",
    "assigned_user": "Zugewiesener Benutzer",
    "uploaded_to": "Hochgeladen nach",
    "cancelled": "Abgesagt",
    "edited": "bearbeitet",
    "other_edits": "Andere Bearbeitungen",
    "view_details": "Details anzeigen",
    "all": "Alle"
  },
  "appointment_list": {
    "group_all": "ALLE",
    "group_primary": "PRIMÄRE",
    "group_user": "BENUTZER",
    "group_team": "GRUPPEN",
    "group_calendar": "KALENDER",
    "all_appointments": "Alle Termine",
    "my_calendar": "Mein Kalender",
    "status_all": "Alle",
    "status_confirmed": "Bestätigt",
    "status_new": "Neu (Aktion erforderlich)",
    "status_show": "Erschienen",
    "status_no_show": "Nicht erschienen",
    "status_cancelled": "Abgesagt",
    "status_invalid": "Ungültig",
    "filter_date_added_desc": "Hinzugefügt am (absteigend)",
    "filter_start_added_desc": "Startdatum (absteigend)",
    "filter_start_added_asc": "Startdatum ab heute aufsteigend",
    "button_new_appointment": "Neuer Termin",
    "name": "Name",
    "title": "Titel",
    "requested_time": "Angeforderte Zeit",
    "date_added": "Hinzugefügt am",
    "calendar": "Kalender",
    "appointment_owner": "Termin-Eigentümer",
    "notes": "Notizen",
    "status": "Status",
    "action_view_detail": "Details anzeigen",
    "action_view_consent": "Einwilligung anzeigen",
    "action_view_notes": "Anmerkungen ansehen",
    "action_edit": "Bearbeiten",
    "action_delete": "Löschen",
    "action_reschedule": "Verschieben",
    "page_previous": "Vorherige",
    "page_next": "Nächste",
    "appointment_notes": "Termin-Anmerkungen",
    "close": "Schließen",
    "confirm_delete_header": "Termin löschen",
    "confirm_delete_message": "Bist du sicher, dass du diesen Termin löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden!",
    "confirm_delete_button": "Löschen",
    "confirm_update_header": "Terminstatus aktualisieren",
    "confirm_update_confirmed_message": "Bist du sicher, dass du diesen Termin als bestätigt markieren möchtest?",
    "confirm_update_invalid_message": "Bist du sicher, dass du diesen Termin als ungültig markieren möchtest?",
    "confirm_update_showed_message": "Bist du sicher, dass du diesen Termin als erschienen markieren möchtest?",
    "confirm_update_noshow_message": "Bist du sicher, dass du diesen Termin als nicht erschienen markieren möchtest?",
    "confirm_update_cancelled_message": "Bist du sicher, dass du diesen Termin als abgesagt markieren möchtest?",
    "confirm_update_button": "Aktualisierung",
    "empty_state_title": "Keine Termine gefunden",
    "empty_state_description": "Keine Termine gefunden.",
    "disable_menu_warning": "Sie sind nicht dazu berechtigt, die Termindetails anzuzeigen oder zu bearbeiten, da der zugehörige Kontakt Ihnen nicht zugeordnet ist. Wenden Sie sich an Ihren Admin, um Unterstützung zu erhalten.",
    "no_contact_warning": "Du kannst derzeit nicht auf die Kontaktinformationen zugreifen. Dies kann daran liegen, dass der Kontakt dir nicht zugewiesen ist. Bitte wende dich an deinen Administrator, um Hilfe zu erhalten.",
    "consent_label": "Einwilligung",
    "ip_address": "IP",
    "youre_viewing_in": "Wird derzeit angezeigt in",
    "appointment_delete_msg": "<b>Hinweis:</b> Der hier gelöschte Termin wird nicht aus Calendly entfernt.",
    "rescheduled": "Verschoben"
  },
  "add_guest": {
    "guest_label": "Gast/Gäste",
    "search_placeholder": "In Kontakten suchen",
    "add_new": "Neu hinzufügen",
    "save": "Speichern",
    "close": "Schließen",
    "name": "Name",
    "phone": "Telefon",
    "email": "E-Mail",
    "guest_label_count": "Anzahl Gast/Gäste",
    "guest_count_error": "Die Anzahl der Gäste sollte zwischen 1 und 100 liegen"
  },
  "languages": {
    "danish": "Danish",
    "dutch": "Dutch",
    "english": "English",
    "finnish": "Finnisch",
    "french": "French",
    "french_canada": "Französisch (Kanada)",
    "german": "German",
    "hungarian": "Hungarian",
    "italian": "Italian",
    "norwegian": "Norwegisch",
    "polish": "Polish",
    "portuguese_brazil": "Portuguese (Brazil)",
    "portuguese_portugal": "Portuguese (Portugal)",
    "spanish": "Spanish",
    "swedish": "Schwedisch",
    "turkish": "Türkisch"
  },
  "service_menu_advanced": {
    "new_service_menu_details_header": "Details zum Servicemenü",
    "select_groups_header": "Services auswählen",
    "arrange_groups_header": "Services anordnen",
    "new_service_menu": "Neues Servicemenü",
    "service_menu_sub_title": "Erstelle mit nur wenigen Klicks ein personalisiertes Servicemenü für deine Kunden",
    "quick_tip": "Du kannst Gruppen zum Servicemenü hinzufügen",
    "service_menu_name": "Name des Servicemenüs",
    "service_menu_description": "Beschreibung",
    "service_menu_slug": "Service-URL",
    "select_groups_calendars": "Gruppen und Kalender auswählen",
    "select_groups_calendars_desc": "Services zu deinem Servicemenü hinzufügen",
    "select_all": "Alles auswählen",
    "arrange_groups": "Reihenfolge der Services festlegen",
    "arrange_groups_desc": "Reihenfolge der Services im Servicemenü festlegen",
    "arrange_services_quicktip": "Um Kalender innerhalb einer Gruppe neu anzuordnen, gehe zu Gruppen > Optionen > Kalender neu anordnen.",
    "enable_add_guest_desc": "Ermöglicht es Kunden, bei der Buchung zusätzliche Gäste hinzuzufügen.",
    "enable_multiple_service_desc": "Ermöglicht es Kunden, mehrere Services in einem einzigen Termin zu buchen.",
    "enable_staff_selection_desc": "Ermöglicht es Kunden, bei der Buchung bevorzugte Mitarbeiter auszuwählen.",
    "enable_add_guest": "Aktivieren Sie das Hinzufügen von Gästen",
    "enable_multiple_service": "Mehrere Dienste aktivieren",
    "enable_staff_selection": "Mitarbeiterauswahl aktivieren",
    "additional_options": "Zusätzliche Optionen",
    "code_block_tooltip": "Drittanbieter-Skripte innerhalb des HTML-Blocks können zwar leistungsstarke Funktionen bieten, bringen aber auch Risiken für Datenschutz, Sicherheit, Leistung und Seitenverhalten mit sich. Daher empfehlen wir, den Inhalt dieses Skripts zu überprüfen, bevor du es im Kalender speicherst.",
    "custom_code_placeholder": "Bitte gib hier den benutzerdefinierten Code ein",
    "insert_custom_code": "Benutzerdefinierten Code einfügen",
    "no_service": "Keinen Service gefunden",
    "no_service_desc": " Keine Services gefunden. Erstelle Services und füge sie zu Gruppen hinzu, um ein Servicemenü zu erstellen.",
    "learn_more": "Mehr erfahren",
    "no_service_selected": "Kein Service ausgewählt",
    "create_service_calendars": "Servicekalender erstellen",
    "alert_description": " Um ein Servicemenü zu erstellen, musst du Service-Kalender erstellen und diese zu Gruppen hinzufügen.",
    "dont_show_again": "Diese Nachricht nicht mehr anzeigen",
    "service_name_required": "Der Name des Servicemenüs ist erforderlich",
    "slug_already_taken": "Dieser URL-Teil ist bereits vergeben",
    "slug_required": "URL-Teil ist erforderlich",
    "please_enter_name": "Bitte gib einen Namen ein",
    "service_name_placeholder": "Hauptmenü",
    "service_slug_placeholder": "Hauptmenü",
    "form_label": "Formular",
    "consent_label": "Kontrollkästchen „Einwilligung“",
    "consent_input_placeholder": "Einwilligungstext hinzufügen",
    "consent_tooltip": "Aktiviere diese Option, um die Genehmigung von {contactsLabel} einzuholen, wenn sie ihre Rufnummer während des Terminbuchungsprozesses angeben.",
    "back_message": "Zurück zur Liste",
    "saving_changes": "Nur eine Minute – Speichern Sie das neueste Dynamisch...",
    "payment_provider_warning": "Achtung! Service-Menüs unterstützen zur Zeit nur Zahlungen über Stripe und Authorize.net. Da Ihr Standardanbieter abweicht, wird die Zahlungserfassung für ausgewählte Kalender, in denen Zahlungen aktiviert sind, übersprungen.",
    "aria": {
      "consent_form_toggle": "Umschaltung der Einwilligungserklärung",
      "enable_add_guest_toggle": "Umschaltung „Gast hinzufügen“ aktivieren",
      "enable_multiple_services_toggle": "Umschaltung für mehrere Dienste aktivieren",
      "enable_staff_selection_toggle": "Umschaltung für die Mitarbeiterauswahl aktivieren"
    }
  },
  "widget_configuration": {
    "customise_calendar_widget": "Kalender-Widget anpassen",
    "works_with_neo_widget": "Funktioniert nur mit Neo Widget",
    "customise_widget_desc": "Passe das Aussehen des Widgets an: Grundfarbe, Hintergrundfarbe und Schaltflächentext.",
    "learn_more": "Mehr erfahren",
    "primary_settings": "Primäre Einstellungen",
    "primary_settings_desc": "Konfiguriere die Primärfarbe, Hintergrundfarbe und andere Widget-Einstellungen, um dein Kalender-Widget anzupassen.",
    "primary_color": "Primärfarbe",
    "primary_color_desc": "Definiere die Farbe für Schaltflächen, Daten, Zeitfenster und Aktionen.",
    "background_color": "Hintergrundfarbe",
    "background_color_desc": "Lege die Hintergrundfarbe fest, die als Hintergrund für die Datums-/Uhrzeitauswahl und das Formular dient.",
    "button_text": "Schaltflächentext",
    "button_text_desc": "Passe den Text an, der bei der Terminbuchung auf der Schaltfläche angezeigt wird.",
    "calendar_title": "Kalendertitel",
    "calendar_title_desc": "Der Name deines Kalenders",
    "calendar_description": "Kalenderbeschreibung",
    "calendar_description_desc": "Die eingegebene Beschreibung.",
    "calendar_details": "Kalenderdetails",
    "calendar_details_desc": "Enthält Informationen wie Dauer, Datum und Uhrzeit, wiederkehrende Details und Zeitzone.",
    "reset_to_default": "Auf Standard zurücksetzen",
    "preview_widget": "Vorschau-Widget",
    "calendar_title_tooltip": "Legen Sie fest, ob der Kalendername und der Gruppenname (falls zutreffend) im Buchungs-Widget sichtbar sein sollen.",
    "calendar_description_tooltip": "Legen Sie fest, ob die Kalenderbeschreibung im Buchungs-Widget sichtbar sein soll.",
    "calendar_details_tooltip": "Sammlung Falls die Schlüssel- Besprechungen Details wie Konferenzen Dauer, Ausgewähltes Datum & Datum und Wiederholungsinformationen (Falls anwendbar) sollten am Booking Widget sichtbar sein.",
    "insert_custom_code_tooltip": "Anpassen des Widget -Stylings über Ihren eigenen CSS Code.",
    "staff_selection_tooltip": "Aktiviere Booker , um einen Mitarbeiter Mitglieder direkt aus dem Kalender Widget bei der Terminbuchung auszuwählen. Funktioniert nur mit Neo Widget."
  },
  "eventNotification": {
    "customFields": "Benutzerdefinierte Felder",
    "customValues": "Benutzerdefinierte Werte",
    "templateVariableIssueDefaultPartBefore": "Es gibt Probleme mit Ihrem ",
    "templateVariableIssueDefaultPartHighlight": "benutzerdefinierte Werte",
    "templateVariableIssueDefaultPartAfter": "; bitte überprüfen und korrigieren Sie diese vor dem Speichern.",
    "templateVariableInvalidListOverflow": "… und {count} weitere",
    "templateVariableIssueSingle": "Es gibt ein Problem mit diesem benutzerdefinierten Wert: {value}; bitte korrigieren Sie ihn vor dem Speichern.",
    "templateVariableIssueEmpty": "Mindestens ein benutzerdefinierter Wert ist leer ({emptyPair}); bitte fügen Sie ein gültiges Feld in die Klammern ein.",
    "templateVariableIssueMarkup": "Einige benutzerdefinierte Werte enthalten HTML oder Formatierungen, die nicht unterstützt werden; bitte entfernen Sie sie vor dem Speichern.",
    "guest": "Gast",
    "assignedUser": "Zugewiesener Benutzer",
    "additionalEmails": "Zusätzliche E-Mails",
    "list": {
      "booked": {
        "title": "Termin gebucht (Status: unbestätigt)",
        "modalTitle": "Termin gebucht (Status: unbestätigt)",
        "note": "Diese Benachrichtigung wird gesendet, wenn ein neuer Termin mit nicht bestätigtem Status erstellt wird.",
        "subTitle": "Benachrichtigt, wenn ein Termin mit unbestätigtem Status gebucht wird."
      },
      "confirmation": {
        "title": "Termin gebucht (Status: bestätigt)",
        "modalTitle": "Termin gebucht (Status: bestätigt)",
        "note": "Diese Benachrichtigung wird gesendet, wenn ein Termin mit oder aktualisiert zum Bestätigt Status erstellt wird.",
        "subTitle": "Benachrichtigt, wenn ein Termin erfolgreich bestätigt wird."
      },
      "cancellation": {
        "title": "Absage",
        "modalTitle": "Stornierung",
        "note": "Diese Benachrichtigung wird gesendet, wenn ein Termin abgesagt, als Nichterscheinen, oder als Ungültig markiert wird.",
        "subTitle": "Benachrichtigungen, wenn ein Termin abgesagt wird."
      },
      "reschedule": {
        "title": "Verschieben",
        "modalTitle": "neu planen",
        "note": "Diese Benachrichtigung wird gesendet, wenn ein Termin verschoben wird. Sie wird nur ausgelöst, wenn sich der Termin in Status„Nicht bestätigt“ oder „Bestätigt“ befindet.",
        "subTitle": "Benachrichtigt, wenn ein Termin verschoben wird."
      },
      "reminder": {
        "title": "Erinnerung",
        "modalTitle": "Erinnerung",
        "note": "Diese Benachrichtigung wird als Erinnerung vor dem Termin gesendet. Sie wird nur ausgelöst, wenn sich der Termin in Status„Nicht bestätigt“ oder „Bestätigt“ befindet.",
        "subTitle": "Sendet eine Erinnerung vor dem Termin."
      },
      "followup": {
        "title": "Follow-up",
        "modalTitle": "Follow-up",
        "note": "Diese Benachrichtigung wird später dem Termin als Follow-up gesendet. Sie wird nur ausgelöst, wenn sich der Termin in Status„Nicht bestätigt“, „Bestätigt“ oder „Erschienen“ befindet.",
        "subTitle": "Sendet nach Abschluss des Termins eine Follow-up-Nachricht."
      }
    },
    "saveToastMsg": "Einstellungen gespeichert!",
    "saveToastMsgDesc": "Deine Änderungen wurden erfolgreich gespeichert.",
    "enableSuccess": "Benachrichtigungen aktiviert!",
    "disableSuccess": "Benachrichtigungen deaktiviert!",
    "tooltip": "Diese Benachrichtigung wurde deaktiviert. Bitte aktivieren Sie es, um ein Dynamisch zu erstellen.",
    "enabled": "Aktiviert",
    "disabled": "Deaktiviert",
    "statusLabel": "Statusbeschriftungen",
    "email": {
      "channelName": "E-Mail",
      "noneTemplate": "Keine",
      "notificationLabel": "Wer soll diese Benachrichtigung erhalten?",
      "sendButtonLabel": "Test-E-Mail senden",
      "testEmailLabel": "Test-E-Mail",
      "testEmailPlaceholder": "Gib die E-Mail-Adresse des Empfängers für den Test ein",
      "body": "E-Mail-Textkörper",
      "bodyPlaceholder": "Gib hier deine Nachricht ein",
      "subject": "Betreff",
      "subjectPlaceholder": "Gib den Betreff der E-Mail ein",
      "templateLabel": "E-Mail-Vorlage",
      "templatePlaceholder": "Wähle eine E-Mail-Vorlage oder beginne neu",
      "fromNamePlaceholder": "Namen eingeben",
      "fromNameLabel": "Absendername",
      "fromAddressLabel": "Absenderadresse",
      "alertEmailAddress": "E-Mail-IDs eingeben (durch Kommas getrennt)",
      "addMore": "Mehr hinzufügen",
      "afterAppointmentEnds": "nach Beendigung des Termins",
      "beforeAppointmentStarts": "bevor der Termin beginnt",
      "durationLabel": "Wann möchtest du die Benachrichtigung auslösen?",
      "disableEmailNotification": "E-Mail-Benachrichtigungen deaktivieren",
      "enableEmailNotification": "E-Mail-Benachrichtigungen aktivieren",
      "enableSuccess": "E-Mail-Benachrichtigung aktiviert!",
      "enableSuccessDesc": "Du wirst nun diese Benachrichtigung erhalten",
      "disableSuccess": "E-Mail-Benachrichtigung deaktiviert!",
      "disableSuccessDesc": "Du wirst diese Benachrichtigung nicht mehr erhalten",
      "reset_to_default": "Auf Standard Zurücksetzen",
      "testEmailSuccessTitle": "Test-E-Mail gesendet!",
      "testEmailSuccessDesc": "Test E-Mail wurde erfolgreich an {email}gesendet",
      "testEmailErrorTitle": "Das Hochladen der Test-E-Mail ist fehlgeschlagen",
      "testEmailErrorDesc": "Beim Senden der Test-E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "create_new_email_template": "Neue E-Mail-Vorlage erstellen",
      "templateVariableFieldSubject": "Betreffzeile",
      "templateVariableFieldFromName": "Absendername",
      "templateVariableFieldFromAddress": "Absenderadresse",
      "templateVariableFieldEmailBody": "E-Mail-Textkörper"
    },
    "inApp": {
      "channelName": "in-app",
      "title": "Benachrichtigungseinstellungen",
      "enableInAppNotification": "In-App-Benachrichtigung aktivieren",
      "disableInAppNotification": "In-App-Benachrichtigung deaktivieren",
      "selectedUser": {
        "label": "Senden an",
        "helperText": "Diese interne Benachrichtigung wird über das Web und die mobilen Apps gesendet.",
        "placeholder": "Benutzer auswählen"
      },
      "enableSuccess": "In-App-Benachrichtigungen aktiviert!",
      "enableSuccessDesc": "Du wirst ab jetzt diese Benachrichtigung erhalten.",
      "disableSuccess": "In-App-Benachrichtigungen deaktiviert!",
      "disableSuccessDesc": "Du wirst diese Benachrichtigung nicht mehr erhalten."
    },
    "sms": {
      "channelName": "SMS",
      "noneTemplate": "Keine",
      "notificationLabel": "Wer soll diese Benachrichtigung erhalten?",
      "sendButtonLabel": "Test-SMS senden",
      "testSMSLabel": "Test-SMS (geben Sie die Telefonnummer mit Landesvorwahl ein)",
      "testSMSPlaceholder": "+12345678901",
      "body": "SMS-Nachricht",
      "bodyPlaceholder": "Gib hier deine SMS-Nachricht ein",
      "durationLabel": "Wann möchtest du die Benachrichtigung auslösen?",
      "disableSMSNotification": "SMS-Benachrichtigungen deaktivieren",
      "enableSMSNotification": "SMS-Benachrichtigungen aktivieren",
      "enableSuccess": "SMS-Benachrichtigung aktiviert!",
      "enableSuccessDesc": "Du wirst ab jetzt diese Benachrichtigung erhalten.",
      "disableSuccess": "SMS-Benachrichtigung deaktiviert!",
      "disableSuccessDesc": "Du wirst diese Benachrichtigung nicht mehr erhalten.",
      "alertPhoneNumbers": "Telefonnummern eingeben (mit Ländervorwahlen, durch Kommas getrennt)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Mehr hinzufügen",
      "afterAppointmentEnds": "nach Ende des Termins",
      "beforeAppointmentStarts": "bevor der Termin beginnt",
      "templateLabel": "SMS-Vorlage",
      "templatePlaceholder": "SMS-Vorlage auswählen...",
      "reset_to_default": "Auf Standard zurücksetzen",
      "testSmsSuccessTitle": "Test-SMS gesendet!",
      "testSmsSuccessDesc": "Test-SMS wurde erfolgreich an {phone}gesendet.",
      "testSmsErrorTitle": "Senden der Test-SMS fehlgeschlagen",
      "testSmsErrorDesc": "Beim Senden der Test-SMS ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "templateVariableFieldSmsBody": "Nachrichten-Textkörper"
    },
    "whatsapp": {
      "channelName": "WhatsApp",
      "notificationLabel": "Wer soll diese Benachrichtigung erhalten?",
      "sendButtonLabel": "Test-WhatsApp-Benachrichtigung senden",
      "testWhatsAppLabel": "Testen Sie die WhatsApp Push-Benachrichtigung (Rufnummer mit Ländercode eingeben)",
      "testWhatsAppPlaceholder": "+12345678901",
      "durationLabel": "Wann möchtest du die Benachrichtigung auslösen?",
      "alertPhoneNumbers": "Telefonnummern eingeben (mit Ländervorwahlen, via Kommas getrennt)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Mehr hinzufügen",
      "afterAppointmentEnds": "nach Ende des Termins",
      "beforeAppointmentStarts": "bevor der Termin beginnt",
      "templateLabel": "WhatsApp-Vorlage",
      "templatePlaceholder": "Wählen Sie eine WhatsApp-Vorlage aus...",
      "noPreview": "Keine Vorlage ausgewählt",
      "templateRequired": "Vorlage erforderlich",
      "testWhatsAppSuccessTitle": "Test WhatsApp Push-Benachrichtigung gesendet!",
      "testWhatsAppSuccessDesc": "Test WhatsApp Push-Benachrichtigung wurde erfolgreich an {phone} gesendet.",
      "testWhatsAppErrorTitle": "Die WhatsApp-Testbenachrichtigung konnte nicht gesendet werden.",
      "testWhatsAppErrorDesc": "Beim Senden der Test-WhatsApp-Benachrichtigung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "setupTitle": "Kontaktieren Sie Ihre Kunden über ihre bevorzugte Messaging-App.",
      "setupDescription": "Bleiben Sie näher an Ihren Kunden, indem Sie sofortigen Support bieten, zeitnahe Updates senden und ansprechende Interaktionen schaffen.",
      "connectWhatsApp": "WhatsApp verbinden",
      "checkingStatus": "Überprüfung des WhatsApp-Kontostatus...",
      "checkingTemplateStatus": "Überprüfung des Status der WhatsApp-Vorlage...",
      "statusCheckError": "Überprüfung des WhatsApp-Kontostatus fehlgeschlagen.",
      "templateStatusCheckError": "Der Status der WhatsApp-Vorlage konnte nicht überprüft werden.",
      "setupTemplateTitle": "Schließen Sie die Einrichtung Ihrer WhatsApp-Vorlage ab.",
      "setupTemplateDescription": "Sie müssen WhatsApp-Vorlagen Konfiguration, Vorher Sie Benachrichtigungen Upload können. Klicken Sie unten, um den Einrichtungsvorgang abzuschließen.",
      "loadTemplatesError": "WhatsApp-Vorlagen konnten nicht geladen werden.",
      "templatesRefreshed": "Vorlagen erfolgreich aktualisiert",
      "templatesRefreshError": "Vorlagen konnten nicht aktualisiert werden.",
      "templatesResolveError": "Fehlgeschlagen beim Auflösen von WhatsApp-Standardvorlagen.",
      "locationNotFound": "Standort-ID wurde nicht gefunden.",
      "settingsRedirectError": "Es kann nicht zu den WhatsApp-Einstellungen weitergeleitet werden.",
      "updateNotificationError": "WhatsApp Push-Benachrichtigung konnte nicht aktualisiert werden.",
      "notificationsEnabled": "WhatsApp-Benachrichtigungen sind aktiviert!",
      "notificationsDisabled": "WhatsApp-Benachrichtigungen deaktiviert!",
      "updateError": "Fehler beim Aktualisieren der Benachrichtigungen.",
      "createNewTemplate": "Neue WhatsApp-Vorlage erstellen",
      "phoneValidation": {
        "countryCodeRequired": "Die Rufnummer muss mit einer Landesvorwahl beginnen (z. B. +1, +91, +44)",
        "digitsOnly": "Die Rufnummer darf nur Ziffern nach der Landeskennzahl enthalten.",
        "tooShort": "Die Rufnummer ist zu kurz.",
        "tooLong": "Die Rufnummer ist zu lang.",
        "invalid": "Ungültige Telefonnummer."
      },
      "errors": {
        "templateNotFound": "Vorlage-ID in den geladenen Optionen nicht gefunden, wird gelöscht.",
        "templateNoLongerValid": "Gespeicherte Vorlage ist nicht mehr gültig, wird gelöscht.",
        "invalidTemplateSelection": "Es wurde versucht, eine ungültige WhatsApp-Vorlage auszuwählen.",
        "fetchingTemplates": "Fehler beim Abrufen von WhatsApp-Vorlagen.",
        "mountingCreator": "Fehlgeschlagen beim Mounten des WhatsApp-Vorlagenerstellers.",
        "fetchingAfterCreation": "Fehler beim Abrufen der WhatsApp-Vorlagen nach der Erstellung.",
        "updateStatus": "Fehler beim Aktualisieren des WhatsApp-Status."
      },
      "receiverLabels": {
        "assignedUser": "Zugewiesener Benutzer",
        "phoneNumbers": "Zusätzliche Rufnummern"
      }
    },
    "templateVariableIssueDefaultPartBefore": "Es gibt Probleme mit Ihrem ",
    "templateVariableIssueDefaultPartHighlight": "benutzerdefinierte Werte",
    "templateVariableIssueDefaultPartAfter": "; bitte überprüfen und korrigieren Sie diese vor dem Speichern.",
    "templateVariableInvalidListOverflow": "… und {count} weitere",
    "templateVariableIssueSingle": "Es gibt ein Problem mit diesem benutzerdefinierten Wert: {value}; bitte korrigieren Sie ihn vor dem Speichern.",
    "templateVariableIssueEmpty": "Mindestens ein benutzerdefinierter Wert ist leer ({emptyPair}); bitte fügen Sie ein gültiges Feld in die Klammern ein.",
    "templateVariableIssueMarkup": "Einige benutzerdefinierte Werte enthalten HTML oder Formatierungen, die nicht unterstützt werden; bitte entfernen Sie sie vor dem Speichern.",
    "templateVariableSaveFailed": "{receiverLabel}-Benachrichtigung konnte nicht gespeichert werden. Bitte beheben Sie die Fehler bei den benutzerdefinierten Werten, bevor Sie speichern.",
    "templateVariableSaveFailedGeneric": "Die Benachrichtigung konnte nicht gespeichert werden. Bitte beheben Sie die Fehler bei den benutzerdefinierten Werten, bevor Sie speichern."
  },
  "smsTemplate": {
    "create_new_template": "Neue SMS-Vorlage erstellen",
    "create_new_template_desc": "Erstellen Sie eine wiederverwendbare SMS-Vorlage für Ihre Benachrichtigungen.",
    "template_name": "Vorlagenname",
    "template_name_placeholder": "Vorlagennamen eingeben",
    "message": "Nachricht",
    "message_placeholder": "Gib hier deine SMS-Nachricht ein.",
    "create_template": "Vorlage erstellen",
    "name_required": "Vorlagenname ist erforderlich",
    "text_required": "Nachrichtentext ist erforderlich",
    "fetch_new_templates": "Vorlagen aktualisieren",
    "characters": "Zeichen",
    "words": "Wörter",
    "segments": "Segmente"
  },
  "whatsappTemplate": {
    "create_new_template": "Neue WhatsApp-Vorlage erstellen",
    "create_new_template_desc": "Erstellen Sie eine wiederverwendbare WhatsApp-Vorlage für Ihre Benachrichtigungen.",
    "template_name": "Vorlagenname",
    "template_name_placeholder": "Vorlagennamen eingeben",
    "message": "Nachricht",
    "message_placeholder": "Gib hier deine WhatsApp-Nachricht ein.",
    "create_template": "Vorlage erstellen",
    "name_required": "Vorlagenname ist erforderlich",
    "text_required": "Nachrichtentext ist erforderlich",
    "fetch_new_templates": "Vorlagen aktualisieren"
  },
  "archivedServices": {
    "servicesBanner": "Eine neue, verbesserte Version der Dienste ist hier—leistungsstärker, flexibler und intuitiver. Ihre Servicekalender wurden bereits migriert. Erkunden Sie sie jetzt auf der Registerkarte Dienste.",
    "archivedServiceCalendars": "Servicekalender (v1)",
    "check_new_services": "Neue Services prüfen"
  },
  "tour": {
    "hidden_test_label": "Test",
    "calendar": {
      "edit_calendar": "Kalender bearbeiten",
      "share_calendar": "Kalender teilen",
      "troubleshoot_calendar": "Problembehandlung für Kalender",
      "more_options": "Mehr Optionen",
      "edit_calendar_desc": "Verwalten Sie alle Kalendereinstellungen – Fest Verfügbarkeit, Konfigurationserinnerung, Terminlimits und mehr.",
      "share_calendar_desc": "Kopieren und teilen Sie Ihren Link zur Terminplanung, damit Booker leicht mit Ihnen planen kann.",
      "troubleshoot_calendar_desc": "Finden Sie heraus, warum ein Slot nicht angezeigt wird, und sehen Sie sich mögliche Gründe in der Fehlerbehebungsansicht an.",
      "more_options_desc": "Zugriff auf zusätzliche Einstellungen und Aktivitäten, um deinen Kalender zu verwalten.",
      "read_permissions": {
        "share_description": "Gewähren Sie anderen Zugriff, indem Sie den Kalenderlink freigeben oder die Berechtigungen anpassen.",
        "troubleshoot_description": "Identifizieren und beheben Sie Probleme wie Synchronisierungsfehler oder fehlende Ereignisse für eine reibungslose Funktionalität."
      },
      "next": "Nächste",
      "start_over": "Erneut beginnen",
      "all_set": "Alles bereit!",
      "previous": "Vorherige"
    }
  },
  "emailTemplate": {
    "select_editing_experience": "Wähle deine Bearbeitungserfahrung",
    "select_editing_experience_desc": "Wählen Sie, ob Sie mit unserem visuellen Drag-and-Drop-Design-Editor oder dem leistungsstarken Code-Editor bauen möchten.",
    "design_editor": "Design-Editor",
    "design_editor_desc": "Visuelle Bearbeitung per Drag & Drop.",
    "code_editor": "Code-Editor",
    "code_editor_desc": "Funktionsreiche HTML-Bearbeitung.",
    "text_editor": "Texteditor",
    "text_editor_desc": "Einfache, saubere, schnörkellose Textbearbeitung.",
    "email_text_block": "E-Mail kann auch über Textkörper- Blockieren erstellt werden. ",
    "select": "Auswählen",
    "new_template": "Neue Vorlage",
    "email_block": "E-Mails können auch mit einem Textblock erstellt werden.",
    "fetch_new_templates": "Neue Vorlagen abrufen"
  },
  "quick_tips": {
    "meeting_details": {
      "clear_name_and_description": "Verwenden Sie einen klaren Besprechungsnamen und eine Beschreibung, damit die Buchenden genau wissen, was sie terminieren.",
      "groups_share_link": "Gruppen ermöglichen es Ihnen, einen einzigen Link zur Terminplanung für mehrere Kalender freizugeben, sodass Kunden aus den verfügbaren Optionen wählen und buchen können."
    },
    "staff_location": {
      "custom_location": "Wählen Sie „Benutzerdefiniert“ als Besprechungsstandort, um eine beliebige Adresse oder einen Link Ihrer Wahl einzugeben.",
      "ask_booker_location": "Wenn die Option 'Fragen Sie den Booker' ausgewählt ist, wird der Booker aufgefordert, den Standort des Meetings während der Buchung einzugeben.",
      "round_robin_priority": "Prioritätseinstellungen beeinflussen, wie Besprechungen verteilt werden, wenn mehrere Mitarbeiter verfügbar sind.",
      "connect_video_integrations": "Verbinden Sie Videokonferenz-Integrationen in den Kalendereinstellungen → Verbindungen, bevor Sie sie als Besprechungsort auswählen."
    },
    "availability": {
      "staff_availability_required": "Besprechungen können nur gebucht werden, wenn mindestens ein ausgewähltes Teammitglied verfügbar ist.",
      "use_precreated_schedule": "Sie können einen vorab erstellten Verfügbarkeits-Zeitplan aus den Kalendereinstellungen → Verfügbarkeit verwenden oder einen benutzerdefinierten Zeitplan nur für diesen Kalender erstellen.",
      "timezone_in_schedule": "Die Zeitzone für Besprechungen wird im ausgewählten Verfügbarkeitszeitplan festgelegt.",
      "event_24_hours": "Damit der Kalender 24 Stunden verfügbar ist, stellen Sie den Zeitraum von 00:00 bis 00:00 Uhr ein."
    },
    "booking_rules": {
      "apply_to_all_meetings": "Buchungsregeln gelten für alle Besprechungen in diesem Kalender, unabhängig von der Verfügbarkeit des Personals.",
      "minimum_scheduling_notice": "Erhöhen Sie die Mindestvorlaufzeit, um Last-Minute-Buchungen zu verhindern.",
      "maximum_bookings_per_slot": "Verwenden Sie die maximale Anzahl von Buchungen pro Zeitfenster, um zu steuern, wie viele Besprechungen gleichzeitig stattfinden können."
    },
    "forms": {
      "custom_contact_fields": "Sie können benutzerdefinierte Kontaktfelder sowohl in Formularnachrichten als auch in Formular-URLs einfügen.",
      "create_custom_form": "Um mehr Informationen zu sammeln, erstellen Sie ein benutzerdefiniertes Formular über Sites → Formulare → Builder und verwenden Sie es mit diesem Kalender."
    },
    "payments": {
      "collected_during_booking": "Bezahlungen werden während der Buchung eingezogen und müssen abgeschlossen sein, bevor das Meeting bestätigt wird.",
      "payment_description": "Erläutern Sie anhand der Bezahlungsbeschreibung deutlich, wofür die Gebühr gilt."
    },
    "notifications": {
      "review_policies": "Überprüfen Sie die Stornierungs- und Umbuchungsrichtlinien, um Änderungen in letzter Minute zu vermeiden.",
      "use_workflows": "Für fortgeschrittene Automatisierung verwenden Sie Workflows mit dem Auslöser „Termin gebucht“."
    },
    "customizations": {
      "preview_widget": "Überprüfen Sie das Widget in der Vorschau, um sicherzustellen, dass es mit Ihrer Marke und Ihrem Buchungsablauf übereinstimmt.",
      "update_widget_language": "Die Spracheinstellungen für das Widget können in den Einstellungen → Kalender → Präferenzen geändert werden."
    },
    "connections": {
      "google_organic_booking": "Die Einrichtung von Google Organic Booking ermöglicht es diesem Kalender, Buchungen direkt von der Google-Suche zu empfangen.",
      "external_sync_event": "Nur der unter Externe Synchronisierung ausgewählte Kalender wird zum Abrufen und Übertragen von Ereignissen für diesen Kalender verwendet."
    },
    "equipments": {
      "room_definition": "Ein „Raum“ kann jeden Ort darstellen, an dem Dienstleistungen erbracht werden. Dies können physische Räume und/oder dedizierte Stationen sein. Beispiel: Pediküre-Station.",
      "equipment_definition": "Stellen Sie sich unter „Geräte“ jedes Werkzeug oder Gerät vor, das Unternehmen zur Erfüllung von Terminen verwenden. Dies können Maschinen, Geräte oder auch Stühle sein."
    }
  },
  "aria_labels": {
    "sticky_contacts": "Sticky-Kontakte",
    "consent_form": "Einwilligungsformular",
    "enable_guests": "Gäste aktivieren",
    "auto_confirm": "Automatische Bestätigung",
    "should_accept_payment": "Sollte Zahlung akzeptieren",
    "collect_deposit": "Anzahlung einziehen",
    "enable_charge_guests": "Aktivieren Sie Gebühren für Gäste",
    "enable_coupon": "Coupon aktivieren",
    "payment_live": "Bezahlung Live",
    "add_availability_hour": "Verfügbare Stunde hinzufügen",
    "remove_availability_hour": "Verfügbare Stunde entfernen",
    "copy_availability_hour": "Verfügbarkeit kopieren",
    "close_modal": "Modal schließen",
    "add_custom_slot": "Benutzerdefinierten Slot hinzufügen",
    "remove_custom_slot": "Benutzerdefiniertes Zeitfenster entfernen",
    "edit_custom_slot": "Individuellen Slot bearbeiten",
    "update_frequency": "Aktualisierungshäufigkeit",
    "show_calendar_title": "Kalendertitel anzeigen",
    "show_calendar_description": "Kalenderbeschreibung anzeigen.",
    "show_calendar_details": "Kalenderdetails anzeigen",
    "allow_reschedule": "Terminverschiebung zulassen",
    "allow_cancellation": "Absage zulassen",
    "category_actions": "Kategorie-Aktivitäten",
    "show_seats_per_slot": "Plätze pro Zeitfenster anzeigen",
    "add_more": "Mehr hinzufügen",
    "same_user_assignment_toggle": "Umschalter für gleiche Benutzerzuweisung"
  },
  "placeholders": {
    "pixel_id": "Pixel ID",
    "select_one": "Eine Option auswählen",
    "meeting_location": "Standort des Meetings",
    "schedule_meeting": "Termin vereinbaren",
    "notes": "Notizen",
    "select_users": "Nutzer auswählen",
    "please_select": "Bitte auswählen"
  },
  "alt_text": {
    "payment_provider": "Zahlungsanbieter",
    "no_calendars": "Keine Kalender",
    "date_specific_hours": "datumsspezifische Stunden",
    "custom_widget_image": "Benutzerdefiniertes Widget-Bild",
    "service_calendar": "Servicekalender",
    "event_calendar": "Veranstaltungskalender",
    "round_robin_booking": "Round-Robin-Buchung",
    "class_booking": "Kursbuchung",
    "collective_booking": "Sammelbuchung",
    "calendar_cover_image": "Kalender-Titelbild",
    "email_notification_switch": "E-Mail-Benachrichtigungsschalter",
    "email_template_icon": "E-Mail-Vorlagen-Symbol",
    "in_app_notification_switch": "In-App-Benachrichtigungsschalter",
    "sms_notification_switch": "SMS-Benachrichtigungsschalter",
    "whatsapp_notification_switch": "WhatsApp-Benachrichtigungsschalter",
    "no_service_found": "Keinen Service gefunden",
    "no_group_found": "Keine Gruppen gefunden",
    "sync_icon": "Synchronisierungssymbol",
    "sync_type": "Synchronisierungstyp",
    "test1": "test1",
    "test2": "test2"
  },
  "tooltips": {
    "text_color": "Textfarbe",
    "background_color": "Hintergrundfarbe",
    "strikethrough": "Durchgestrichen",
    "superscript": "Hochgestellt",
    "subscript": "Tiefgestellt",
    "inline_code_block": "Inline-Code-Block",
    "code_block": "Codeblock",
    "block_quote": "Blockzitat",
    "more": "Mehr",
    "upload": "Upload",
    "image_upload_tooltip": "PNG, JPEG, JPG oder GIF (max. Abmessungen 180x180px | max. Größe 2,5 MB).",
    "custom_values": "Benutzerdefinierte Werte",
    "text_wrap": "Textumbruch",
    "trigger_links": "Trigger-Links",
    "text_align": "Textausrichtung"
  },
  "labels": {
    "reset_style": "Stil zurücksetzen",
    "reset_document_style": "Dokumentenstil zurücksetzen",
    "source_code": "Quellcode",
    "success": "Erfolg",
    "edit": "Bearbeiten",
    "submit": "Speichern",
    "cancel": "Abbrechen",
    "payment": "Zahlung",
    "here_is_the_link": "Hier ist der Link:",
    "here_is_the_embed_code": "Hier ist der Einbettungscode:",
    "service_calendar": "Servicekalender",
    "collective_booking": "Sammelbuchung",
    "class_booking": "Kursbuchung",
    "round_robin_booking": "Round-Robin-Buchung",
    "event_calendar": "Veranstaltungskalender",
    "personal_booking": "Persönliche Buchung",
    "service_booking": "Servicebuchung",
    "calendar_id": "Kalender-ID"
  },
  "validation_messages": {
    "calendar_group_name_required": "Der Name der Kalendergruppe ist erforderlich.",
    "calendar_group_description_required": "Die Beschreibung der Kalendergruppe ist erforderlich.",
    "slug_required": "Der Slug ist erforderlich.",
    "slug_not_valid": "Dieser Slug ist nicht gültig.",
    "slug_already_taken": "Dieser Slug ist bereits vergeben.",
    "error_validating_slug": "Fehler beim Validieren des Slugs.",
    "please_enter_name": "Bitte geben Sie einen Namen ein.",
    "room_name_required": "Der Raumname ist erforderlich",
    "equipment_name_required": "Der Gerätename ist erforderlich.",
    "subject_required": "Der Betreff ist erforderlich.",
    "this_is_required": "Dies ist erforderlich.",
    "calendar_group_slug_required": "Der Kalendergruppenslug ist erforderlich.",
    "capacity_mandatory": "Die Kapazität ist erforderlich.",
    "capacity_cannot_be_zero": "Die Kapazität darf nicht null sein.",
    "capacity_should_be_a_number": "Die Kapazität muss eine Zahl sein.",
    "capacity_cannot_be_negative": "Die Kapazität darf nicht negativ sein.",
    "capacity_should_be_a_whole_number": "Die Kapazität muss eine ganze Zahl sein.",
    "quantity_mandatory": "Die Angabe der Anzahl ist erforderlich",
    "quantity_cannot_be_zero": "Die Anzahl darf nicht null sein.",
    "quantity_should_be_a_number": "Die Anzahl muss eine Zahl sein.",
    "quantity_cannot_be_negative": "Die Anzahl darf nicht negativ sein.",
    "quantity_should_be_a_whole_number": "Die Anzahl muss eine ganze Zahl sein.",
    "quantity_cannot_be_less_than_out_of_service_equipments": "Die Anzahl darf nicht geringer sein als die Anzahl der außer Betrieb befindlichen Geräte.",
    "out_of_service_value_should_be_a_number": "Der Wert für „außer Betrieb“ muss eine Zahl sein.",
    "out_of_service_cannot_be_negative": "Der Wert für „außer Betrieb“ darf nicht negativ sein",
    "out_of_service_equipments_qty": "Die Anzahl der außer Betrieb befindlichen Geräte darf die tatsächliche Geräteanzahl nicht überschreiten.",
    "out_of_service_whole_number": "Der Wert für „außer Betrieb“ muss eine ganze Zahl sein.",
    "slot_duration_required": "Die Zeitfensterdauer ist erforderlich.",
    "slot_duration_integer": "Die Zeitfensterdauer muss eine ganze Zahl sein.",
    "meeting_duration_validation": "Die Besprechungsdauer muss zwischen 1 Minute und 12 Stunden liegen",
    "seats_class_required": "Die Anzahl der Plätze pro Klasse ist erforderlich.",
    "seats_class_integer": "Die Anzahl der Plätze pro Klasse muss eine ganze Zahl sein.",
    "seats_class_validation": "Diese darf nicht größer als 9999 oder kleiner als 0 sein.",
    "meeting_location_required": "Besprechungsort ist erforderlich.",
    "meeting_location_empty": "Bitte geben Sie einen Wert für alle Standortarten ein.",
    "meeting_location_duplicate": "Duplikatwerte für denselben Standorttyp sind nicht zulässig.",
    "meeting_location_booker_multiple": "„Bei Buchung fragen“ ist für mehrere Teammitglieder nicht erlaubt."
  },
  "custom_values": {
    "assigned_user": "Zugewiesener Benutzer",
    "full_name": "Vollständiger Name",
    "first_name": "Vorname",
    "last_name": "Nachname",
    "email": "E-Mail",
    "phone": "Telefon",
    "twilio_phone": "Twilio-Telefon",
    "account": "Konto",
    "name": "Name",
    "full_address": "Vollständige Anschrift",
    "city": "Stadt",
    "state": "Bundesland",
    "country": "Land",
    "postal_code": "Postleitzahl",
    "contact": "Kontakt",
    "address1": "Adresse 1",
    "timezone": "Zeitzone",
    "user": "Benutzer",
    "appointment": "Termin",
    "start_date_time": "Startdatum und Uhrzeit",
    "start_date": "Startdatum",
    "start_time": "Startzeit",
    "end_date_time": "Enddatum und -zeit",
    "end_date": "Enddatum",
    "end_time": "Endzeit",
    "meeting_location": "Standort des Meetings"
  },
  "meeting_location_types": {
    "zoom": "Zoom",
    "google_meet": "Google Meet",
    "phone": "Telefon",
    "full_address": "Vollständige Anschrift",
    "microsoft_teams": "Microsoft Teams",
    "custom": "Benutzerdefiniert"
  },
  "duration_units": {
    "minutes": "Minuten",
    "hours": "Stunden"
  },
  "widget_styles": {
    "classic": "Klassisch",
    "neo": "Neo"
  },
  "feature_labels": {
    "service_menu": "Servicemenü",
    "rooms": "Räume",
    "equipments": "Geräte"
  },
  "lsa": {
    "categories": {
      "accountant": "Buchhaltung",
      "acupuncturist": "Akupunktur",
      "air_duct_cleaner": "Luftkanalreinigung",
      "alcohol_treatment": "Dienste zur Behandlung von Alkoholismus",
      "animal_shelter": "Tierrettungsdienste",
      "appliance_repair": "Gerätereparatur",
      "architect": "Architektur",
      "assisted_living": "Dienste für betreutes Wohnen",
      "babysitter": "Babysitting",
      "bankruptcy_lawyer": "Insolvenzrecht",
      "beauty_school": "Kosmetikschule",
      "business_lawyer": "Unternehmensrecht",
      "car_repair": "Autoservices",
      "carpenter": "Zimmerei",
      "carpet_cleaning": "Teppichreinigung",
      "child_care": "Kinderbetreuungsdienste",
      "chiropractor": "Chiropraktische Dienstleistungen",
      "cleaning_service": "Hausreinigung",
      "contract_lawyer": "Vertragsrecht",
      "countertop_pro": "Arbeitsplattenservices",
      "criminal_lawyer": "Strafrecht",
      "dance_instructor": "Tanzunterricht",
      "disability_lawyer": "Behindertenrecht",
      "driving_instructor": "Fahranweisungen",
      "dui_lawyer": "DUI-Recht",
      "electrician": "Elektrisch",
      "energy_efficiency_pro": "Energieeffizienz-Dienstleistungen",
      "estate_lawyer": "Erbrecht",
      "event_planner": "Eventplanung",
      "family_lawyer": "Familienrecht",
      "fencing_pro": "Einzäunung",
      "financial_planner": "Finanzplanung",
      "first_aid_trainer": "Erste-Hilfe-Kurse",
      "flooring_pro": "Bodenbelag",
      "foundation_pro": "Grundlagen",
      "funeral_home": "Bestattungsdienste",
      "garage_door_pro": "Garagentor",
      "general_contractor": "Heimwerkerarbeiten",
      "handyman": "Handwerker",
      "home_inspector": "Hausinspektion",
      "home_security": "Sicherheitsdienste für Privathaushalte",
      "home_theater": "Heimkino-Dienste",
      "hvac": "Heizungs-, Lüftungs- und Klimatechnik",
      "immigration_lawyer": "Einwanderungsgesetz",
      "interior_designer": "Innenarchitektur",
      "ip_lawyer": "Geistiges Eigentumsrecht",
      "junk_removal": "Müllentsorgung",
      "labor_lawyer": "Arbeitsrecht",
      "landscaper": "Landschaftsgestaltung",
      "language_instructor": "Sprachunterricht",
      "lawn_care": "Rasenpflege",
      "litigation_lawyer": "Prozessrecht",
      "locksmith": "Schlüsseldienst",
      "malpractice_lawyer": "Berufshaftungsrecht",
      "massage_center": "Massagedienste",
      "massage_school": "Massageschule",
      "mover": "Verschieben",
      "nursing_home": "Pflegeheimdienst",
      "painter": "Malerei",
      "personal_injury_lawyer": "Personenschadensrecht",
      "personal_trainer": "Persönliches Training",
      "pest_control": "Schädlingsbekämpfung",
      "pet_adoption": "Adoptionsdienste für Haustiere",
      "pet_boarding": "Haustierpension",
      "pet_grooming": "Haustierpflege",
      "pet_trainer": "Haustiertraining",
      "photographer": "Fotografie",
      "plumber": "Sanitär",
      "pool_cleaner": "Poolreinigung",
      "pool_contractor": "Pool-Verträge",
      "preschool": "Vorschulbildung",
      "psychologist": "Psychologische Dienste",
      "real_estate_agent": "Immobilien",
      "real_estate_lawyer": "Immobilienrecht",
      "rehab": "Rehabilitationsdienste",
      "roofer": "Dachdeckerarbeiten",
      "sewage_pro": "Abwassersystemdienste",
      "siding_pro": "Verkleidung",
      "smart_home": "Smart Home-Dienste",
      "snow_removal": "Schneeräumungsdienste",
      "spa": "Spa-Dienstleistungen",
      "tax_lawyer": "Steuerrecht",
      "tax_specialist": "Steuerdienste",
      "therapist": "Therapie",
      "towing_pro": "Pannenhilfe",
      "traffic_lawyer": "Verkehrsrecht",
      "tree_service": "Baumpflege",
      "tutor": "Nachhilfeunterricht",
      "upholstery_cleaner": "Polsterreinigung",
      "veterinarian": "Tierärztliche Dienstleistungen",
      "videographer": "Videodienste",
      "water_damage": "Wasserschaden-Service",
      "weight_loss_service": "Dienstleistungen zur Gewichtsabnahme",
      "window_cleaner": "Fensterreinigung",
      "window_repair": "Fensterservices",
      "windshield_repair_pro": "Autoglas",
      "yoga_instructor": "Yoga"
    },
    "job_types": {
      "accountant_other": "Andere",
      "bankruptcy_tax_litigation": "Insolvenzsteuerstreitigkeiten",
      "bookkeeping": "Buchhaltung",
      "business_consulting": "Unternehmensberatung",
      "debt_collection_relief": "Schuldeneinziehungserleichterung",
      "irs_representation_resolution": "IRS-Vertretung und Streitbeilegung",
      "payroll": "Gehaltsabrechnung",
      "tax_planning_business": "Steuerplanungsgeschäft",
      "tax_planning_individual": "Steuerplanung Einzelperson",
      "tax_return_business": "Steuererstattungsunternehmen",
      "tax_return_individual": "Steuererstattung Einzelperson",
      "trusts_estates_accounting": "Rechnungswesen für Stiftungen und Nachlässe",
      "acupressure": "Akupressur",
      "acupuncture": "Akupunktur",
      "acupuncturist_other": "Andere",
      "cupping": "Schröpfen",
      "gua_sha": "Gua Sha",
      "heat_therapy": "Wärmetherapie",
      "herbal_therapy": "Kräutertherapie",
      "infrared_therapy": "Infrarot-Therapie",
      "moxibustion": "Moxibustion",
      "qigong": "Qigong",
      "shiatsu": "Shiatsu",
      "tui_na": "Tui Na",
      "air_duct_cleaning": "Luftkanalreinigung",
      "air_duct_filter_replacement": "Filterwechsel",
      "air_duct_other": "Andere",
      "dryer_vent_cleaning": "Reinigung der Trocknerentlüftung",
      "furnace_cleaning": "Ofenreinigung",
      "indoor_air_quality_testing": "Prüfung der Raumluftqualität",
      "alcohol_treatment_other": "Andere",
      "animal_shelter_cat_adoption": "Katzenadoption",
      "animal_shelter_dog_adoption": "Hundeadoption",
      "animal_shelter_other": "Andere",
      "animal_shelter_other_animal_adoption": "Andere Tieradoption",
      "animal_shelter_other_veterinary_services": "Andere tierärztliche Dienstleistungen",
      "animal_shelter_spay_neuter": "Kastrieren oder Sterilisieren",
      "animal_shelter_vaccinations": "Impfungen",
      "lost_stray_found_animals": "Verlorene, streunende oder gefundene Tiere",
      "pet_license": "Haustierlizenz",
      "pet_surrender": "Abgabe von Haustieren",
      "appliance_other": "Andere",
      "repair_dishwasher": "Geschirrspüler reparieren",
      "repair_dryer": "Trockner reparieren",
      "repair_freezer": "Gefrierschrank reparieren",
      "repair_microwave": "Mikrowelle reparieren",
      "repair_oven": "Ofen reparieren",
      "repair_refrigerator": "Reparatur Kühlschrank",
      "repair_refrigerator_freezer": "Reparatur Kühl-/Gefrierschrank",
      "repair_stove_cooktop": "Reparatur Herd/Kochfeld",
      "repair_stove_cooktop_oven": "Reparatur Herd/Kochfeld/Backofen",
      "repair_washer": "Reparatur Waschmaschine",
      "repair_washer_dryer": "Reparatur Waschmaschine/Trockner",
      "3d_architectural_rendering": "3D-Architekturvisualisierung",
      "adaptive_reuse_historical_renovation": "Adaptive Wiederverwendung & Historische Renovierung",
      "architect_other": "Andere",
      "architectural_designing": "Architekturdesign",
      "architectural_engineering": "Bauingenieurwesen",
      "building_code_analysis_permit_coordination": "Code-Analyse und Genehmigungen",
      "consulting": "Beratung",
      "home_building_improvement": "Hausbau und Renovierung",
      "interior_design_architect": "Innenarchitektur",
      "planning_zoning_approval_assistance": "Planungs- und Zonengenehmigung",
      "project_managing_architect": "Projektmanagement",
      "site_master_planning": "Standort-Masterplanung",
      "assisted_living_housekeeping_and_laundry": "Hauswirtschaft und Wäscheservice",
      "assisted_living_meal_services": "Verpflegungsdienste",
      "assisted_living_memory_care": "Gedächtnispflege",
      "assisted_living_other": "Andere",
      "assisted_living_rehabilitation_services": "Rehabilitationsdienste",
      "assisted_living_transportation": "Transport",
      "assisted_living_wellness_programs": "Wellness-Programme",
      "daily_living_assistance": "Hilfe im Alltag",
      "medication_management": "Medikamentenmanagement",
      "short_term_stays": "Kurzzeitaufenthalte",
      "social_and_recreational_activities": "Freizeitaktivitäten",
      "babysitter_other": "Andere",
      "event_babysitting": "Event-Babysitting",
      "homework_assistance": "Hausaufgabenhilfe",
      "housekeeping_laundry": "Hauswirtschaft und Wäscheservice",
      "meal_preparation": "Essenszubereitung",
      "nanny_services": "Kinderbetreuung",
      "overnight_babysitting": "Babysitting über Nacht",
      "pick_up_and_drop_off": "Abholung und Rückgabe",
      "shopping_errand": "Einkaufen und Besorgungen",
      "special_needs_care": "Betreuung für besondere Bedürfnisse",
      "virtual_babysitting": "Virtuelles Babysitting",
      "agriculture_bankruptcy": "Insolvenz in der Landwirtschaft",
      "bankruptcy_lawyer_other": "Andere",
      "bankruptcy_litigation": "Insolvenzstreitigkeiten",
      "chapter_11_bankruptcy": "Kapitel 11 Insolvenz",
      "chapter_13_bankruptcy": "Kapitel 13 Insolvenz",
      "chapter_7_bankruptcy": "Kapitel 7 Insolvenz",
      "corporate_bankruptcy": "Unternehmensinsolvenz",
      "creditor_harassment": "Belästigung durch Gläubiger",
      "debt_settlement": "Schuldenregulierung",
      "foreclosure_bankruptcy_lawyer": "Zwangsvollstreckung",
      "personal_bankruptcy": "Privatinsolvenz",
      "repossession": "Rücknahme",
      "wage_garnishment": "Lohnpfändung",
      "beauty_school_barbering": "Friseurhandwerk",
      "beauty_school_business_management": "Unternehmensführung",
      "beauty_school_cosmetology": "Kosmetologie",
      "beauty_school_esthetics": "Ästhetik",
      "beauty_school_hair_cutting": "Haarschneiden",
      "beauty_school_hair_design": "Haarstyling",
      "beauty_school_makeup": "Make-up",
      "beauty_school_massage_therapy": "Massagetherapie",
      "beauty_school_nail_technology": "Nageltechnik",
      "beauty_school_other": "Andere",
      "beauty_school_retail_training": "Einzelhandelskurse",
      "banking_finance_law": "Bankwesen & Finanzen",
      "business_lawyer_other": "Andere",
      "business_licenses_permits": "Unternehmenslizenzen und -genehmigungen",
      "business_litigation": "Wirtschaftsrechtliche Streitigkeiten",
      "business_taxes": "Unternehmenssteuern",
      "business_transactions_business_lawyer": "Unternehmensumsatz",
      "commercial_bankruptcy": "Gewerbliche Insolvenz",
      "commercial_contracts_business_lawyer": "Handelsverträge",
      "employment_law_business_lawyer": "Arbeitsrecht",
      "incorporation_restructuring": "Gründung und Umstrukturierung",
      "insurance_law": "Versicherungsrecht",
      "intellectual_property_law": "Geistiges Eigentumsrecht",
      "mergers_acquisitions_business_lawyer": "Fusionen und Übernahmen",
      "partnership_agreements_business_lawyer": "Partnerschaftsvereinbarungen",
      "patents_copyrights_trademarks": "Patente, Urheberrechte und Marken",
      "securities_law": "Wertpapierrecht",
      "shareholder_disputes": "Aktionärsstreitigkeiten",
      "air_and_cabin_filter": "Luft- und Kabinenfilter",
      "battery": "Batterie",
      "body_and_trim": "Karosserie und Verkleidung",
      "brakes": "Bremsen",
      "car_air_conditioning": "Klimaanlage",
      "car_electrical": "Elektrisch",
      "car_repair_other": "Andere",
      "check_engine_light_diagnostic": "Diagnose der Motorkontrollleuchte",
      "exhaust": "Auspuff",
      "oil_change": "Ölwechsel",
      "steering_suspension": "Lenkung / Federung",
      "tires": "Reifen",
      "transmission": "Getriebe",
      "cabinetry": "Schreinerei",
      "carpenter_other": "Andere",
      "decking": "Terrassendielen",
      "drywalling": "Trockenbau",
      "fencing": "Einzäunung",
      "general_installations": "Allgemeine Installationen",
      "general_repairs_maintenance": "Allgemein Service- und Wartungsarbeiten",
      "remodeling": "Renovierung",
      "shelving_storage": "Regale und Lagerung",
      "carpet_cleaning_other": "Andere",
      "clean_area_rugs": "Teppichreinigung",
      "clean_carpet": "Teppichreinigung",
      "clean_drapes_and_curtains": "Reinigung von Vorhängen und Gardinen",
      "clean_upholstery": "Polstermöbel reinigen",
      "remove_pet_stains_and_odors": "Entfernen von Flecken und Gerüchen von Haustieren",
      "after_school_care": "Nachmittagsbetreuung",
      "all_hours_daycare": "Rund-um-die-Uhr-Kindertagesstätte",
      "bilingual_daycare": "Zweisprachige Kindertagesstätte",
      "child_care_other": "Andere",
      "drop_in_daycare": "Kindertagesstätte",
      "full_time_daycare": "Ganztägige Kindertagesstätte",
      "in_home_daycare": "Tagesbetreuung im Haus",
      "infant_programs": "Programme für Säuglinge",
      "part_time_daycare": "Teilzeit-Kindertagesstätte",
      "pre_kindergarten_programs": "Vorschulprogramme",
      "preschool_programs": "Vorschulprogramme",
      "school_age_programs": "Programme für Schulkinder",
      "special_needs_daycare": "Kindertagesstätte für besondere Bedürfnisse",
      "summer_daycare": "Sommerbetreuung",
      "toddler_programs": "Programme für Kleinkinder",
      "weekend_daycare": "Wochenendbetreuung",
      "chiropractor_acupuncture": "Akupunktur",
      "chiropractor_chiropractic": "Chiropraktik",
      "chiropractor_massage_therapy": "Massagetherapie",
      "chiropractor_other": "Andere",
      "diagnosis": "Diagnose",
      "eastern_medicine": "Östliche Medizin",
      "exercise_counseling": "Trainingsberatung",
      "pain_management": "Schmerzmanagement",
      "physical_therapy": "Physiotherapie",
      "spinal_adjustments": "Wirbelsäulenanpassungen",
      "sports_medicine": "Sportmedizin",
      "cleaner_other": "Andere",
      "deep_clean": "Tiefenreinigung",
      "moving_clean": "Umzugsreinigung",
      "office_clean": "Büroreinigung",
      "standard_clean": "Normalreinigung",
      "assignment_of_contract": "Vertragsabtretung",
      "business_transactions_contract_lawyer": "Unternehmensumsatz",
      "commercial_contracts_contract_lawyer": "Handelsverträge",
      "contract_dispute": "Vertragskonflikt",
      "contract_lawyer_other": "Andere",
      "contract_negotiation": "Vertragsverhandlung",
      "contract_review": "Vertragsbewertung",
      "employment_contracts_contract_lawyer": "Arbeitsverträge",
      "franchise_agreements": "Franchiseverträge",
      "mergers_acquisitions_contract_lawyer": "Fusionen und Übernahmen",
      "non_disclosure_agreements_contract_lawyer": "Geheimhaltungsvereinbarungen",
      "partnership_agreements_contract_lawyer": "Partnerschaftsvereinbarungen",
      "power_of_attorney_contract_lawyer": "Vollmacht",
      "security_agreements": "Sicherheitsvereinbarungen",
      "warranties": "Garantien",
      "bathroom_countertops": "Arbeitsplatten für das Badezimmer",
      "bathroom_wall_panels": "Wandpaneele für das Badezimmer",
      "countertop_design": "Arbeitsplattendesign",
      "countertop_installation": "Arbeitsplatteninstallation",
      "countertop_pro_other": "Andere",
      "fireplace_facade": "Kaminfassade",
      "granite_countertops": "Granit-Arbeitsplatten",
      "kitchen_countertops": "Küchen-Arbeitsplatten",
      "kitchen_wall_panels": "Küchenwandpaneele",
      "laminate_countertops": "Laminat-Arbeitsplatten",
      "marble_countertops": "Marmor-Arbeitsplatten",
      "quartz_countertops": "Quarz-Arbeitsplatten",
      "remodeling_countertop_pro": "Renovierung",
      "repair_maintenance_countertop_pro": "Reparatur und Wartung",
      "stone_slab_countertops": "Arbeitsplatten aus Steinplatten",
      "tile_countertops": "Arbeitsplatten aus Fliesen",
      "corporate_representation": "Unternehmensvertretung",
      "criminal_immigration_defense": "Strafrechtliche Einwanderungsverteidigung",
      "criminal_lawyer_other": "Andere",
      "domestic_violence": "Häusliche Gewalt",
      "drug_possession": "Drogenbesitz",
      "duis_reckless_driving": "Fahren unter Einfluss von Alkohol oder Drogen und rücksichtsloses Autofahren",
      "expungement": "Löschung",
      "federal_crimes": "Bundeskriminalität",
      "felonies": "Schwere Verbrechen",
      "petty_crimes_misdemeanors": "Bagatelldelikte und Ordnungswidrigkeiten",
      "restraining_orders": "Einstweilige Verfügungen",
      "sex_offenses": "Sexualdelikte",
      "three_strikes_law": "Three-Strikes-Gesetz",
      "dance_instructor_african": "Afrikanisch",
      "dance_instructor_ballet": "Ballett",
      "dance_instructor_ballroom": "Ballsaal",
      "dance_instructor_belly": "Bauch",
      "dance_instructor_bollywood": "Bollywood",
      "dance_instructor_contemporary": "Zeitgenössisch",
      "dance_instructor_folk_traditional": "Folk und Traditionell",
      "dance_instructor_hip_hop": "Hip Hop",
      "dance_instructor_jazz": "Jazz",
      "dance_instructor_kids_classes": "Kinderkurse",
      "dance_instructor_latin": "Latein",
      "dance_instructor_modern": "Modern",
      "dance_instructor_other": "Andere",
      "dance_instructor_tap": "Tippen",
      "dance_instructor_wedding": "Hochzeit",
      "disability_hearings": "Anhörungen zu Erwerbsunfähigkeit",
      "disability_lawyer_other": "Andere",
      "long_term_disability": "Langfristige Erwerbsunfähigkeit",
      "short_term_disability": "Kurzfristige Erwerbsunfähigkeit",
      "social_security_disability_insurance": "Sozialversicherung für Erwerbsunfähigkeit",
      "ssa_claim_reconsideration": "Neubewertung des SSA-Anspruchs",
      "ssa_disability_appeals": "Berufungsverfahren bei der SSA bei Erwerbsunfähigkeit",
      "ssa_disability_applications": "Anträge auf Leistungen bei Erwerbsunfähigkeit bei der SSA",
      "ssa_disability_benefits": "SSA-Leistungen bei Erwerbsunfähigkeit",
      "ssa_family_benefits": "SSA-Familienleistungen",
      "ssa_impairment_listings": "SSA-Liste der Beeinträchtigungen",
      "supplemental_security_income": "Ergänzende Sicherheitsleistungen",
      "veterans_disability_benefits": "Leistungen bei Erwerbsunfähigkeit für Veteranen",
      "workers_compensation_disability_lawyer": "Arbeitnehmerentschädigung",
      "behind_the_wheel_lessons": "Fahrstunden",
      "commercial_license_training": "Kurse für gewerbliche Lizenzen",
      "defensive_driving_lessons": "Ausbildung zum Erwerb einer gewerblichen Fahrerlaubnis",
      "drivers_education_classes": "Fahrschulunterricht",
      "driving_instructor_other": "Andere",
      "manual_transmission_lessons": "Schaltgetriebe-Unterricht",
      "motorcycle_lessons": "Motorradunterricht",
      "traffic_school": "Verkehrsschule",
      "dui_dwi_dui_lawyer": "Fahren unter Einfluss psychoaktiver Substanzen (DUI/DWI)",
      "dui_injuries_dui_lawyer": "Fahren unter Alkoholeinfluss mit Verletzung",
      "dui_lawyer_other": "Andere",
      "dui_with_accident": "Fahren unter Alkoholeinfluss mit Unfall",
      "felony_dui": "Schweres Verbrechen unter Alkoholeinfluss",
      "invalid_tests": "Ungültige Tests",
      "multiple_offenses": "Mehrere Verstöße",
      "reckless_driving_dui_lawyer": "Rücksichtsloses Fahren",
      "underage_dui": "Fahren unter Alkoholeinfluss von Minderjährigen",
      "electric_car_charger": "Elektroauto-Ladegerät installieren",
      "electrician_other": "Andere",
      "electrician_remodeling": "Renovierung",
      "install_fan": "Lüfter installieren",
      "install_ground_wire": "Erdungskabel installieren",
      "install_light_fixtures": "Leuchten installieren",
      "install_outdoor_lighting": "Außenbeleuchtung installieren",
      "install_outlets_switches": "Steckdosen oder Schalter installieren",
      "install_security_system": "Sicherheitssystem installieren",
      "relocate_outlets_switches": "Steckdosen oder Schalter verlegen",
      "repair_fan": "Lüfter reparieren",
      "repair_light_fixtures": "Reparatur von Beleuchtungskörpern",
      "repair_outlets_switches": "Reparatur von Steckdosen oder Schaltern",
      "repair_panel": "Panel reparieren",
      "replace_upgrade_panel": "Panel ersetzen oder verbessern",
      "restore_power": "Stromversorgung wiederherstellen",
      "energy_efficiency_pro_other": "Andere",
      "charitable_giving": "Spenden für wohltätige Zwecke",
      "contests_litigation": "Wettbewerbe/Rechtsstreitigkeiten",
      "deeds": "Urkunden",
      "estate_lawyer_other": "Andere",
      "estate_planning_lawyer": "Nachlassplanung",
      "guardianship_estate_lawyer": "Vormundschaft",
      "medical_power_of_attorney": "Medizinische Vollmacht",
      "power_of_attorney_estate_lawyer": "Vollmacht",
      "probate_estate_lawyer": "Anwalt für Nachlassangelegenheiten",
      "trusts": "Vertrauensstellungen",
      "wills": "Testamente",
      "anniversary_planner": "Jubiläum",
      "baby_shower_planner": "Babyparty",
      "bar_and_bat_mitzvah_planner": "Bar und Bat Mitzvah",
      "birthday_party": "Geburtstagsparty",
      "children_party": "Kinderparty",
      "corporate_and_conference_planner": "Firmen und Kongresse",
      "event_planner_other": "Andere",
      "quinceanera_planner": "Quinceanera",
      "religious_event": "Religiöse Veranstaltung",
      "retirement_party": "Ruhestandsfeier",
      "school_event": "Schulveranstaltung",
      "theme_party": "Mottoparty",
      "wedding_and_engagement_planner": "Hochzeit und Verlobung",
      "adoption": "Adoption",
      "child_support": "Kindesunterhalt",
      "contested_divorce": "Streitige Scheidung",
      "debt_division": "Schuldenabteilung",
      "family_lawyer_other": "Andere",
      "guardianship_family_lawyer": "Vormundschaft",
      "mediation_family_lawyer": "Mediation",
      "modifications_of_orders": "Änderung von Bestellungen",
      "parent_timesharing": "Eltern-Timesharing",
      "paternity": "Vaterschaft",
      "prenuptial_postnuptial_agreements": "Ehevorbereitungen und Ehevereinbarungen",
      "probate_family_lawyer": "Nachlassverfahren",
      "property_divisions": "Vermögensaufteilung",
      "protective_orders_domestic_violence_issues": "Einstweilige Verfügungen",
      "spousal_support_alimony": "Ehegattenunterhalt & Alimente",
      "uncontested_divorce": "Einvernehmliche Scheidung",
      "custom_construction": "Sonderanfertigung",
      "fence_design": "Zaundesign",
      "fencing_other": "Andere",
      "installation_fencing_pro": "Zaunmontage",
      "repairs_maintenance_fencing_pro": "Reparaturen und Wartung",
      "education_savings": "Bildungsersparnisse",
      "estate_financial_planning": "Nachlassplanung",
      "financial_planning": "Finanzplanung",
      "financial_planning_other": "Andere",
      "home_purchase": "Hauskauf",
      "insurance": "Versicherung",
      "investment_advising": "Anlageberatung",
      "retirement_savings": "Ruhestand",
      "tax_planning": "Steuerplanung",
      "advanced_cardiac_life_support": "Erweiterte Herz-Lungen-Wiederbelebung",
      "aed_defibrillator": "AED - Defibrillator",
      "basic_life_support": "Grundlegende Wiederbelebung",
      "cpr": "CPR",
      "first_aid": "Erste Hilfe",
      "first_aid_trainer_other": "Andere",
      "pediatric_advanced_life_support": "Pädiatrische erweiterte Wiederbelebung",
      "pediatric_cpr_first_aid": "Kinder-CPR und Erste Hilfe",
      "pet_cpr_first_aid": "Erste Hilfe und Wiederbelebung für Haustiere",
      "wilderness_first_aid": "Erste Hilfe in der Wildnis",
      "baseboards": "Sockelleisten",
      "carpet": "Teppich",
      "flooring_other": "Andere",
      "hardwood": "Hartholz",
      "installation_flooring_pro": "Fußböden verlegen",
      "marble": "Marmor",
      "polishing": "Bodenpolitur",
      "refinishing": "Bodensanierung",
      "repair_maintenance_flooring_pro": "Bodenreparatur und -wartung",
      "stair_flooring": "Treppenbelag",
      "tile": "Fliese",
      "wood_floor_sanding": "Schleifen von Holzböden",
      "basement_waterproofing": "Kellerabdichtung",
      "crawl_spaces": "Kriechkellerfundament",
      "foundation_drainage": "Fundamentdrainage",
      "foundation_installation": "Fundamentinstallation",
      "foundation_pro_other": "Andere",
      "foundation_raising": "Fundamenterhöhung",
      "repairs_maintenance_foundation_pro": "Reparaturen und Wartung",
      "slab_foundation": "Plattenfundament",
      "steel_pier_pilings": "Stahlpfeilerpfähle",
      "water_moisture_control": "Wasser- und Feuchtigkeitskontrolle",
      "burials": "Bestattungen",
      "caskets": "Särge",
      "cremation": "Einäscherung",
      "funeral_home_flowers": "Blumen",
      "funeral_home_other": "Andere",
      "funeral_home_transportation_transfers": "Transport und Überstellungen",
      "funeral_home_veteran_services": "Veteranendienste",
      "funerals": "Beerdigungen",
      "gravestones": "Grabsteine",
      "grief_services": "Trauerdienste",
      "memorials": "Gedenkstätten",
      "urns": "Urnen",
      "garage_door_other": "Andere",
      "general_maintenance": "Allgemeine Wartung",
      "install_garage_door": "Garagentorinstallation",
      "install_opener": "Opener installieren",
      "repair_cables": "Kabel reparieren",
      "repair_garage_door": "Garagentor reparieren",
      "repair_gate": "Reperatur von Toren",
      "repair_rollers_tracks": "Reparatur von Rollen und Laufbahnen",
      "replace_door_panels": "Türverkleidungen ersetzen",
      "replace_opener": "Öffner ersetzen",
      "replace_springs": "Federn ersetzen",
      "accessory_buildings": "Nebengebäude",
      "bathroom_remodel": "Badezimmerrenovierung",
      "decks_patio": "Terrassen und Patios",
      "exterior_finishing": "Außenverkleidung",
      "foundations_concrete": "Fundamente und Beton",
      "general_contractor_commercial_projects": "Kommerzielle Projekte",
      "general_contractor_other": "Andere",
      "home_addition": "Hausanbau",
      "home_building": "Hausbau",
      "home_remodel_renovation": "Hausumbau und Renovierung",
      "interior_finishing": "Innenausbau",
      "kitchen_remodel": "Küchenrenovierung",
      "roofing": "Dachdeckerarbeiten",
      "assemble_furniture": "Möbel zusammenbauen",
      "clean_gutters": "Dachrinnen reinigen",
      "handyman_other": "Andere",
      "install_drywall": "Trockenbau",
      "install_flooring": "Bodenbelag verlegen",
      "install_tile": "Fliesenlegen",
      "install_water_fixtures": "Wasserarmaturen installieren",
      "mount_tv": "TV montieren",
      "paint_indoors": "Innenräume streichen",
      "paint_outdoors": "Außenbereiche streichen",
      "repair_drywall": "Trockenbau reparieren",
      "repair_flooring": "Bodenbelag reparieren",
      "repair_water_fixtures": "Wasserarmaturen reparieren",
      "replace_tile": "Fliese ersetzen",
      "buyer_seller_inspection": "Käufer-Verkäufer-Inspektion",
      "commercial_properties": "Gewerbeimmobilien",
      "fire_safety": "Brandschutz",
      "fireplace_chimney": "Kamin und Schornstein",
      "full_home_inspection": "Vollständige Hausinspektion",
      "home_inspector_electrical": "Elektrisch",
      "home_inspector_foundation": "Grundlage",
      "home_inspector_hvac": "Heizungs-, Lüftungs- und Klimatechnik",
      "home_inspector_mold": "Schimmel",
      "home_inspector_new_construction": "Neubau",
      "home_inspector_other": "Andere",
      "home_inspector_plumbing": "Sanitär",
      "home_inspector_roof": "Dach",
      "home_inspector_structural": "Strukturell",
      "home_warranty": "Hausgarantie",
      "water_testing": "Wassertests",
      "well_or_septic_system": "Brunnen oder Klärgrube",
      "wood_insects": "Holz und Insekten",
      "access_control": "Zugangskontrolle",
      "alarm_systems": "Alarmsysteme",
      "commercial_security_systems": "Kommerzielle Sicherheitssysteme",
      "fire_smoke_detection": "Brand- und Raucherkennung",
      "home_security_doors": "Türen",
      "home_security_locks": "Schlösser",
      "home_security_other": "Andere",
      "home_security_windows": "Fenster",
      "monitoring_services": "Überwachungsdienste",
      "residential_security_systems": "Sicherheitssysteme für Wohngebäude",
      "smart_home_integration": "Smart-Home-Integration",
      "video_surveillance": "Videoüberwachung",
      "audio_video_installation": "Audio-Video-Installation",
      "commercial_projects": "Kommerzielle Projekte",
      "home_theater_design": "Heimkino-Design",
      "home_theater_lighting": "Beleuchtung",
      "home_theater_other": "Andere",
      "home_theater_smart_home_integration": "Smart-Home-Integration",
      "install_tv": "TV installieren",
      "network_it_services": "Netzwerk- und IT-Dienstleistungen",
      "outdoor_installations": "Außeninstallationen",
      "soundproofing": "Schalldämmung",
      "whole_house_audio_video": "Audio-Video für das ganze Haus",
      "ac_maintenance": "AC-Wartung",
      "clean_ducts_vents": "Reinigung von Kanälen und Lüftungsöffnungen",
      "ductless_heating_and_ac_services": "Kanallose Heizungs- und Klimaanlagendienste",
      "heating_maintenance": "Heizungswartung",
      "hvac_maintenance": "HVAC-Wartung",
      "hvac_other": "Andere",
      "install_ac": "AC installieren",
      "install_ducts_vents": "Installieren von Kanälen und Lüftungsöffnungen",
      "install_heating_system": "Heizsystem installieren",
      "install_thermostat": "Thermostat installieren",
      "repair_ac": "AC reparieren",
      "repair_ducts_vents": "Reparatur von Kanälen und Lüftungsöffnungen",
      "repair_heating_system": "Heizsystem reparieren",
      "repair_hvac": "HVAC reparieren",
      "repair_thermostat": "Thermostat reparieren",
      "asylum": "Asyl",
      "citizenship": "Staatsbürgerschaft",
      "deportation": "Abschiebung",
      "family_based_immigration": "Familienbasierte Einwanderung",
      "green_card": "Green Card",
      "immigration_lawyer_other": "Andere",
      "investment_visa": "Investorenvisum",
      "outbound_work_permits": "Arbeitsgenehmigungen für Auslandsaufenthalte",
      "student_visa": "Studentenvisum",
      "visitor_visa": "Besuchervisum",
      "work_visa": "Arbeitsvisum",
      "appliance_selection": "Geräteauswahl",
      "cabinetry_molding_hardware_design": "Schrank- und Hardwaredesign",
      "decorating": "Dekorieren",
      "door_design": "Türdesign",
      "exterior_building_design": "Außengebäudedesign",
      "flooring_selection": "Auswahl der Bodenbeläge",
      "interior_designer_other": "Andere",
      "landscaping_design": "Landschaftsgestaltung",
      "lighting_design": "Beleuchtungsdesign",
      "multifamily_housing_design": "Mehrfamilienhaus-Design",
      "room_planning": "Raumplanung",
      "stone_brick_stucco_design": "Stein-, Ziegel- und Stuckdesign",
      "window_design": "Fensterdesign",
      "advertisements": "Anzeigen",
      "copyright": "Urheberrecht",
      "export_control": "Exportkontrolle",
      "franchises": "Franchise",
      "international_ip": "Internationale IP",
      "ip_lawyer_other": "Andere",
      "ip_strategy": "IP-Strategie",
      "ip_transactions": "IP-Transaktionen",
      "licensing": "Lizenzierung",
      "litigation_ip_lawyer": "Rechtsstreitigkeit",
      "non_disclosure_agreements_ip_lawyer": "Geheimhaltungsvereinbarungen",
      "patents": "Patente",
      "technology_transfer": "Technologietransfer",
      "trade_secrets": "Geschäftsgeheimnisse",
      "trademarks": "Markenzeichen",
      "appliance_removal": "Entfernen von Geräten",
      "construction_waste_removal": "Bauschuttentsorgung",
      "donation_pickup": "Spendenabholung",
      "electronic_waste_removal": "Entsorgung von Elektroschrott",
      "furniture_removal": "Möbelentsorgung",
      "general_junk_removal": "Allgemeine Müllentsorgung",
      "hazardous_waste_removal": "Entsorgung gefährlicher Abfälle",
      "house_garage_cleanout": "Haus-/Garagenreinigung",
      "junk_removal_other": "Andere",
      "yard_waste_removal": "Entsorgung von Gartenabfällen",
      "employment_contracts_labor_lawyer": "Arbeitsverträge",
      "employment_law_labor_lawyer": "Arbeitsrecht",
      "exempt_employee_status": "Status als freigestellter Arbeitnehmer",
      "labor_law": "Arbeitsrecht",
      "labor_lawyer_other": "Andere",
      "labor_negotiations": "Arbeitsverhandlungen",
      "privacy_rights": "Datenschutzrechte",
      "sexual_harassment": "Sexuelle Belästigung",
      "unpaid_overtime": "Unbezahlte Überstunden",
      "whistle_blowing": "Whistleblowing",
      "workers_compensation_labor_lawyer": "Arbeitnehmerentschädigung",
      "wrongful_termination": "Unrechtmäßige Kündigung",
      "artificial_turf_installation": "Kunstraseninstallation",
      "concrete_masonry": "Betonmauerwerk",
      "driveway_landscaping": "Einfahrtsgestaltung",
      "garden_decorations": "Gartendekorationen",
      "grading_resloping": "Planieren und Neuanlegen der Neigung",
      "hardscapes": "Hardscapes",
      "landscape_design": "Landschaftsdesign",
      "landscape_installations": "Landschaftsinstallationen",
      "landscaper_other": "Andere",
      "outdoor_steps": "Außentreppen",
      "outdoor_water_feature": "Wasserspiele im Freien",
      "paving_driveway_walkway": "Einfahrt- oder Gehwegpflasterung",
      "retaining_walls": "Stützmauern",
      "sidewalk_walkway_landscaping": "Gehweggestaltung",
      "sod_seeding": "Rollrasen und Aussaat",
      "stone_masonry": "Steinmetzarbeiten",
      "arabic": "Arabisch",
      "english": "English",
      "french": "French",
      "german": "German",
      "hebrew": "Hebräisch",
      "italian": "Italian",
      "japanese": "Japanisch",
      "korean": "Koreanisch",
      "language_instructor_other": "Andere",
      "mandarin": "Mandarin",
      "portuguese": "Portugiesisch",
      "russian": "Russisch",
      "sign_language": "Gebärdensprache",
      "spanish": "Spanish",
      "irrigation_system_repair_maintenance": "Reparatur/Wartung von Bewässerungssystemen",
      "lawn_care_other": "Andere",
      "lawn_mowing_maintenance": "Rasenmähen/-pflege",
      "lawn_pest_control": "Schädlingsbekämpfung im Rasen",
      "mulching": "Mulchen",
      "seeding": "Aussaat",
      "sod_installation": "Rollrasenverlegung",
      "weed_control": "Unkrautbekämpfung",
      "yard_cleanup": "Hofreinigung",
      "appeals": "Berufungen",
      "case_assessment_litigation_lawyer": "Fallbewertung",
      "civil_litigation": "Zivilprozess",
      "commercial_litigation": "Handelsstreitigkeiten",
      "contracts_and_agreements": "Verträge und Vereinbarungen",
      "criminal_litigation": "Strafrechtliche Verfahren",
      "litigation_lawyer_other": "Andere",
      "mediation_litigation_lawyer": "Mediation",
      "settlements": "Vergleiche",
      "building_lockout": "Gebäudesperre",
      "copy_building_key": "Gebäudeschlüssel kopieren",
      "copy_vehicle_key": "Fahrzeugschlüssel kopieren",
      "install_hardware": "Hardware installieren",
      "locksmith_other": "Andere",
      "new_key_fob": "Neuer Funkschlüssel",
      "rekey_lock": "Schloss neu codieren",
      "repair_hardware": "Hardware reparieren",
      "vehicle_lockout": "Fahrzeugsperre",
      "consent_issues": "Einwilligungsprobleme",
      "diagnosis_errors": "Diagnosefehler",
      "malpractice_lawyer_other": "Andere",
      "medical_negligence": "Ärztliche Fahrlässigkeit",
      "treatment_errors": "Behandlungsfehler",
      "massage_center_other": "Andere",
      "massage_school_advanced_neuromuscular_therapy": "Fortgeschrittene neuromuskuläre Therapie",
      "massage_school_business_and_ethics": "Wirtschaft und Ethik",
      "massage_school_clinical_therapies": "Klinische Therapien",
      "massage_school_continuing_education": "Weiterbildung",
      "massage_school_deep_tissue_massage": "Tiefengewebsmassage",
      "massage_school_energetics": "Energetik",
      "massage_school_hydrotherapy": "Hydrotherapie",
      "massage_school_lymphatic_massage": "Lymphdrainage",
      "massage_school_online_massage_therapy": "Online-Massagetherapie",
      "massage_school_other": "Andere",
      "massage_school_prenatal_massage": "Pränatale Massage",
      "massage_school_sports_massage": "Sportmassage",
      "massage_school_student_massage_clinic": "Studentische Massageklinik",
      "massage_school_swedish_massage": "Schwedische Massage",
      "massage_theory": "Massagetheorie",
      "massage_therapy_training": "Massagetherapie-Ausbildung",
      "in_state_move": "Umzug innerhalb des Bundeslandes",
      "local_move": "Lokaler Umzug",
      "mover_other": "Andere",
      "moving_junk_removal": "Müllentsorgung",
      "moving_storage": "Speicher",
      "out_of_state_move": "Umzug in ein anderes Bundesland",
      "oversized_item_move": "Transport übergroßer Gegenstände",
      "packing_unpacking": "Verpacken / Auspacken",
      "senior_move": "Seniorenumzug",
      "vehicle_transport": "Fahrzeugtransport",
      "cardiac_care": "Kardiologische Versorgung",
      "general_medical_care": "Allgemeine medizinische Versorgung",
      "hospice": "Hospiz",
      "iv_therapy": "Infusionstherapie",
      "nursing_home_meal_services": "Verpflegungsdienste",
      "nursing_home_memory_care": "Gedächtnispflege",
      "nursing_home_other": "Andere",
      "nursing_home_pain_management": "Schmerzmanagement",
      "nursing_home_rehabilitation_services": "Rehabilitationsdienste",
      "nursing_home_wellness_programs": "Wellness-Programme",
      "outpatient_rehabilitation": "Ambulante Rehabilitation",
      "post_hospital_care": "Pflege nach dem Krankenhausaufenthalt",
      "respiratory_and_pulmonary_care": "Atemwegs- und Lungenversorgung",
      "senior_activity_programs": "Aktivitätsprogramme für Senioren",
      "short_term_rehabilitation": "Kurzzeitrehabilitation",
      "wound_care": "Wundversorgung",
      "exterior_painting": "Außenanstrich",
      "interior_painting": "Innenanstrich",
      "paint_cabinets": "Schränke streichen",
      "paint_doors": "Türen streichen",
      "painter_other": "Andere",
      "repair_water_damage": "Wasserschaden reparieren",
      "staining": "Färbung",
      "assault_battery": "Körperverletzung und Tätlichkeit",
      "auto_accidents": "Autounfälle",
      "bicycle_accidents": "Fahrradunfälle",
      "catastrophic_injuries": "Katastrophale Verletzungen",
      "dog_bites": "Hundebisse",
      "dui_injuries_personal_injury_lawyer": "Verletzungen durch Trunkenheit am Steuer",
      "medical_malpractice": "Ärztlicher Kunstfehler",
      "motorcycle_accidents": "Motorradunfälle",
      "pain_suffering": "Schmerz und Leid",
      "pedestrian_accidents": "Fußgängerunfälle",
      "personal_injury_lawyer_other": "Andere",
      "product_liability": "Produkthaftung",
      "slip_fall": "Ausrutschen und Stürzen",
      "uninsured_motorist_claims": "Ansprüche aus der Kfz-Versicherung",
      "workers_compensation_personal_injury_lawyer": "Arbeitnehmerentschädigung",
      "wrongful_death": "Fahrlässiger Tod",
      "aerobics": "Aerobic",
      "athletic_performance": "Sportliche Leistung",
      "circuit_training": "Zirkeltraining",
      "endurance": "Ausdauer",
      "fitness_assessment": "Fitnesstest",
      "hiit": "HIIT",
      "nutritional_counseling": "Ernährungsberatung",
      "personal_trainer_other": "Andere",
      "strength_conditioning": "Kraft- und Konditionstraining",
      "weight_loss": "Gewichtsverlust",
      "yoga": "Yoga",
      "ants": "Ameisen",
      "bed_bugs": "Bettwanzen",
      "bees": "Bienen",
      "cockroaches": "Kakerlaken",
      "fleas_or_mites": "Flöhe oder Milben",
      "hornets_or_wasps": "Hornissen oder Wespen",
      "mosquitoes": "Mücken",
      "pest_control_other": "Andere",
      "pest_inspection": "Inspektion",
      "rodents": "Nagetiere",
      "spiders": "Spinnen",
      "termites": "Termiten",
      "wildlife": "Wildtiere",
      "pet_adoption_birds": "Vögel",
      "pet_adoption_cats": "Katzen",
      "pet_adoption_dogs": "Hunde",
      "pet_adoption_farm_animals": "Nutztiere",
      "pet_adoption_fish": "Fisch",
      "pet_adoption_other": "Andere",
      "pet_adoption_reptiles": "Reptilien",
      "pet_adoption_small_mammals": "Kleine Säugetiere",
      "pet_adoption_special_needs_animals": "Tiere mit besonderen Bedürfnissen",
      "cat_boarding": "Katzenpension",
      "cat_grooming": "Katzenpflege",
      "cat_sitting_in_home": "Katzenbetreuung (zu Hause)",
      "dog_boarding": "Hundepension",
      "dog_boarding_with_training": "Hundepension mit Training",
      "dog_daycare": "Hundetagesstätte",
      "dog_grooming": "Hundepflege",
      "dog_sitting_in_home": "Hundebetreuung (zu Hause)",
      "dog_training": "Hundetraining",
      "dog_walking": "Gassigehen",
      "other_pet_boarding": "Andere Haustierunterkünfte",
      "other_pet_daycare": "Andere Haustier-Tagesbetreuung",
      "other_pet_grooming": "Andere Haustierpflege",
      "other_pet_sitting_in_home": "Andere Haustierbetreuung (zu Hause)",
      "pet_boarding_other": "Andere",
      "cat_bathing": "Katzenbaden",
      "cat_ear_cleaning": "Katzenohrenreinigung",
      "cat_grooming_and_styling": "Katzenpflege und Styling",
      "cat_nail_trimming": "Katzennagelschneiden",
      "dog_anal_gland_expression": "Ausdruck der Analdrüsen bei Hunden",
      "dog_bathing_and_blow_dry": "Hundebaden und Föhnen",
      "dog_ear_cleaning": "Ohrenreinigung bei Hunden",
      "dog_flea_and_tick_treatment": "Floh- und Zeckenbehandlung bei Hunden",
      "dog_full_service_grooming": "Vollständige Hundepflege",
      "dog_grooming_and_styling": "Hundepflege und Styling",
      "dog_nail_trimming": "Krallenschneiden bei Hunden",
      "dog_teeth_brushing": "Zahnreinigung für Hunde",
      "pet_grooming_other": "Andere",
      "aggressive_dog_training": "Training für aggressive Hunde",
      "behavior_modification": "Verhaltensmodifikation",
      "obedience_training": "Gehorsamkeitstraining",
      "offleash_training": "Training ohne Leine",
      "pet_trainer_other": "Andere",
      "puppy_training": "Welpentraining",
      "service_animal_training": "Ausbildung von Servicetieren",
      "sport_trick_training": "Sport- oder Tricktraining",
      "training_other_animals": "Training für andere Tiere",
      "corporate_photo": "Unternehmen",
      "events_and_parties_photo": "Veranstaltungen und Partys",
      "family_and_group_photo": "Familie und Gruppe",
      "headshots_and_portraits": "Headshots und Porträts",
      "individual_photo": "Einzelperson",
      "maternity_and_newborn_photo": "Mutterschaft und Neugeborenes",
      "photographer_other": "Andere",
      "product_photo": "Produkt",
      "real_estate_photo": "Immobilien",
      "school_portraits": "Schulporträts",
      "wedding_and_engagement_photo": "Hochzeit und Verlobung",
      "find_leak": "Leck finden und reparieren",
      "install_faucet": "Wasserhahn installieren",
      "install_garbage_disposal": "Müllentsorgung installieren",
      "install_shower": "Dusche installieren",
      "install_toilet": "Toilette installieren",
      "install_water_heater": "Warmwasserbereiter installieren",
      "plumbing_other": "Andere",
      "repair_faucet": "Wasserhahn reparieren",
      "repair_garbage_disposal": "Müllentsorgung reparieren",
      "repair_outdoor_systems": "Außensysteme reparieren",
      "repair_pipe": "Rohr reparieren",
      "repair_sewer": "Abwasserkanal reparieren",
      "repair_shower": "Dusche reparieren",
      "repair_toilet": "Toilette reparieren",
      "repair_water_heater": "Warmwasserbereiter reparieren",
      "unclog_drain": "Abfluss freimachen",
      "commercial_pool_cleaning_maintenance": "Gewerbliche Poolreinigung und -wartung",
      "equipment_maintenance_repair": "Gerätewartung und -reparatur",
      "one_time_pool_cleaning": "Einmalige Pool-Reinigung",
      "ongoing_pool_cleaning": "Laufende Poolreinigung",
      "pool_cleaner_other": "Andere",
      "pool_cleaner_water_features": "Wassereigenschaften",
      "seasonal_opening_closing": "Saisonale Öffnung und Schließung",
      "spa_hot_tub_cleaning": "Reinigung von Spas und Whirlpools",
      "spa_hot_tub_repairs": "Reparaturen von Spas und Whirlpools",
      "tile_pool_wall_cleaning": "Reinigung von Fliesen und Poolwänden",
      "water_testing_balancing": "Wasserprüfung und -ausgleich",
      "jetted_lap_pools": "Jet-Sportbecken",
      "pool_construction": "Poolbau",
      "pool_contractor_commercial_projects": "Kommerzielle Projekte",
      "pool_contractor_custom_designs": "Benutzerdefinierte Designs",
      "pool_contractor_other": "Andere",
      "pool_contractor_renovation": "Renovierung",
      "pool_contractor_repair_cracks": "Risse reparieren",
      "pool_contractor_repair_tile": "Fliese reparieren",
      "pool_contractor_resurfacing": "Oberflächenerneuerung",
      "pool_contractor_water_features": "Wassereigenschaften",
      "pool_hot_tub_equipment": "Pool- und Whirlpool-Geräte",
      "spa_hot_tub_installation": "Installation von Spas und Whirlpools",
      "bilingual_programs": "Bilinguale Programme",
      "early_preschool": "Frühkindliche Vorschule",
      "full_day_preschool": "Ganztagsvorschule",
      "half_day_preschool": "Halbtagsvorschule",
      "kindergarten_classes": "Kindergartenkurse",
      "montessori_programs": "Montessori-Programme",
      "play_based_preschool": "Spielbasierte Vorschule",
      "preschool_infant_programs": "Programme für Säuglinge",
      "preschool_other": "Andere",
      "reggio_emilia_preschool": "Reggio Emilia Vorschule",
      "special_needs_programs": "Programme für besondere Bedürfnisse",
      "summer_camp": "Sommercamp",
      "waldorf_preschool": "Waldorf-Vorschule",
      "psychologist_other": "Andere",
      "buyer_agent": "Käufervertreter",
      "first_time_home_buyer": "Erstkäufer eines Eigenheims",
      "foreclosed_properties": "Zwangsvollstreckte Immobilien",
      "luxury_properties": "Luxusimmobilien",
      "new_construction": "Neubau",
      "property_management": "Immobilienverwaltung",
      "real_estate_agent_other": "Andere",
      "relocation": "Standortwechsel",
      "rentals": "Vermietungen",
      "sellers_agent": "Händlervertreter",
      "commercial_real_estate": "Gewerbeimmobilien",
      "easements": "Dienstbarkeiten",
      "encroachment": "Eingriff",
      "foreclosure_real_esate_lawyer": "Zwangsvollstreckung",
      "landlord_tenant_law": "Vermieter- und Mietrecht",
      "litigation_real_estate_lawyer": "Rechtsstreitigkeit",
      "mortgage_lending_law": "Hypotheken- und Kreditrecht",
      "neighbor_hoa_disputes": "Nachbarschafts- und HOA-Streitigkeiten",
      "property_damage": "Sachschäden",
      "purchase_agreements": "Kaufverträge",
      "real_estate_contracts_transactions": "Immobilientransaktionen",
      "real_estate_lawyer_other": "Andere",
      "residential_real_estate": "Wohnimmobilien",
      "title_services": "Titeldienste",
      "trespassing": "Hausfriedensbruch",
      "rehab_other": "Andere",
      "attic_venting": "Dachbodenbelüftung",
      "gutter_installation": "Dachrinnenmontage",
      "gutter_repair": "Dachrinnenreparatur",
      "roof_inspection": "Dachinspektion",
      "roof_installation": "Dachinstallation",
      "roof_repair": "Dachreparatur",
      "roofer_other": "Andere",
      "skylight_installation": "Dachfensterinstallation",
      "skylight_repair": "Dachfensterreparatur",
      "storm_wind_damage_roof_repair": "Reparatur von Dachschäden",
      "sewage_cleaning": "Reinigung",
      "sewage_excavation": "Ausgrabung",
      "sewage_inspection": "Inspektion",
      "sewage_installation": "Installation",
      "sewage_locating": "Lokalisierung",
      "sewage_maintenance_repairs": "Wartung und Reparaturen",
      "sewage_pro_other": "Andere",
      "sewage_pumping": "Pumpen",
      "sewage_removal_demolition": "Entfernung oder Abriss",
      "remodeling_siding_pro": "Renovierung",
      "repair_maintenance_siding_pro": "Reparatur und Wartung",
      "siding_installation": "Installation von Fassadenverkleidungen",
      "siding_pro_other": "Andere",
      "siding_removal": "Entfernung von Fassadenverkleidungen",
      "smart_home_other": "Andere",
      "commercial_snow_removal": "Gewerbliche Schneeräumung",
      "residential_plowing": "Schneeräumung für Wohngebiete",
      "residential_shoveling_blowing": "Wohnungsreinigung mit Schaufel und Blasgerät",
      "salt_sand_deicing": "Salz, Sand und Enteisung",
      "snow_relocation": "Schneeverlegung",
      "snow_removal_other": "Andere",
      "body_polish": "Körperpolitur",
      "body_wrap": "Körperpackung",
      "facial": "Gesichtsbehandlung",
      "hydrotherapy": "Hydrotherapie",
      "manicure": "Maniküre",
      "massage": "Massage",
      "pedicure": "Pediküre",
      "peels": "Peelings",
      "spa_other": "Andere",
      "spa_packages": "Spa-Pakete",
      "tanning": "Bräunung",
      "waxing": "Waxing",
      "civil_tax_litigation": "Zivilsteuerstreitigkeiten",
      "corporate_taxes": "Unternehmenssteuern",
      "criminal_tax_litigation": "Steuerstrafrechtliche Streitigkeiten",
      "estate_tax_planning": "Erbschaftssteuerplanung",
      "failure_to_file": "Fehler beim Einreichen",
      "innocent_spouse_relief": "Entlastung des unschuldigen Ehepartners",
      "international_tax_services": "Internationale Steuerdienste",
      "irs_tax_problems": "IRS Steuerprobleme",
      "non_collectible_status": "Nicht eintreibbarer Status",
      "offer_in_compromise": "Angebot im Vergleich",
      "tax_audits": "Steuerprüfungen",
      "tax_lawyer_other": "Andere",
      "tax_liens_levies": "Steuerpfandrechte und -abgaben",
      "tax_planning_lawyer": "Steuerplanung",
      "tax_relief": "Steuererleichterung",
      "accounting_support": "Unterstützung bei der Buchführung",
      "business_incorporation_restructuring": "Gründung und Umstrukturierung",
      "cryptocurrency_taxes": "Steuern auf Kryptowährungen",
      "irs_audit_representation": "Vertretung bei IRS-Prüfungen",
      "irs_filing": "IRS-Einreichung",
      "irs_problem_consulting": "IRS-Problemberatung",
      "new_business_services": "Neue Unternehmensdienste",
      "payroll_support": "Unterstützung bei der Gehaltsabrechnung",
      "tax_planning_tax_specialist": "Steuerplanung",
      "tax_preparation": "Steuervorbereitung",
      "tax_problem_consulting_tax_specialist": "Beratung bei Steuerproblemen",
      "tax_specialist_other": "Andere",
      "therapist_other": "Andere",
      "battery_service": "Batterieservice",
      "car_towing": "Abschleppdienst",
      "fuel_delivery": "Kraftstoffzufuhr",
      "local_hauling": "Lokaler Transport",
      "long_distance_hauling": "Lokale Beförderung",
      "motorcycle_towing": "Motorradabschleppdienst",
      "special_vehicle_towing": "Abschleppen von Spezialfahrzeugen",
      "tire_change": "Reifenwechsel",
      "towing_other": "Andere",
      "case_assessment_traffic_lawyer": "Fallbewertung",
      "cdl_traffic_ticket": "Verkehrsverstoß mit einem gewerblichen Führerschein",
      "dui_dwi_traffic_lawyer": "Fahren unter Alkoholeinfluss",
      "fixit_ticket": "Verwarnung mit Mängelbescheinigung",
      "parking_ticket": "Verwarnung wegen Falschparken",
      "reckless_driving_traffic_lawyer": "Rücksichtsloses Fahren",
      "red_light_ticket": "Verwarnung wegen Rotlichtverstoß",
      "speeding_ticket": "Verwarnung wegen Geschwindigkeitsverstoß",
      "suspended_license": "Führerscheinentzug",
      "traffic_lawyer_other": "Andere",
      "traffic_ticket": "Strafzettel",
      "cabling_and_bracing": "Verkabelung und Verstrebungen",
      "stump_removal": "Baumstumpfentfernung",
      "tree_planting": "Baumpflanzung",
      "tree_removal": "Baumentfernung",
      "tree_service_other": "Andere",
      "tree_transplanting": "Baumverpflanzung",
      "tree_trimming_and_pruning": "Beschneiden und Stutzen von Bäumen",
      "tutor_computer_science": "Informatik",
      "tutor_foreign_languages": "Fremdsprachen",
      "tutor_geography": "Geographie",
      "tutor_government_and_economics": "Regierung & Wirtschaft",
      "tutor_history": "Verlauf",
      "tutor_homework_help": "Hausaufgabenhilfe",
      "tutor_math": "Mathematik",
      "tutor_other": "Andere",
      "tutor_reading_and_writing": "Lesen und Schreiben",
      "tutor_science": "Wissenschaft",
      "tutor_special_education": "Sonderpädagogik",
      "tutor_test_pre_college_entrance": "Prüfungsvorbereitung: Hochschulzugang",
      "tutor_test_prep_grad_school_entrance": "Prüfungsvorbereitung: Zulassung zur Graduiertenschule",
      "tutor_test_prep_k8": "Prüfungsvorbereitung: K-8",
      "area_rug_cleaning": "Reinigung von Teppichböden",
      "drapery_and_blind_cleaning": "Vorhang- und Jalousienreinigung",
      "leather_cleaning": "Lederreinigung",
      "mattress_cleaning": "Matratzenreinigung",
      "upholstery_cleaner_other": "Andere",
      "upholstery_cleaning": "Polsterreinigung",
      "upholstery_water_damage_cleanup": "Wasserschadensbeseitigung",
      "bird_exotic_animal_care": "Pflege von Vögeln und exotischen Tieren",
      "farm_barn_animal_care": "Tierpflege auf dem Bauernhof und in Ställen",
      "microchipping": "Mikrochippen",
      "veterinarian_allergies": "Allergien",
      "veterinarian_behavior_counseling": "Verhaltensberatung",
      "veterinarian_dental_care": "Zahnpflege",
      "veterinarian_dermatology": "Dermatologie",
      "veterinarian_emergency_care": "Notfallversorgung",
      "veterinarian_end_of_life_care": "Palliativpflege",
      "veterinarian_examinations": "Untersuchungen",
      "veterinarian_nutrition_counseling": "Ernährungsberatung",
      "veterinarian_other": "Andere",
      "veterinarian_preventive_care": "Vorbeugende Pflege",
      "veterinarian_spay_neuter": "Kastration oder Sterilisation",
      "veterinarian_surgery": "Chirurgie",
      "veterinarian_vaccinations": "Impfungen",
      "aerial_videography": "Luftbild-Videografie",
      "documentary_video_production": "Produktion von Dokumentarfilmen",
      "family_video_production": "Familienvideoproduktion",
      "live_streaming": "Live-Streaming",
      "photography": "Fotografie",
      "product_demonstrations": "Produktdemonstration",
      "promotional_video_production": "Produktion von Werbevideos",
      "real_estate_video_production": "Produktion von Immobilienvideos",
      "special_event_video_production": "Produktion von Videos für spezielle Veranstaltungen",
      "video_editing": "Videobearbeitung",
      "videographer_other": "Andere",
      "voice_overs": "Voice-Over",
      "wedding_video_production": "Hochzeitsvideoproduktion",
      "fire_damage_cleanup_repair": "Beseitigung/Reparatur von Brandschäden",
      "water_damage_cleanup_repair": "Wasserschadensbeseitigung",
      "water_damage_flooring": "Bodenbelag",
      "water_damage_mold_inspection": "Schimmelinspektion",
      "water_damage_mold_removal": "Schimmelentfernung",
      "water_damage_other": "Andere",
      "water_damage_painting": "Malerei",
      "water_damage_pest_control": "Schädlingsbekämpfung",
      "water_damage_plumbing": "Sanitär",
      "water_damage_remodeling": "Umgestaltung",
      "water_damage_roofing": "Dachdeckerarbeiten",
      "water_damage_sewage_cleanup": "Abwasserreinigung",
      "adult_weight_loss_programs": "Programme zur Gewichtsreduktion für Erwachsene",
      "diet_and_nutrition_counseling": "Diät- und Ernährungsberatung",
      "kids_weight_loss_programs": "Programme zur Gewichtsreduktion für Kinder",
      "metabolic_testing": "Stoffwechseltests",
      "weight_loss_consultation_and_training": "Beratung und Schulung",
      "weight_loss_fitness_programs": "Fitnessprogramme",
      "weight_loss_meal_planning": "Essensplanung",
      "weight_loss_personal_training": "Persönliches Training",
      "weight_loss_service_other": "Andere",
      "weight_loss_wellness_programs": "Wellness-Programme",
      "glass_and_mirror_cleaning": "Glas- und Spiegelreinigung",
      "gutter_cleaning": "Dachrinnenreinigung",
      "power_pressure_washing": "Kraft-/Hochdruckreinigung",
      "rooftop_skylight_cleaning": "Reinigung von Dächern/Oberlichtern",
      "window_cleaner_other": "Andere",
      "window_cleaning": "Fensterreinigung",
      "door_installation": "Türmontage",
      "door_repair": "Türreparatur",
      "glass_installation": "Glasinstallation",
      "window_boardup": "Boardup",
      "window_installation": "Fenstermontage",
      "window_repair": "Fensterreparatur",
      "window_repair_other": "Andere",
      "install_new_wiper_blades": "Neue Wischerblätter installieren",
      "repair_power_window": "Fensterheber reparieren",
      "repair_water_leak": "Wasserleck reparieren",
      "repair_windshield": "Windschutzscheibe reparieren",
      "replace_rear_window": "Heckscheibe ersetzen",
      "replace_side_view_mirrors": "Seitenspiegel reparieren",
      "replace_side_window": "Seitenfenster ersetzen",
      "replace_sunroof": "Schiebedachglas ersetzen",
      "replace_windshield": "Windschutzscheibe ersetzen",
      "windshield_other": "Andere",
      "ashtanga": "Ashtanga",
      "hatha": "Hatha",
      "hot_yoga": "Hot Yoga",
      "iyengar": "Iyengar",
      "kundalini": "Kundalini",
      "meditation": "Meditation",
      "power_yoga": "Power Yoga",
      "restorative": "Restaurativ",
      "vinyasa": "Vinyasa",
      "yin": "Yin",
      "yoga_instructor_other": "Andere"
    }
  }
}
